webpackJsonp([6],{

/***/ 166:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by cedricgodefroy on 17/08/2017.
 */
angular.module('FlexyBeautyApp.services').factory('TypeOfSale', ['gettextCatalog', function (gettextCatalog) {

    var prestations = gettextCatalog.getString("Prestations"),
        produits = gettextCatalog.getString("Produits"),
        cures = gettextCatalog.getString("Cures"),
        loyalties = gettextCatalog.getString("Cartes de fidélité"),
        transformedBooking = gettextCatalog.getString("Réservation transformée"),
        unTransformedBooking = gettextCatalog.getString("Réservation non transformée"),
        all = gettextCatalog.getString("Tous");

    var typeOfSale = {
        SERVICE: { id: 'SERVICE', label: prestations },
        PRODUCT: { id: 'PRODUCT', label: produits },
        CURE: { id: 'CURE', label: cures },
        LOYALTY: { id: 'LOYALTY', label: loyalties },
        SERVICE_AND_PRODUCT: { id: 'SERVICE_AND_PRODUCT', label: transformedBooking },
        SERVICE_WITHOUT_PRODUCT: { id: 'SERVICE_WITHOUT_PRODUCT', label: unTransformedBooking }
    };
    typeOfSale.ALL = {
        id: 'ALL',
        label: all,
        getSubStatCategories: function getSubStatCategories(rootCategory) {
            return [typeOfSale.SERVICE, typeOfSale.PRODUCT, typeOfSale.CURE, typeOfSale.LOYALTY];
        }
    };
    typeOfSale.ALL_WITH_PRODUCT_OR_NOT = {
        id: 'ALL_WITH_PRODUCT_OR_NOT',
        label: all,
        getSubStatCategories: function getSubStatCategories(rootCategory) {
            return [typeOfSale.SERVICE_AND_PRODUCT /*, typeOfSale.SERVICE_WITHOUT_PRODUCT*/];
        }
    };
    typeOfSale.values = function () {
        return [this.SERVICE, this.PRODUCT, this.CURE, this.LOYALTY];
    };

    return typeOfSale;
}]).factory('TypeOfGraph', ["$filter", 'gettextCatalog', function ($filter, gettextCatalog) {
    var tableau = gettextCatalog.getString("Tableau"),
        circulaire = gettextCatalog.getString("Diagramme circulaire"),
        colonne = gettextCatalog.getString("Diagramme en colonne"),
        colonnesempilees = gettextCatalog.getString("Diagramme en colonnes empilées"),
        batons = gettextCatalog.getString("Diagramme en batons"),
        batonsEmpiles = gettextCatalog.getString("Diagramme en batons empilés");
    var representations = {
        TABLE: { id: 'table', label: tableau, icon: 'fa-table' },
        PIECHART: { id: 'pie-chart', label: circulaire, icon: 'fa-pie-chart' },
        COLUMNCHART: { id: 'column-chart', label: colonne, icon: 'fa-bar-chart' },
        STACKEDCOLUMNCHART: { id: 'stacked-column-chart', label: colonnesempilees, icon: 'fa-bar-chart' },
        BARCHART: { id: 'bar-chart', label: batons, icon: 'fa-bar-chart' },
        STACKEDBARCHART: { id: 'stacked-bar-chart', label: batonsEmpiles, icon: 'fa-bar-chart' }
    };
    representations.getAll = function () {
        return [this.TABLE, this.PIECHART, this.COLUMNCHART, this.STACKEDCOLUMNCHART, this.BARCHART, this.STACKEDBARCHART];
    };
    representations.getStacked = function () {
        return [this.TABLE, this.STACKEDCOLUMNCHART, this.STACKEDBARCHART];
    };
    representations.getTypeGraphById = function (id) {
        return $filter('filter')(this.getAll(), function (elt) {
            return elt.id === id;
        })[0];
    };
    return representations;
}]).factory('EltReportType', ["$filter", function ($filter) {
    var eltReportType = {
        TOTALISE: { id: 'TOTALISE' },
        COMPARE: { id: 'COMPARE' },
        ZOOM: { id: 'ZOOM' }
    };
    eltReportType.getAll = function () {
        return [this.TOTALISE, this.COMPARE, this.ZOOM];
    };
    eltReportType.getEltReportTypeById = function (id) {
        return $filter('filter')(this.getAll(), function (elt) {
            return elt.id === id;
        })[0];
    };
    return eltReportType;
}]).factory('ReportTotalAgregateFunctionType', [function () {
    var reportTotalAgregateFunctionType = {
        SUM_CATEGORIES: { id: 'SUM_CATEGORIES' },
        AVERAGE_CATEGORIES: { id: 'AVERAGE_CATEGORIES' },
        NO_AGREGATION: { id: 'NO_AGREGATION' }
    };

    return reportTotalAgregateFunctionType;
}]).factory('ReportTemporalAgregateFunctionType', [function () {
    var reportTemporalAgregateFunctionType = {
        DAILY_SUM: { id: 'DAILY_SUM' },
        DAILY_AVERAGE: { id: 'DAILY_AVERAGE' }
    };

    return reportTemporalAgregateFunctionType;
}]).factory('DataType', [function () {
    var dataType = {
        NB: { id: 'NB' },
        VALUE: { id: 'VALUE' }
    };
    return dataType;
}]).factory('ColorGraph', [function () {
    var colorGraph = {
        colors: ['#bfe9ff', '#e5d1ff', '#b4ffc7', '#f6f460', '#ffe0f0', '#ffd6a6', '#ffcac7', '#ddd3ff', '#7cd9ff', '#c5ff6c']
    };
    return colorGraph;
}]).factory('PrimaryDatasType', ["SaleService", "Sale", "SaleProduct", "SaleCure", "LoyaltyCardItem", "Booking", "GiftItem", "Customer", "BookingService", "HrOccupationDatas", function (SaleService, Sale, SaleProduct, SaleCure, LoyaltyCardItem, Booking, GiftItem, Customer, BookingService, HrOccupationDatas) {
    var primaryDatasType = {
        SALESERVICE: { id: 'SALESERVICE', fileLabel: 'ventes-prestatiions' },
        SALEPRODUCT: { id: 'SALEPRODUCT', fileLabel: 'ventes-produits' },
        SALECURE: { id: 'SALECURE', fileLabel: 'ventes-cures' },
        LOYALTYCARDITEM: { id: 'LOYALTYCARDITEM', fileLabel: 'ventes-cartes-fidelite' },
        SALE: { id: 'SALE', fileLabel: 'ventes' },
        BOOKING: { id: 'BOOKING', fileLabel: 'reservations' },
        GIFTITEM: { id: 'GIFTITEM', fileLabel: 'cheques-cadeaux' },
        CUSTOMER: { id: 'CUSTOMER', fileLabel: 'clients' },
        BOOKINGSERVICE: { id: 'BOOKINGSERVICE', fileLabel: 'reservations-prestations' },
        HROCCUPATIONDATAS: { id: 'HROCCUPATIONDATAS', fileLabel: 'occupation-personnel' },
        VISITE: { id: 'VISITE', fieldLabel: 'visites' }
    };
    primaryDatasType.getType = function (objectModel) {
        if (!objectModel) return null;

        if (objectModel instanceof SaleService) {
            return this.SALESERVICE;
        } else if (objectModel instanceof SaleProduct) {
            return this.SALEPRODUCT;
        } else if (objectModel instanceof SaleCure) {
            return this.SALECURE;
        } else if (objectModel instanceof LoyaltyCardItem) {
            return this.LOYALTYCARDITEM;
        } else if (objectModel instanceof Sale) {
            return this.SALE;
        } else if (objectModel instanceof Booking) {
            return this.BOOKING;
        } else if (objectModel instanceof GiftItem) {
            return this.GIFTITEM;
        } else if (objectModel instanceof Customer) {
            return this.CUSTOMER;
        } else if (objectModel instanceof BookingService) {
            return this.BOOKINGSERVICE;
        } else if (objectModel instanceof HrOccupationDatas) {
            return this.HROCCUPATIONDATAS;
        } else if (objectModel && objectModel.dataType && objectModel.dataType == "VISITE") {
            return this.VISITE;
        }
    };

    return primaryDatasType;
}]).factory('RootStatCategorie', ["CategoryData", "ProductCategoryData", "CureCategoryData", "LoyaltyCardCategoryData", function (CategoryData, ProductCategoryData, CureCategoryData, LoyaltyCardCategoryData) {
    var rootStatCategorie = function rootStatCategorie() {
        this.id = "superCategory", this.label = "superCategory", this.getSubStatCategories = function (rootCategory) {
            return [CategoryData.categoryRoot, ProductCategoryData.categoryRoot, CureCategoryData.categoryRoot, LoyaltyCardCategoryData.categoryRoot];
        };
    };
    return new rootStatCategorie();
}]).factory('ProductStatCategorie', ["gettextCatalog", "ProductCategoryData", function (gettextCatalog, ProductCategoryData) {
    var productStatCategorie = {
        ALL: {
            id: 'PRODUCTS',
            label: "PRODUCTS",
            getSubStatCategories: function getSubStatCategories(rootCategory) {
                return [ProductCategoryData.categoryRoot];
            }
        }
    };

    return productStatCategorie;
}]).factory('HrRootOccupationRateCategory', ['HumanResourceData', function (HumanResourceData) {
    var rootStatCategorie = {
        id: "HrRootOccupationRateCategory",
        label: "HrRootOccupationRateCategory",
        getSubStatCategories: function getSubStatCategories(rootCategory, periodDays) {
            var humanResourceList = HumanResourceData.getActiveList(),
                humanResourceFinalList = humanResourceList;

            if (periodDays) {
                humanResourceFinalList = new Array();
                for (var i = 0; i < humanResourceList.length; i++) {
                    if (humanResourceList[i].statFilter(periodDays)) {
                        humanResourceFinalList.push(humanResourceList[i]);
                    }
                }
            }
            return humanResourceFinalList;
        }
    };
    return rootStatCategorie;
}]).factory('PrRootOccupationRateCategory', ['PhysicalResourceData', function (PhysicalResourceData) {
    var rootStatCategorie = {
        id: "PrRootOccupationRateCategory",
        label: "PrRootOccupationRateCategory",
        getSubStatCategories: function getSubStatCategories(rootCategory) {
            return PhysicalResourceData.getActiveList();
        }
    };
    return rootStatCategorie;
}]).factory('PeriodType', ["$filter", "gettextCatalog", function ($filter, gettextCatalog) {
    var dayly = gettextCatalog.getString("Période quotidienne"),
        weekly = gettextCatalog.getString("Période hebdomadaire"),
        monthly = gettextCatalog.getString("Période mensuelle"),
        yearly = gettextCatalog.getString("Période annuelle"),
        defined = gettextCatalog.getString("Période définie");

    var periodType = {
        DAY: { id: 'DAY', label: 'jour', selecLabel: dayly },
        WEEK: { id: 'WEEK', label: 'semaine', selecLabel: weekly },
        MONTH: { id: 'MONTH', label: 'mois', selecLabel: monthly },
        YEAR: { id: 'YEAR', label: 'annuel', selecLabel: yearly },
        CUSTOMED: { id: 'CUSTOMED', label: 'customed', selecLabel: defined }
    };
    periodType.getAll = function () {
        var tabPeriodType = new Array();
        for (var i in periodType) {
            if (periodType.hasOwnProperty(i)) {
                tabPeriodType.push(periodType[i]);
            }
        }
        return tabPeriodType;
    };
    periodType.getPeriodTypeByLabel = function (label) {
        return $filter('filter')(this.getAll(), function (elt) {
            return elt.label === label;
        })[0];
    };

    periodType.getLastDayOfPeriod = function (periodTypeObject, beginDayOfPeriod, nbDay) {
        var currentMomentDay = beginDayOfPeriod.clone(),
            endMomentDay = null;

        if (periodTypeObject === this.DAY) {
            endMomentDay = currentMomentDay.clone().add(1, 'day');
        } else if (periodTypeObject === this.WEEK) {
            endMomentDay = currentMomentDay.clone().add(1, 'week');
        } else if (periodTypeObject === this.MONTH) {
            endMomentDay = currentMomentDay.clone().add(1, 'month');
        } else if (periodTypeObject === this.YEAR) {
            endMomentDay = currentMomentDay.clone().add(1, 'year');
        } else if (periodTypeObject === this.CUSTOMED) {
            endMomentDay = currentMomentDay.clone().add(nbDay, 'day');
        }
        endMomentDay.add(-1, 'day');

        return endMomentDay;
    };

    return periodType;
}]).factory('SchedulerType', ["$filter", "gettextCatalog", function ($filter, gettextCatalog) {
    var single = gettextCatalog.getString("Manuel"),
        dayly = gettextCatalog.getString("Journalier"),
        weekly = gettextCatalog.getString("Hebdomadaire"),
        monthly = gettextCatalog.getString("Mensuel"),
        yearly = gettextCatalog.getString("Annuel");

    var schedulerType = {
        SINGLE: { id: 'single', label: single },
        DAILY: { id: 'daily', label: dayly },
        WEEKLY: { id: 'weekly', label: weekly },
        MONTHLY: { id: 'monthly', label: monthly },
        YEARLY: { id: 'yearly', label: yearly }
    };
    schedulerType.getAll = function () {
        var tabShedulerType = new Array();
        for (var i in schedulerType) {
            if (schedulerType.hasOwnProperty(i)) {
                tabShedulerType.push(schedulerType[i]);
            }
        }
        return tabShedulerType;
    };
    schedulerType.getSchedulerTypeByLabel = function (label) {
        return $filter('filter')(this.getAll(), function (elt) {
            return elt.label === label;
        })[0];
    };

    schedulerType.getSchedulerTypeById = function (id) {
        return $filter('filter')(this.getAll(), function (elt) {
            return elt.id === id;
        })[0];
    };

    return schedulerType;
}]).factory('StatPeriodType', ["$filter", "gettextCatalog", function ($filter, gettextCatalog) {
    var present = gettextCatalog.getString("present"),
        passed = gettextCatalog.getString("passée");

    var statPeriodType = {
        CURRENT: { id: 'CURRENT', label: present },
        PAST: { id: 'PAST', label: passed }
    };
    statPeriodType.getAll = function () {
        var tabStatPeriodType = new Array();
        for (var i in statPeriodType) {
            if (statPeriodType.hasOwnProperty(i)) {
                tabStatPeriodType.push(statPeriodType[i]);
            }
        }
        return tabStatPeriodType;
    };
    statPeriodType.getPeriodTypeByLabel = function (label) {
        return $filter('filter')(this.getAll(), function (elt) {
            return elt.label === label;
        })[0];
    };
    return statPeriodType;
}]).factory('LoyaltyCustomers', ['HumanResourceData', "gettextCatalog", function (HumanResourceData, gettextCatalog) {
    var customersLabel = gettextCatalog.getString("Clients venus plusieurs fois"),
        newCustomersLabel = gettextCatalog.getString("Clients venus une seule fois");
    var LoyaltyCustomers = {
        id: "LoyaltyCustomers",
        label: "LoyaltyCustomers",
        noTitle: true,
        getSubStatCategories: function getSubStatCategories(rootCategory) {
            return HumanResourceData.getActiveList();
        }
    };
    return LoyaltyCustomers;
}]).factory('HumanResourceExtra', ['CategoryData', 'ProductCategoryData', 'CureCategoryData', 'LoyaltyCardCategoryData', function (CategoryData, ProductCategoryData, CureCategoryData, LoyaltyCardCategoryData) {
    var HumanResourceExtra = {
        label: "Autre",
        getSubStatCategories: function getSubStatCategories(rootCategory) {
            var subCategories = [CategoryData.categoryRoot, ProductCategoryData.categoryRoot, CureCategoryData.categoryRoot, LoyaltyCardCategoryData.categoryRoot];
            return subCategories;
        }
    };
    return HumanResourceExtra;
}]).factory('HrRootCategory', ['HumanResourceData', 'HumanResourceExtra', function (HumanResourceData, HumanResourceExtra) {
    var rootStatCategorie = {
        id: "hrRootCategory",
        label: "hrRootCategory",
        getSubStatCategories: function getSubStatCategories(rootCategory) {
            return HumanResourceData.getActiveList().concat([HumanResourceExtra]);
        }
    };
    return rootStatCategorie;
}]).factory('GiftItemRootCategory', ["TypeOfBooking", "gettextCatalog", function (TypeOfBooking, gettextCatalog) {
    var serviceLabel = gettextCatalog.getString("En prestation"),
        amountLabel = gettextCatalog.getString("En montant");
    var giftItemRootCategory = {
        id: "giftItemRootCategory",
        label: "giftItemRootCategory",
        subCategories: {
            SERVICE: {
                id: "giftItemServiceCategory",
                label: serviceLabel,
                getSubStatCategories: function getSubStatCategories(rootCategory) {
                    return [TypeOfBooking.CREATE_BY_CUSTORMER, TypeOfBooking.NOT_CREATE_BY_CUSTOMER];
                }
            },
            PRICE: {
                id: "giftItemPriceCategory",
                label: amountLabel,
                getSubStatCategories: function getSubStatCategories(rootCategory) {
                    return [TypeOfBooking.CREATE_BY_CUSTORMER, TypeOfBooking.NOT_CREATE_BY_CUSTOMER];
                }
            }
        },
        getSubStatCategories: function getSubStatCategories(rootCategory) {
            return [this.subCategories.SERVICE, this.subCategories.PRICE];
        }
    };

    return giftItemRootCategory;
}]).factory('GiftItemByHrRootCategory', ["HumanResourceData", function (HumanResourceData) {
    var giftItemByHrRootCategory = {
        id: "giftItemByHrRootCategory",
        label: "giftItemByHrRootCategory",
        getSubStatCategories: function getSubStatCategories(rootCategory) {
            return HumanResourceData.getActiveList();
        }
    };
    return giftItemByHrRootCategory;
}]).factory('NbCustormerCategoryStat', ["gettextCatalog", function (gettextCatalog) {
    var mens = gettextCatalog.getString("Hommes"),
        womens = gettextCatalog.getString("Femmes"),
        children = gettextCatalog.getString("Enfants"),
        unknow = gettextCatalog.getString("Non précisé"),
        walkin = gettextCatalog.getString("Clients de passage");
    var nbCustormercategoryStat = {
        id: "NbCustormerCategoryStat",
        label: "NbCustormerCategoryStat",
        subCategories: {
            MEN_VISITS: { id: 'MEN_VISITS', label: mens },
            WOMEN_VISITS: { id: 'WOMEN_VISITS', label: womens },
            CHILDREN_VISITS: { id: 'CHILDREN_VISITS', label: children },
            UNDEFINED_VISITS: { id: 'UNDEFINED_VISITS', label: unknow },
            PASSENGER_VISITS: { id: 'PASSENGER_VISITS', label: walkin }
        },
        getSubStatCategories: function getSubStatCategories(rootCategory) {
            return [this.subCategories.MEN_VISITS, this.subCategories.WOMEN_VISITS, this.subCategories.CHILDREN_VISITS, this.subCategories.UNDEFINED_VISITS, this.subCategories.PASSENGER_VISITS];
        }
    };
    return nbCustormercategoryStat;
}]).factory('TypeOfBooking', ['TypeOfCustomer', 'gettextCatalog', 'Brand', function (TypeOfCustomer, gettextCatalog, Brand) {
    var come = gettextCatalog.getString("Venus"),
        notCome = gettextCatalog.getString("Pas venus"),
        bookedInline = gettextCatalog.getString("Réservé en ligne"),
        bookedOnSite = gettextCatalog.getString("Réservé sur site"),
        comeNotCome = gettextCatalog.getString("Venus/Pas venu"),
        inlineOnSite = gettextCatalog.getString("Réservé en ligne/sur site"),
        createByRGW = gettextCatalog.getString("Réservé depuis Google"),
        createByWebSite = gettextCatalog.getString("Réservé depuis {{brandLabel}}", { brandLabel: Brand.label });

    var typeOfBooking = {
        COME: { id: 'COME', label: come },
        NOT_COME: { id: 'NOT_COME', label: notCome },
        CREATE_BY_CUSTORMER: { id: 'CREATE_BY_CUSTORMER', label: bookedInline },
        NOT_CREATE_BY_CUSTOMER: { id: 'NOT_CREATE_BY_CUSTOMER', label: bookedOnSite },
        COME_AND_NOT_COME: { id: 'COME_AND_NOT_COME', label: comeNotCome },
        CREATE_BY_CUSTORMER_AND_NOT: { id: 'CREATE_BY_CUSTORMER_AND_NOT', label: inlineOnSite },
        CREATE_BY_RWG: { id: 'CREATE_BY_RWG', label: createByRGW },
        CREATE_BY_WEBSITE: { id: 'CREATE_BY_WEBSITE', label: createByWebSite }
    };
    typeOfBooking.COME_AND_NOT_COME.getSubStatCategories = function () {
        return [typeOfBooking.COME, typeOfBooking.NOT_COME];
    };
    typeOfBooking.COME.getSubStatCategories = function () {
        return [TypeOfCustomer.OLD_CUSTOMER, TypeOfCustomer.NEW_CUSTOMER];
    };
    typeOfBooking.NOT_COME.getSubStatCategories = function () {
        return [TypeOfCustomer.OLD_CUSTOMER, TypeOfCustomer.NEW_CUSTOMER];
    };
    typeOfBooking.CREATE_BY_CUSTORMER_AND_NOT.getSubStatCategories = function () {
        return [typeOfBooking.CREATE_BY_CUSTORMER, typeOfBooking.NOT_CREATE_BY_CUSTOMER];
    };
    typeOfBooking.CREATE_BY_CUSTORMER.getSubStatCategories = function () {
        return [typeOfBooking.CREATE_BY_RWG, typeOfBooking.CREATE_BY_WEBSITE];
    };

    return typeOfBooking;
}]).factory('TypeOfCustomerRootCategory', ['TypeOfCustomer', function (TypeOfCustomer) {
    var typeOfCustomerRootCategory = {
        id: "TypeOfCustomerRootCategory",
        label: "TypeOfCustomerRootCategory",
        getSubStatCategories: function getSubStatCategories() {
            return [TypeOfCustomer.OLD_CUSTOMER, TypeOfCustomer.NEW_CUSTOMER];
        }
    };
    return typeOfCustomerRootCategory;
}]).factory('TypeOfCustomer', ['gettextCatalog', function (gettextCatalog) {
    var oldCustoms = gettextCatalog.getString("Anciens clients"),
        newCusoms = gettextCatalog.getString("Nouveaux clients");
    var typeOfCustomer = {
        OLD_CUSTOMER: { id: 'OLD_CUSTOMER', label: oldCustoms },
        NEW_CUSTOMER: { id: 'NEW_CUSTOMER', label: newCusoms }
    };
    return typeOfCustomer;
}]).factory('WorkingTimeRootCategory', ['HumanResourceData', function (HumanResourceData) {
    var rootStatCategorie = {
        id: "WorkingTimeRootCategory",
        label: "WorkingTimeRootCategory",
        getSubStatCategories: function getSubStatCategories(rootCategory, periodDays) {
            var humanResourceList = HumanResourceData.getActiveList(),
                humanResourceFinalList = humanResourceList;

            if (periodDays) {
                humanResourceFinalList = new Array();
                for (var i = 0; i < humanResourceList.length; i++) {
                    if (humanResourceList[i].statFilter(periodDays)) {
                        humanResourceFinalList.push(humanResourceList[i]);
                    }
                }
            }
            return humanResourceFinalList;
        }
    };
    return rootStatCategorie;
}]).factory('WorkingTimeHrIndisponibilityTime', ['WorkingTimeHrUsualIndisponibilityTime', 'WorkingTimeHrUnusualIndisponibilityTime', function (WorkingTimeHrUsualIndisponibilityTime, WorkingTimeHrUnusualIndisponibilityTime) {
    var rootStatCategorie = {
        id: "WorkingTimeHrIndisponibilityTime",
        label: "Période d'indisponibilité",
        getSubStatCategories: function getSubStatCategories(rootCategory, periodDays) {
            return [WorkingTimeHrUsualIndisponibilityTime, WorkingTimeHrUnusualIndisponibilityTime];
        }
    };
    return rootStatCategorie;
}]).factory('WorkingTimeHrUsualIndisponibilityTime', ['HumanResourceData', function (HumanResourceData) {
    var rootStatCategorie = {
        id: "WorkingTimeHrUsualIndisponibilityTime",
        label: "Indisponibilité réccurentes"
    };
    return rootStatCategorie;
}]).factory('WorkingTimeHrUnusualIndisponibilityTime', ['HumanResourceData', function (WorkingTimeHrUnusualIndisponibilityTime) {
    var rootStatCategorie = {
        id: "WorkingTimeHrUnusualIndisponibilityTime",
        label: "Indisponibilités exceptionnelles"
    };
    return rootStatCategorie;
}]).factory('WorkingTimeHrBookingOpenTime', ['WorkingTimeHrUnoccupiedTime', 'WorkingTimeHrBookingTime', function (WorkingTimeHrUnoccupiedTime, WorkingTimeHrBookingTime) {
    var rootStatCategorie = {
        id: "WorkingTimeHrBookingOpenTime",
        label: "Période ouverte aux prestations",
        getSubStatCategories: function getSubStatCategories(rootCategory, periodDays) {
            return [WorkingTimeHrUnoccupiedTime, WorkingTimeHrBookingTime];
        }
    };
    return rootStatCategorie;
}]).factory('WorkingTimeHrUnoccupiedTime', ['HumanResourceData', function (HumanResourceData) {
    var rootStatCategorie = {
        id: "WorkingTimeHrUnoccupiedTime",
        label: "Innoccupé"
    };
    return rootStatCategorie;
}]).factory('WorkingTimeHrBookingTime', ['HumanResourceData', function (HumanResourceData) {
    var rootStatCategorie = {
        id: "WorkingTimeHrBookingTime",
        label: "En prestation"
    };
    return rootStatCategorie;
}]).factory('HrOccupationDatas', [function () {
    var HrOccupationDatas = function HrOccupationDatas(day, unoccupiedTime, bookingTime, unusualIndisponibilityTime, usualIndisponibilityTime) {
        this.day = day;
        this.unoccupiedTime = unoccupiedTime;
        this.bookingTime = bookingTime;
        this.unusualIndisponibilityTime = unusualIndisponibilityTime;
        this.usualIndisponibilityTime = usualIndisponibilityTime;
    };
    return HrOccupationDatas;
}]);

/***/ }),

/***/ 338:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by mathieudeumie on 30/04/2014.
 */

angular.module('FlexyBeautyApp.controllers').controller('StatisticsCtrl', ["$scope", "$timeout", "$filter", "$dialog", "CategoryStatView", "ServiceStatView", "CategoryData", "DayData", "SiteData", "HumanResourceData", "HumanResourceStatView", "CustomerData", "CustomerStatView", "CustomerView", "SaleCure", "GiftItem", "LoyaltyCardItem", "MenuStatView", "ProductCategoryData", "ProductCategoryStatView", "ProductStatView", "CureCategoryStatView", "CureCategoryData", "CureStatView", "LoyaltyCardCategoryStatView", "LoyaltyCardCategoryData", "LoyaltyCardStatView", "DashboardStatView", "DashboardData", "$spMenu", "TypeOfSale", "Day", "ReportDatasSource", "PeriodDatasSource", "ReportTemporalAgregateFunctionType", "ColorGraph", "DateFormator", "RootStatCategorie", "SimpleReportDataSource", "HrRootOccupationRateCategory", "PrRootOccupationRateCategory", "ReportModelData", "ReportView", "HrRootCategory", "PeriodType", "TaxMode", "AppData", "App", "AppAttribute", "AppSrv", "PeriodStat", "TypeOfBooking", "StatPeriodType", "StoreAppData", "SmsCampaign", "SmsCampaignSrv", "$base64", "$http", "$sce", "$locale", "gettextCatalog", "PrimaryDatasType", "DashboardSrv", "DashboardSchedulerSrv", "DashboardScheduler", "DashboardSchedulerView", "SchedulerType", "CompanyImageData", "$location", "NotificationCampaign", "NotificationCampaignSrv", "MobileDeviceData", "MobileDeviceSrv", "NbCustormerCategoryStat", "StoreAppCode", "moment", "Timers", "Constants", function ($scope, $timeout, $filter, $dialog, CategoryStatView, ServiceStatView, CategoryData, DayData, SiteData, HumanResourceData, HumanResourceStatView, CustomerData, CustomerStatView, CustomerView, SaleCure, GiftItem, LoyaltyCardItem, MenuStatView, ProductCategoryData, ProductCategoryStatView, ProductStatView, CureCategoryStatView, CureCategoryData, CureStatView, LoyaltyCardCategoryStatView, LoyaltyCardCategoryData, LoyaltyCardStatView, DashboardStatView, DashboardData, $spMenu, TypeOfSale, Day, ReportDatasSource, PeriodDatasSource, ReportTemporalAgregateFunctionType, ColorGraph, DateFormator, RootStatCategorie, SimpleReportDataSource, HrRootOccupationRateCategory, PrRootOccupationRateCategory, ReportModelData, ReportView, HrRootCategory, PeriodType, TaxMode, AppData, App, AppAttribute, AppSrv, PeriodStat, TypeOfBooking, StatPeriodType, StoreAppData, SmsCampaign, SmsCampaignSrv, $base64, $http, $sce, $locale, gettextCatalog, PrimaryDatasType, DashboardSrv, DashboardSchedulerSrv, DashboardScheduler, DashboardSchedulerView, SchedulerType, CompanyImageData, $location, NotificationCampaign, NotificationCampaignSrv, MobileDeviceData, MobileDeviceSrv, NbCustormerCategoryStat, StoreAppCode, moment, Timers, Constants) {

    $scope.dd = {
        dataLoaded: false,
        loading: true,
        displaySubConf: 1,
        idChart: 1,
        timePeriod: "",
        bookingPriceAverage: 0, // panier moyen

        goBackAvailable: true,
        detailedCategories: false, // first level of zoom in category tree
        finalArray: false, // array displayed when zoom in max used in each view
        finalArrayCaByHr: false, // array displayed when zoom in max in ca view by hr
        finalArrayCaByTypeOfCustomer: false, // array displayed when zoom in max in ca view by type of customer
        finalArrayCustomerDetails: false, // array displayed in customer analyse view when one customer is selected : display ddetails of one customer

        isCollapsed: true,

        // data loaded from models
        hrs: null,
        defaultSite: null,
        days: [],
        categoryRoot: null,
        productCategoryRoot: null,
        cureCategoryRoot: null,
        loyaltyCardCategoryRoot: null,

        now: null,
        periodWatched: [], // list of days  //TO_DELETE

        periodWatchedLastYear: [], // list of days
        dateDisplayed: "",
        treeView: [],

        // Ca Values
        categoryStatViewTree: null, // equivalent of categoryRoot with CategoryStatView and ServiceStatView objects for CategoryView and ServiceView
        productCategoryStatViewTree: null,
        cureCategoryStatViewTree: null,
        loyaltyCardCategoryStatViewTree: null,
        selectedCategoryStatView: null,
        listOfCategoryStatViewDisplayed: [], // display only the CategoryStatView which contains booked servicesStatView (for the selector)
        selectedProductCategoryStatView: null,
        listOfProductCategoryStatViewDisplayed: [], // display only the CategoryStatView which contains booked servicesStatView (for the selector)
        selectedCureCategoryStatView: null,
        listOfCureCategoryStatViewDisplayed: [], // display only the CategoryStatView which contains booked servicesStatView (for the selector)
        selectedLoyaltyCardCategoryStatView: null,
        listOfLoyaltyCardCategoryStatViewDisplayed: [], // display only the CategoryStatView which contains booked servicesStatView (for the selector)
        selectedServiceStatView: null,
        listOfServiceStatViewDisplayed: [], // display only the booked ServiceStatView (for the selector)
        listOfBookingServicesDisplayed: [], // display a list of bookings of one service

        selectedTypeOfCustomerByCa: 0, // Ca analyse view / 1 : old ones, 2 : new ones
        selectedListOfCustomersByType: [], // used for Ca and customer view / list for the final array in analyse client

        selectedHrByCa: null, // HumanResource
        listOfBookingsOfSelectedHr: [], // used for CA and occupationRate
        listOfSaleServicesOfSelectedHr: [], // used for CA and occupationRate
        sumOfSaleServicesOfSelectedHr: 0,
        listOfSaleProductsOfSelectedHr: [], // used for CA and occupationRate
        sumOfSaleProductsOfSelectedHr: 0,
        listOfSaleCuresOfSelectedHr: [], // used for CA and occupationRate
        sumOfSaleCuresOfSelectedHr: 0,
        listOfLoyaltyCardItemsOfSelectedHr: [], // used for CA and occupationRate
        sumOfLoyaltyCardItemsOfSelectedHr: 0,
        listOfHrDisplayed: [], // display only the Hr which have a rate > 0% <=> at least one bookingService (for the selector)

        listOfCustomerStatView: [], // the list of the customerStatView existing in the periodWatched
        selectedTypeOfCustomer: 0, // Customer analyse view / 1 : old ones, 2 : new ones

        globalData: { ca: 0, hrCa: 0 },
        serviceData: { ca: 0 },
        productData: { ca: 0 },
        cureData: { ca: 0 },
        loyaltyCardData: { ca: 0 },
        giftItemData: { ca: 0 },
        // selectedCustomerStatView and selectedCustomerView used to see details of one customer in analyse customer view zoom in
        selectedCustomerStatView: null,
        selectedCustomerView: null, // useful to get the came / not came attributes

        // occupation rate
        hrStatViews: [],
        selectedHrByRate: null, // HumanResource
        hrWithGift: true,

        // menu in anayse views
        rateDisplayed: 1,
        caDisplayed: 1,
        caDisplayedSub: null,
        customerDisplayed: 1,
        datePickerDisplayed: false,
        rootMenuStatView: null,
        globalMenuDisplayed: 1,
        menuMobile: true,
        cMenuStatView: null,
        dashboardsView: [],
        selectedDashboardView: null,
        selectedDashboardSchedulerView: null,
        allReportsView: [],
        freeReportsView: [],
        advancedReportsView: [],
        reportCategoriesView: [{
            label: "Rapports recommandés par " + $scope.ad.brand.label,
            imgUrl: $scope.ad.brand.images.logoWhite,
            reportsCodes: ["ca", "sale-by-hr", "giftItem"],
            reportsView: []
        }, {
            label: "Ventilation du chiffre d'affaires",
            imgUrl: "/img/statistics/ca.svg",
            reportsCodes: ["ca", "nb-sales", "not-honored-booking", "gain-by-minute", "products-ca", "daily-average-nb-sales", "sales-by-visit"],
            reportsView: []
        }, {
            label: "Performances commerciales",
            imgUrl: "/img/statistics/commerciale.svg",
            reportsCodes: ["average-cart", "average-cart-by-gender", "average-cart-gift", "booking-in-line", "fidelity-collaborator-rate"],
            reportsView: []
        }, {
            label: "Optimisation des plannings",
            imgUrl: "/img/statistics/planning.svg",
            reportsCodes: ["hr-occupation-rate", "pr-occupation-rate", "not-honored-booking", "custormer-come", "gain-by-minute", "working-time"],
            reportsView: []
        }, {
            label: "Performances des collaborateurs",
            imgUrl: "/img/statistics/collaborateur.svg",
            reportsCodes: ["sale-by-hr", "visits-by-collab", "nb-sales-by-personnal", "fidelity-collaborator-rate", "hr-occupation-rate", "working-time", "daily-average-nb-visits-by-personnal"],
            reportsView: []
        }, { label: "Suivi des clients",
            imgUrl: "/img/statistics/client.svg",
            reportsCodes: ["old-and-new-customer", "nb-customers", "new-customer", "old-customer", "not-honored-booking", "custormer-come", "penetration-rate", "fidelity-rate"],
            reportsView: []
        }],
        reportTextFilter: "",
        statMenu: true,
        reportDataSources: new Array(),
        graphColors: ColorGraph.colors,
        displayUnsavedMessage: false,
        currentPeriod: null,
        pastPeriod: null,
        periodType: PeriodType.MONTH,
        beginMoment: null,
        endMoment: null,
        taxMode: TaxMode.HT,
        additionalFilters: [],
        hideUsedReport: false, //TO MANAGE IT IN FUTURE VERSION
        pageDisplayed: {
            type: null, // null / "addReports","business","helpCenter","commnunicate","dashboardMng", "detail"
            selectedReportView: null
        },
        businessPage: null,
        helpCenterArticle: null,
        businessNotHonoredData: null,
        notHonoredBookingProjectionData: new Array(),
        smsRecallCostProjectionData: new Array(),
        caIncreaseProjectionData: new Array(),
        businessNotHonoredParameters: {
            nbMonth: 6,
            maxiRatio: 0.75,
            miniRatio: 0.2,
            smsPrice: null,
            /* colorsBenefits : ['#C5FF6C','#B4FFC7'],*/
            colorsBenefits: ['#B4FFC7', '#B4FFC7'],
            colorsDepenses: ['#FFCAC7']
        },
        recallActivatedMessageDisplayed: false,
        recallActivatedSmsCampaignMessageDisplayed: false,
        recallActivatedNotificationCampaignMessageDisplayed: false,
        reloadDailyPrecalculatedDatas: false,
        sendDashboardOkDisplayed: false,
        sendDashboardPeriodicOkDisplayed: false,
        StatPeriodType: StatPeriodType,
        PrimaryDatasType: PrimaryDatasType,
        shareInfo: {
            type: SchedulerType.SINGLE,
            surname: null,
            object: null,
            message: null,
            emailList: [],
            displayEmptyEmail: false,
            displayEmptyObject: false,
            displayEmptySurname: false,
            periodic: false
        },
        SchedulerType: SchedulerType,
        dashboardOverview: false,
        NbCustormerCategoryStat: NbCustormerCategoryStat
    };

    var timers = [];

    $scope.fetchStatistics = function () {
        $scope.dd.loading = true;
        return DashboardSrv.query(function () {
            $scope.loadDashboards();
            $scope.loadReportsView();

            $scope.loadBusinessNotHonoredData();
            $scope.loadNotHonoredBookingProjectionDataGraphs();
            $scope.dd.loading = false;
        }, function () {
            $scope.dd.loading = false;
        });
    };

    $scope.$watch('ad.dataLoaded', function (newValue, oldValue) {
        if (newValue) {
            $scope.redirectToPlanningIfStatisticsDisabled();
            if (!$scope.ad.managerMode) {
                $scope.goToDomain("planningPos", "dashboard");
            }

            $scope.dd.loading = false;
            $scope.dd.beginMoment = new moment();
            $scope.dd.endMoment = new moment();

            $scope.dd.categoryRoot = CategoryData.categoryRoot;
            $scope.dd.productCategoryRoot = ProductCategoryData.categoryRoot;
            $scope.dd.cureCategoryRoot = CureCategoryData.categoryRoot;
            $scope.dd.loyaltyCardCategoryRoot = LoyaltyCardCategoryData.categoryRoot;

            CategoryData.categoryRoot.label = TypeOfSale.SERVICE.label;
            ProductCategoryData.categoryRoot.label = TypeOfSale.PRODUCT.label;
            CureCategoryData.categoryRoot.label = TypeOfSale.CURE.label;
            LoyaltyCardCategoryData.categoryRoot.label = TypeOfSale.LOYALTY.label;

            $scope.dd.businessNotHonoredParameters.smsPrice = $scope.ad.view.companyView.getSubscriptionViewByStoreAppViewCode(StoreAppCode.OPTION_SMS_REMINDER_APP_CODE).price; //StoreAppData.getByCode("smsCampaign").price;

            $scope.reloadDailyPrecalculatedDatas = true;

            $scope.loadStatisticAppParameter("taxMode");

            var dashboardList = DashboardData.getDashboardList();
            if (dashboardList && dashboardList.length === 0) {
                $scope.fetchStatistics();
            } else {
                $scope.loadDashboards();
                $scope.loadReportsView();
                $scope.loadBusinessNotHonoredData();
                $scope.loadNotHonoredBookingProjectionDataGraphs();
            }

            $scope.dd.shareInfo.emailList.push({ text: $scope.ad.loggedUser.email });
            //$scope.loadLogo();
        }
    });

    //Manage windows width resize
    var width = $(window).width();
    var doit;
    $(window).resize(function () {
        if ($(this).width() != width) {
            width = $(this).width();
            clearTimeout(doit);
            $scope.dd.loading = true;
            $scope.safeApply();
            doit = setTimeout($scope.onWindowResizeEnd, 250);
        }
    });
    $scope.onWindowResizeEnd = function () {
        $scope.dd.loading = false;
        $scope.safeApply();
    };

    $scope.safeApply = function (fn) {
        if ($scope.$root) {
            var phase = $scope.$root.$$phase;
            if (phase == '$apply' || phase == '$digest') {
                if (fn && typeof fn === 'function') {
                    fn();
                }
            } else {
                $scope.$apply(fn);
            }
        } else $scope.$apply(fn);
    };

    $scope.getReportView = function (reportId) {
        var reportsView = null;
        for (var i = 0; i < $scope.dd.allReportsView.length; i++) {
            if ($scope.dd.allReportsView[i].id == reportId) {
                reportsView = $scope.dd.allReportsView[i];
                break;
            }
        }
        return reportsView;
    };

    $scope.getVisibleReports = function (globalMenuDisplayed) {
        var visibleReports = null;
        if (globalMenuDisplayed == 1) {
            visibleReports = $scope.dd.selectedDashboardView.reportsView;
        } else if (globalMenuDisplayed == 2) {
            visibleReports = $scope.dd.freeReportsView;
        } else if (globalMenuDisplayed == 3) {
            visibleReports = $scope.dd.advancedReportsView;
        }
        return visibleReports;
    };

    $scope.getUnVisibleReports = function (globalMenuDisplayed) {
        var unVisibleReports = null;
        if (globalMenuDisplayed == 1) {
            unVisibleReports = $scope.dd.freeReportsView.concat($scope.dd.advancedReportsView).concat($scope.dd.allReportsView);
        } else if (globalMenuDisplayed == 2) {
            unVisibleReports = $scope.dd.selectedDashboardView.reportsView.concat($scope.dd.advancedReportsView).concat($scope.dd.allReportsView);
        } else if (globalMenuDisplayed == 3) {
            unVisibleReports = $scope.dd.selectedDashboardView.reportsView.concat($scope.dd.freeReportsView).concat($scope.dd.allReportsView);
        }
        for (var i = 0; i < $scope.dd.dashboardsView.length; i++) {
            if ($scope.dd.dashboardsView[i] != $scope.dd.selectedDashboardView) {
                unVisibleReports = unVisibleReports.concat($scope.dd.dashboardsView[i].reportsView);
            }
        }
        return unVisibleReports;
    };

    $scope.nextReportPromises = [];
    $scope.unvisiblePromise = null;

    $scope.reloadReportsDataSource = function () {
        $timeout.cancel($scope.unvisiblePromise);
        for (var i = 0; i < $scope.nextReportPromises.length; i++) {
            $timeout.cancel($scope.nextReportPromises[i]);
        }
        $scope.nextReportPromises = [];

        var numLoad = Math.floor(Math.random() * 100);

        var globalMenuDisplayed = $scope.dd.globalMenuDisplayed;
        //reload visible reports
        $scope.reloadReportsDataSourceOf($scope.getVisibleReports(globalMenuDisplayed), numLoad);

        $scope.unvisiblePromise = $timeout(function () {
            $scope.reloadReportsDataSourceOf($scope.getUnVisibleReports(globalMenuDisplayed), numLoad);
        }, 100);
    };

    $scope.reloadReportsDataSourceOf = function (reportsView, numLoad) {
        for (var i = 0; i < reportsView.length; i++) {
            var reportView = reportsView[i];
            reportsView[i].loading = true;
        }

        $scope.loadAndDisplayReportView(reportsView, 0, numLoad);
    };

    $scope.loadAndDisplayReportView = function (reportsView, index, numLoad) {
        if (reportsView && index < reportsView.length) {

            if (reportsView[index].eltsReport && reportsView[index].getDataSource() && reportsView[index].getDataSource().loadPeriod) {
                //reportsView[index].getDataSource().loadPeriod($scope.dd.periodWatched[0].getMomentDate(), $scope.dd.timePeriod);
                reportsView[index].getDataSource().loadPeriod($scope.dd.currentPeriod, $scope.dd.pastPeriod, $scope.dd.taxMode, $scope.dd.additionalFilters);
            }

            reportsView[index].loading = false;
            $scope.nextReportPromises.push($timeout(function () {
                $scope.loadAndDisplayReportView(reportsView, index + 1, numLoad);
            }, 100));
        }
    };

    $scope.loadDashboards = function () {
        $scope.dd.dashboardsView = [];
        var indexFirstDashboard = null;

        for (var i = 0; i < DashboardData.getDashboardList().length; i++) {
            var newDashboard = new DashboardStatView(DashboardData.getDashboardList()[i], i, $scope.isSolutionActivated, $scope.ad.view.companyView.startModelId);
            $scope.dd.dashboardsView.push(newDashboard);
            if (!indexFirstDashboard && !newDashboard.isFlexy) {
                indexFirstDashboard = i;
            }
        }
        if ($scope.dd.dashboardsView.length != 0) {
            $scope.loadStatisticAppParameter("selectedDashboardId");

            if (!$scope.dd.selectedDashboardView && $scope.dd.dashboardsView.length > 0) {
                $scope.dd.selectedDashboardView = $scope.dd.dashboardsView[0];
            }
        } else {
            var newDashboard = new DashboardStatView();
            $scope.dd.dashboardsView.push(newDashboard);
            $scope.dd.selectedDashboardView = newDashboard;
        }
    };

    $scope.isSolutionActivated = function (reportModelId) {
        var isSolutionActivated = false;
        if (reportModelId == "not-honored-booking") {
            var smsReminder = $scope.ad.view.companyView.getSubscriptionViewByStoreAppViewCode('smsReminder');
            if (smsReminder) {
                isSolutionActivated = smsReminder.isActive;
            }
        }
        return isSolutionActivated;
    };

    $scope.loadReportsView = function () {
        var reportsModel = ReportModelData.getActiveList();
        $scope.dd.freeReportsView = [];
        $scope.dd.advancedReportsView = [];
        $scope.dd.allReportsView = [];
        for (var i = 0; i < reportsModel.length; i++) {
            var reportView = new ReportView(reportsModel[i], null, $scope.dd.taxMode, $scope.isSolutionActivated, $scope.ad.view.companyView.startModelId);

            $scope.dd.allReportsView.push(reportView);
            if (reportsModel[i].advanced) $scope.dd.advancedReportsView.push(reportView);else $scope.dd.freeReportsView.push(reportView);
        }
        $scope.loadReportCategoriesView($scope.dd.allReportsView);
    };
    $scope.loadReportCategoriesView = function (reportsView) {

        if (reportsView) $scope.dd.reportCategoriesView.forEach(function (reportCategory) {
            reportCategory.reportsView = [];
            reportsView.forEach(function (reportView) {
                if (reportCategory.reportsCodes.indexOf(reportView.id) != -1) reportCategory.reportsView.push(reportView);
            });
        });
    };

    $scope.displayModifyButton = function () {
        if ($scope.dd.selectedDashboardView.isFlexy) {
            $scope.openEditFlexyDashboardViewConfirmDialog();
        } else {
            $scope.dd.selectedDashboardView.editing = true;
        }
    };

    $scope.displayReportsAddView = function () {
        if ($scope.dd.selectedDashboardView) {
            $scope.dd.reportsForSearchLoad = false;
            $scope.dd.reportTextFilter = "";
            $scope.setPageDisplayed("addReports");
            $scope.dd.selectedDashboardView.editing = true;
            $scope.dd.selectedDashboardView.activeCategoryReportView = null;
            $scope.dd.selectedDashboardView.activeReportView = null;
            $scope.displayReportLoader($scope.dd.allReportsView);
            var timer = $timeout(function () {
                $scope.dd.reportsForSearchLoad = true;
            }, 200);
            timers.push(timer);
        }
    };
    $scope.setPageDisplayed = function (type, reportView) {
        //set to null if ask for it or already active
        if (type === undefined || !type || $scope.dd.pageDisplayed && $scope.dd.pageDisplayed.type && $scope.dd.pageDisplayed.type == type && $scope.dd.pageDisplayed.selectedReportView == reportView) {
            $scope.dd.pageDisplayed.type = null;
            $scope.dd.pageDisplayed.selectedReportView = null;
        } else {
            $scope.dd.pageDisplayed.type = type;
            if (reportView !== undefined) $scope.dd.pageDisplayed.selectedReportView = reportView;
        }
    };

    $scope.displayReportsBusinessView = function (reportView, businessPage) {
        $scope.setPageDisplayed("business", reportView);
        $scope.businessPage = businessPage; //TODO REMOVE AND MANAGE ONLY SELECTED REPORTVIEW
    };

    $scope.displayReportsCommunicateView = function (reportView) {
        $scope.setPageDisplayed("communicate", reportView);
    };

    $scope.displayReportsDetailView = function (reportView) {
        $scope.setPageDisplayed("detail", reportView);
    };

    $scope.displayReportsShareView = function (reportView) {
        $scope.setPageDisplayed("share", reportView);
    };

    $scope.displayReportsSchedulerListView = function (reportView) {
        $scope.setPageDisplayed("schedulerList", reportView);
    };

    $scope.trustAsHtml = function (string) {
        return $sce.trustAsHtml(string);
    };

    $scope.displayReportLoader = function (reportsView) {
        if (reportsView) {
            for (var i = 0; i < reportsView.length; i++) {
                reportsView[i].loading = true;
            }$scope.displayReport(reportsView, 0);
        }
    };

    $scope.displayReport = function (reportsView, index) {
        if (reportsView && index < reportsView.length) {
            reportsView[index].loading = false;
            var timer = $timeout(function () {
                $scope.displayReport(reportsView, index + 1);
            }, 100);
            timers.push(timer);
        }
    };

    $scope.createNewDashboard = function () {
        var newDashboard = new DashboardStatView();
        $scope.dd.dashboardsView.push(newDashboard);
        newDashboard.editing = true;
        $scope.setPageDisplayed();
        $scope.dd.selectedDashboardView = newDashboard;
        $scope.displayReportsAddView();
    };

    $scope.cloneSelectedDashboard = function () {
        var defaultTitle = gettextCatalog.getString("Mon tableau de bord");
        var dashboardToClone = $scope.dd.selectedDashboardView;
        $scope.createNewDashboard();

        for (var i = 0; i < dashboardToClone.reportsView.length; i++) {
            $scope.dd.selectedDashboardView.addReport(dashboardToClone.reportsView[i]);
        }
        $scope.dd.selectedDashboardView.title = defaultTitle;
        $scope.saveSelectedDashboardView();
    };

    $scope.saveSelectedDashboardView = function () {
        var dashboardView = $scope.dd.selectedDashboardView;
        dashboardView.updateModel(function () {
            if (dashboardView.dashboardModel) {
                $scope.saveAppParameter("selectedDashboardId", dashboardView.dashboardModel.id);
            }
        });
        $scope.dd.displayUnsavedMessage = false;

        $scope.dd.selectedDashboardView.editing = false;
        $scope.displayChangeMsg = false;
        if ($scope.dd.dashboardsView.indexOf($scope.dd.selectedDashboardView) == -1) {
            $scope.dd.dashboardsView.push($scope.dd.selectedDashboardView);
        }
    };

    $scope.openDeletedDashboardViewConfirmDialog = function () {
        if ($scope.dd.selectedDashboardView) {
            var opts = {
                backdrop: true,
                keyboard: true,
                backdropClick: false,
                templateUrl: '/partials/global/removeConfirm.html',
                controller: 'DialogCtrl',
                resolve: {
                    dialogsModel: function dialogsModel() {
                        var tableModel = [];
                        tableModel["label"] = $scope.dd.selectedDashboardView.titre;
                        return tableModel;
                    } } };

            var d = $dialog.dialog(opts);
            d.open().then(function (result) {
                if (result) $scope.removeSelectedDashboardView();
            });
        }
    };

    $scope.openEditFlexyDashboardViewConfirmDialog = function () {
        if ($scope.dd.selectedDashboardView) {
            var opts = {
                backdrop: true,
                keyboard: true,
                backdropClick: false,
                templateUrl: '/partials/global/editFlexyDashboardConfirm.html',
                controller: 'DialogCtrl',
                resolve: {
                    dialogsModel: function dialogsModel() {
                        var tableModel = [];
                        tableModel["label"] = $scope.dd.selectedDashboardView.titre;
                        return tableModel;
                    } } };

            var d = $dialog.dialog(opts);
            d.open().then(function (result) {
                if (result) $scope.cloneSelectedDashboard();
                //TODO CREATE NEW DASHBOARD FROM FLEXY TEMPLATE
            });
        }
    };

    $scope.loadDashboardView = function (dashboardView) {
        $scope.dd.selectedDashboardView = dashboardView;
        if (dashboardView.dashboardModel) {
            $scope.saveAppParameter("selectedDashboardId", dashboardView.dashboardModel.id);
        }
    };

    $scope.removeSelectedDashboardView = function () {
        if ($scope.dd.selectedDashboardView) {
            $scope.dd.selectedDashboardView.removeModel();
            var index = $scope.dd.dashboardsView.indexOf($scope.dd.selectedDashboardView);
            if (index != -1) {
                $scope.dd.dashboardsView.splice(index, 1);
            }
        }
        if ($scope.dd.dashboardsView.length == 0) {
            $scope.createNewDashboard();
        } else {
            $scope.dd.selectedDashboardView = $scope.dd.dashboardsView[0];
        }
    };

    $scope.cancelEditedDashboard = function () {
        if ($scope.dd.selectedDashboardView) {
            $scope.dd.displayUnsavedMessage = false;
            $scope.dd.selectedDashboardView.reloadModel($scope.isSolutionActivated, $scope.ad.view.companyView.startModelId);
            $scope.displayChangeMsg = false;
            $scope.dd.selectedDashboardView.editing = false;
            $scope.reloadReportsDataSource();
        }
    };

    $scope.displayMenu = function () {
        $scope.dd.statMenu = true;

        $spMenu.show();
        var timer = $timeout(function () {
            window.dispatchEvent(new Event('resize'));
        }, 500);
        timers.push(timer);
    };

    $scope.hideMenu = function () {
        $scope.dd.statMenu = false;

        $spMenu.hide();
        var timer = $timeout(function () {
            window.dispatchEvent(new Event('resize'));
        }, 500);
        timers.push(timer);
    };

    $scope.onTitleDashboardClick = function () {
        if (!$scope.dd.selectedDashboardView.isFlexy) {
            $scope.dd.selectedDashboardView.editing = true;
        }
    };

    $scope.onDashboardGestionClick = function () {
        if ($scope.dd.selectedDashboardView.isChanged() && $scope.dd.selectedDashboardView.dashboardModel != null && $scope.dd.selectedDashboardView.dashboardIndex != null) {
            $scope.dd.displayUnsavedMessage = true;
        } else {
            $scope.setPageDisplayed("dashboardMng");
        }
    };

    $scope.onPeriodChanged = function (newCurrentPeriod, newPastPeriod) {
        if (!$scope.dd.currentPeriod || !$scope.dd.currentPeriod.isSame(newCurrentPeriod)) {
            $scope.dd.currentPeriod = newCurrentPeriod;
            $scope.dd.pastPeriod = newPastPeriod;

            $scope.dd.periodType = $scope.dd.currentPeriod.periodType;
            $scope.dd.beginMoment = $scope.dd.currentPeriod.beginMomentDay;
            $scope.dd.endMoment = $scope.dd.currentPeriod.endMomentDay;
            $scope.reloadReportsDataSource();
        }
    };

    $scope.onTaxModeChange = function (newTaxMode) {
        $scope.dd.taxMode = newTaxMode;
        $scope.saveAppParameter("taxMode", $scope.dd.taxMode.id);

        $scope.reloadReportsDataSource();
    };

    $scope.loadStatisticAppParameter = function (parameterName) {
        if (AppData.getAppList().length > 0) {
            var statisticApp = AppData.getAppByCode("statistic");
            if (statisticApp !== null) {
                if (parameterName == "taxMode" && statisticApp.getAppAttribute(parameterName) !== null) $scope.dd.taxMode = TaxMode.getTaxModeById(statisticApp.getAppAttribute(parameterName).value);

                if (parameterName == "selectedDashboardId") {
                    $scope.dd.selectedDashboardView = null;
                    if (statisticApp.getAppAttribute(parameterName) !== null) {
                        for (var i = 0; i < $scope.dd.dashboardsView.length; i++) {
                            if ($scope.dd.dashboardsView[i].dashboardModel && $scope.dd.dashboardsView[i].dashboardModel.id && $scope.dd.dashboardsView[i].dashboardModel.id == statisticApp.getAppAttribute(parameterName).value) {
                                $scope.dd.selectedDashboardView = $scope.dd.dashboardsView[i];
                            }
                        }
                    }
                    if (!$scope.dd.selectedDashboardView && $scope.dd.dashboardsView.length > 0) $scope.dd.selectedDashboardView = $scope.dd.dashboardsView[0];
                }
            }
        }
    };

    $scope.saveAppParameter = function (parameterName, parameterValue) {
        var statisticApp = AppData.getAppByCode("statistic");

        if (statisticApp !== null) {
            //agenda app exists
            var appAttribute = statisticApp.getAppAttribute(parameterName);
            if (appAttribute) statisticApp.setAppAttribute(parameterName, parameterValue);else statisticApp.addAppAttribute(new AppAttribute(parameterName, parameterValue));

            AppSrv.save(statisticApp);
        } else {
            // if statistic app doesn't exist and/or values are not the same
            statisticApp = new App();
            statisticApp.setCode("statistic");
            statisticApp.addAppAttribute(new AppAttribute(parameterName, parameterValue));

            AppSrv.save(statisticApp);
        }
    };

    $scope.loadBusinessNotHonoredData = function () {
        var nbMonth = 6,
            beginMoment = new moment().startOf('month').add(nbMonth * -1, 'month'),
            endMoment = new moment().startOf('month').add(-1, 'day'),
            notHonoredBookingPrice = 0,
            nbBooking = 0;

        var last6monthsPeriod = new PeriodStat(StatPeriodType.PAST, beginMoment, endMoment, PeriodType.CUSTOMED);

        for (var i = 0; i < last6monthsPeriod.arrayOfDays.length; i++) {
            var day = last6monthsPeriod.arrayOfDays[i];

            if (day && day.isAStatisticDay()) {
                notHonoredBookingPrice += day.getBookingsCAOfBookingObject([TypeOfBooking.NOT_COME], last6monthsPeriod.arrayOfDays[0], $scope.taxMode);
                nbBooking += day.getNbBookingsOfBookingObject([TypeOfBooking.COME_AND_NOT_COME], last6monthsPeriod.arrayOfDays[0], $scope.taxMode);
            }
        }
        $scope.dd.businessNotHonoredData = {
            "averageOfNotHonoredBooking": notHonoredBookingPrice / nbMonth,
            "averageNbBooking": nbBooking / nbMonth
        };
    };

    $scope.loadNotHonoredBookingProjectionDataGraphs = function () {
        var monthlyDatasFirstRow = new Array(),
            monthlyDatas = new Array(),
            currentMomentDay = new moment().startOf('month'),
            endMoment = new moment().startOf('month').add($scope.dd.businessNotHonoredParameters.nbMonth, 'month'),
            monthlyAverageOfNotHonoredBooking = $scope.dd.businessNotHonoredData.averageOfNotHonoredBooking,
            monthlyAverageNbBooking = $scope.dd.businessNotHonoredData.averageNbBooking;

        monthlyDatasFirstRow.push({ id: 'jour', label: 'jour', type: 'date' });
        //monthlyDatasFirstRow.push("Economie minimum");
        monthlyDatasFirstRow.push("Economie minimum");
        $scope.dd.notHonoredBookingProjectionData.push(monthlyDatasFirstRow);

        monthlyDatasFirstRow = new Array();
        monthlyDatasFirstRow.push({ id: 'jour', label: 'jour', type: 'date' });
        monthlyDatasFirstRow.push("Coût des rappels de rendez-vous par sms");
        $scope.dd.smsRecallCostProjectionData.push(monthlyDatasFirstRow);

        monthlyDatasFirstRow = new Array();
        monthlyDatasFirstRow.push({ id: 'jour', label: 'jour', type: 'date' });
        //monthlyDatasFirstRow.push("Augmentation du CA minimum");
        monthlyDatasFirstRow.push("Augmentation du CA maximum");
        $scope.dd.caIncreaseProjectionData.push(monthlyDatasFirstRow);

        while (endMoment.diff(currentMomentDay) >= 0) {
            var monthArray = new Array();
            monthArray.push(currentMomentDay.toDate());
            //monthArray.push(monthlyAverageOfNotHonoredBooking * $scope.dd.businessNotHonoredParameters.miniRatio);
            monthArray.push(monthlyAverageOfNotHonoredBooking * $scope.dd.businessNotHonoredParameters.maxiRatio);
            $scope.dd.notHonoredBookingProjectionData.push(monthArray);

            var monthArray = new Array();
            monthArray.push(currentMomentDay.toDate());
            monthArray.push(monthlyAverageNbBooking * $scope.dd.businessNotHonoredParameters.smsPrice);
            $scope.dd.smsRecallCostProjectionData.push(monthArray);

            var monthArray = new Array();
            monthArray.push(currentMomentDay.toDate());
            //monthArray.push(monthlyAverageOfNotHonoredBooking * $scope.dd.businessNotHonoredParameters.miniRatio - monthlyAverageNbBooking * $scope.dd.businessNotHonoredParameters.smsPrice);
            monthArray.push(monthlyAverageOfNotHonoredBooking * $scope.dd.businessNotHonoredParameters.maxiRatio - monthlyAverageNbBooking * $scope.dd.businessNotHonoredParameters.smsPrice);
            $scope.dd.caIncreaseProjectionData.push(monthArray);

            currentMomentDay.add(1, 'month');
        }
    };

    $scope.activateSmsCampaign = function () {
        var smsReminder = $scope.ad.view.companyView.getSubscriptionViewByStoreAppViewCode(StoreAppCode.OPTION_SMS_REMINDER_APP_CODE);
        if (smsReminder) {
            smsReminder.isActive = true;
            $scope.ad.view.companyView.updateModelSubscriptions();
        }
        $scope.dd.recallActivatedMessageDisplayed = true;
    };

    $scope.createNotification = function (label, customerList) {
        if (label && customerList && customerList.length > 0) {
            var notifCampaign = new NotificationCampaign();
            notifCampaign.label = label;
            customerList.forEach(function (element) {
                var mobileDevices = MobileDeviceData.getListByCustomerId(element.id);
                if (mobileDevices && mobileDevices.length > 0) mobileDevices.forEach(function (mobile) {
                    notifCampaign.mobiles.push(mobile);
                });
            });
            if (notifCampaign.mobiles.length == 0) {
                var opts = {
                    backdrop: true,
                    keyboard: true,
                    backdropClick: false,
                    templateUrl: '/partials/global/infoDialog.html',
                    controller: 'DialogCtrl',
                    resolve: {
                        dialogsModel: function dialogsModel() {
                            var tableModel = [];
                            var label = gettextCatalog.getString("La campagne de notifications n'a pas été créée, car aucun client ne possède l'application mobile.");
                            tableModel["label"] = label;
                            return tableModel;
                        }
                    }
                };
                $dialog.dialog(opts).open();
            } else {
                // SUCCESS
                notifCampaign.status = "createdFromReport";
                notifCampaign.type = "campaign";
                NotificationCampaignSrv.save(notifCampaign);
                $scope.dd.recallActivatedNotificationCampaignMessageDisplayed = true;
                $scope.setPageDisplayed();
                var timer = $timeout(function () {
                    $scope.dd.recallActivatedNotificationCampaignMessageDisplayed = false;
                }, 20000);
                timers.push(timer);
            }
        } else {
            var opts = {
                backdrop: true,
                keyboard: true,
                backdropClick: false,
                templateUrl: '/partials/global/infoDialog.html',
                controller: 'DialogCtrl',
                resolve: {
                    dialogsModel: function dialogsModel() {
                        var tableModel = [];
                        var label = gettextCatalog.getString("La campagne de notifications n'a pas été créée, car il n'y a aucun client dans le tableau.");
                        tableModel["label"] = label;
                        return tableModel;
                    }
                }
            };
            $dialog.dialog(opts).open();
        }
    };
    $scope.checkForCreateNotification = function (label, customerList) {
        if (!$scope.ad.addons.sub.nativeAppAccess) {
            var opts = {
                backdrop: true,
                keyboard: true,
                backdropClick: false,
                templateUrl: '/partials/global/infoDialog.html',
                controller: 'DialogCtrl',
                resolve: {
                    dialogsModel: function dialogsModel() {
                        var tableModel = [];
                        var label = gettextCatalog.getString("La campagne de notifications n'est pas disponible sans application mobile.");
                        tableModel["label"] = label;
                        return tableModel;
                    }
                }
            };
            $dialog.dialog(opts).open();
        } else {
            if (MobileDeviceData.getActiveList().length == 0) {
                MobileDeviceSrv.query(function (data) {
                    $scope.createNotification(label, customerList);
                }, function (data) {});
            } else {
                $scope.createNotification(label, customerList);
            }
        }
    };

    $scope.createSmsCampaign = function (label, customerList) {
        var smsCampaign = $scope.ad.view.companyView.getSubscriptionViewByStoreAppViewCode(StoreAppCode.OPTION_SMS_CAMPAIGN_APP_CODE);
        var msgSmsCampain = gettextCatalog.getString("L'option campagne de sms n'est pas activée");
        if (!smsCampaign || !smsCampaign.isActive) {
            var opts = {
                backdrop: true,
                keyboard: true,
                backdropClick: false,
                templateUrl: '/partials/global/infoDialog.html',
                controller: 'DialogCtrl',
                resolve: {
                    dialogsModel: function dialogsModel() {
                        var tableModel = [];
                        tableModel["label"] = msgSmsCampain + ".";
                        return tableModel;
                    }
                }
            };
            $dialog.dialog(opts).open();
        } else if (label && customerList && customerList.length > 0) {
            var smsCampaign = new SmsCampaign();
            smsCampaign.initUsingDefaults();
            smsCampaign.label = label; // TODO ADD PATH TO LABEL
            customerList.forEach(function (element) {
                if (element.phone && element.phone != "") smsCampaign.customers.push(element);
            });
            if (smsCampaign.customers.length == 0) {
                var msgSmsCampainNOk = gettextCatalog.getString("La campagne de sms n'a pas été créée, car aucun client qui possède un téléphone mobile");
                var opts = {
                    backdrop: true,
                    keyboard: true,
                    backdropClick: false,
                    templateUrl: '/partials/global/infoDialog.html',
                    controller: 'DialogCtrl',
                    resolve: {
                        dialogsModel: function dialogsModel() {
                            var tableModel = [];
                            tableModel["label"] = msgSmsCampainNOk + ".";
                            return tableModel;
                        }
                    }
                };
                $dialog.dialog(opts).open();
            } else {
                // SUCCESS
                smsCampaign.status = "createdFromReport";
                SmsCampaignSrv.save(smsCampaign);
                $scope.dd.recallActivatedSmsCampaignMessageDisplayed = true;
                $scope.setPageDisplayed();
                var timer = $timeout(function () {
                    $scope.dd.recallActivatedSmsCampaignMessageDisplayed = false;
                }, 20000);
                timers.push(timer);
            }
        } else {
            var msgSmsCampainNOK = gettextCatalog.getString("La campagne de sms n'a pas été créée car il n'y a aucun client dans le tableau");

            var opts = {
                backdrop: true,
                keyboard: true,
                backdropClick: false,
                templateUrl: '/partials/global/infoDialog.html',
                controller: 'DialogCtrl',
                resolve: {
                    dialogsModel: function dialogsModel() {
                        var tableModel = [];

                        tableModel["label"] = msgSmsCampainNOK + ".";
                        return tableModel;
                    }
                }
            };
            $dialog.dialog(opts).open();
        }
    };

    $scope.exportExcel = function (objet, idTable, title) {
        return ExcellentExport.excel(objet, idTable, title);
    };

    $scope.exportCsv = function (objet, idTable) {
        return ExcellentExport.csv(objet, idTable);
    };

    $scope.succesSendEmail = function () {
        $scope.dd.sendDashboardOkDisplayed = true;
        $scope.setPageDisplayed();
        var timer = $timeout(function () {
            $scope.dd.sendDashboardOkDisplayed = false;
        }, 20000);
        timers.push(timer);

        $scope.setPageDisplayed();
    };

    $scope.succesSendPeriodicEmail = function () {
        $scope.dd.sendDashboardPeriodicOkDisplayed = true;
        $scope.setPageDisplayed();
        var timer = $timeout(function () {
            $scope.dd.sendDashboardPeriodicOkDisplayed = false;
        }, 20000);
        timers.push(timer);

        $scope.setPageDisplayed();
    };

    $scope.failureSendEmail = function () {
        alert("echec");
    };

    $scope.getSendMail = function () {
        var emailTab = [];
        for (var i = 0; i < $scope.dd.shareInfo.emailList.length; i++) {
            emailTab.push($scope.dd.shareInfo.emailList[i].text);
        }
        return emailTab;
    };

    $scope.sendByMail = function () {
        if ($scope.dd.shareInfo.emailList && $scope.dd.shareInfo.object && $scope.dd.currentPeriod.beginMomentDay && $scope.dd.currentPeriod.endMomentDay) {

            var emailTab = $scope.getSendMail();

            DashboardSrv.export($scope.dd.selectedDashboardView.id, $scope.dd.shareInfo.object, $scope.dd.shareInfo.message, $scope.dd.currentPeriod.beginMomentDay.format("YYYYMMDD"), $scope.dd.currentPeriod.endMomentDay.format("YYYYMMDD"), emailTab, $scope.succesSendEmail, $scope.failureSendEmail);
        } else {
            $scope.updateError();
        }
    };

    $scope.updateErrorEmail = function () {
        $scope.dd.shareInfo.displayEmptyEmail = false;

        if (!$scope.dd.shareInfo.emailList || $scope.dd.shareInfo.emailList.length == 0) {
            $scope.dd.shareInfo.displayEmptyEmail = true;
        }
    };

    $scope.updateErrorObject = function () {
        $scope.dd.shareInfo.displayEmptyObject = false;

        if (!$scope.dd.shareInfo.object || $scope.dd.shareInfo.object == "") {
            $scope.dd.shareInfo.displayEmptyObject = true;
        }
    };

    $scope.updateErrorSurname = function () {
        $scope.dd.shareInfo.displayEmptySurname = false;

        if (!$scope.dd.shareInfo.surname || $scope.dd.shareInfo.surname == "") {
            $scope.dd.shareInfo.displayEmptySurname = true;
        }
    };

    $scope.updateError = function () {
        $scope.dd.shareInfo.displayEmptyEmail = false;
        $scope.dd.shareInfo.displayEmptyObject = false;
        $scope.dd.shareInfo.displayEmptySurname = false;

        if (!$scope.dd.shareInfo.emailList || $scope.dd.shareInfo.emailList == "") {
            $scope.dd.shareInfo.displayEmptyEmail = true;
        }
        if (!$scope.dd.shareInfo.object || $scope.dd.shareInfo.object == "") {
            $scope.dd.shareInfo.displayEmptyObject = true;
        }
        if (!$scope.dd.shareInfo.surname || $scope.dd.shareInfo.surname == "") {
            $scope.dd.shareInfo.displayEmptySurname = true;
        }
    };

    $scope.canSendDashboard = function () {
        var canSendDashboard = true;

        if (!$scope.dd.shareInfo.emailList || $scope.dd.shareInfo.emailList.length == 0) {
            canSendDashboard = false;
        }
        if (!$scope.dd.shareInfo.object || $scope.dd.shareInfo.object == "") {
            canSendDashboard = false;
        }
        if ($scope.dd.shareInfo.periodic) {
            if (!$scope.dd.shareInfo.surname || $scope.dd.shareInfo.surname == "") {
                canSendDashboard = false;
            }
        }
        return canSendDashboard;
    };

    $scope.addScheduler = function () {
        var dashboardSchedulerView = new DashboardSchedulerView();
        dashboardSchedulerView.type = $scope.dd.shareInfo.type.id;
        dashboardSchedulerView.object = $scope.dd.shareInfo.object;
        dashboardSchedulerView.message = $scope.dd.shareInfo.message;
        dashboardSchedulerView.sendTo = $scope.dd.shareInfo.emailList;
        dashboardSchedulerView.dashboardId = $scope.dd.selectedDashboardView.id;
        dashboardSchedulerView.surname = $scope.dd.shareInfo.surname;

        $scope.dd.selectedDashboardView.dashboardSchedulersView.push(dashboardSchedulerView);
        dashboardSchedulerView.updateModel($scope.succesSendPeriodicEmail, $scope.failureSendEmail);
    };

    $scope.removeScheduler = function (dashboardSchedulerView) {
        $scope.dd.selectedDashboardView.removeDashboardScheduler(dashboardSchedulerView);

        DashboardSchedulerSrv.remove(dashboardSchedulerView.getModel());
    };

    $scope.onGenderFilterClick = function (genderFilter) {
        var indexGenderFilter = $scope.dd.additionalFilters.indexOf(genderFilter);
        if (indexGenderFilter == -1) {
            $scope.dd.additionalFilters.push(genderFilter);
        } else {
            $scope.dd.additionalFilters.splice(indexGenderFilter, 1);
        }
        $scope.reloadReportsDataSource();
    };

    $scope.redirectToPlanningIfStatisticsDisabled = function () {
        if ($scope.ad.domain === Constants.APP_DOMAIN.statistics) {
            if (!$scope.ad.addons.sub.statisticsAccess) {
                $scope.goToDomain(Constants.APP_DOMAIN.planningPos);
            }
        }
    };

    $scope.$on('$destroy', function () {
        Timers.cancel(timers);
    });
}]);

/***/ }),

/***/ 352:
/***/ (function(module, exports, __webpack_require__) {

"use strict";



/* Controllers */

angular.module('FlexyBeautyApp.controllers').controller('ReportAloneCtrl', ['$scope', '$routeParams', 'ReportModelData', 'TaxMode', 'StatPeriodType', 'PeriodType', 'PeriodStat', 'ReportView', 'CategoryData', 'ProductCategoryData', 'CureCategoryData', 'LoyaltyCardCategoryData', 'TypeOfSale', 'DashboardData', 'moment', function ($scope, $routeParams, ReportModelData, TaxMode, StatPeriodType, PeriodType, PeriodStat, ReportView, CategoryData, ProductCategoryData, CureCategoryData, LoyaltyCardCategoryData, TypeOfSale, DashboardData, moment) {

    $scope.$watch('ad.dataLoaded', function (newValue, oldValue) {
        if (newValue) {
            $scope.reportId = $routeParams.idReport;
            $scope.beginDayId = $routeParams.beginDayId;
            $scope.endDayId = $routeParams.endDayId;
            $scope.dashboardId = $routeParams.dashboardId;
            $scope.indexReport = $routeParams.indexReport;
            $scope.dashboardModel = null;

            $scope.reportModel = ReportModelData.getById($scope.reportId);
            $scope.reportChanges = null;
            if ($scope.dashboardId) $scope.dashboardModel = DashboardData.getById($scope.dashboardId);

            if ($scope.dashboardModel) {
                var reports = angular.fromJson($scope.dashboardModel.jsonDetail);
                for (var i = 0; i < reports.length; i++) {
                    if (reports[i].reportModelId === $scope.reportId && i == $scope.indexReport) {
                        $scope.reportChanges = reports[i].reportChanges;
                    }
                }
            }

            $scope.taxMode = TaxMode.TTC;
            $scope.reportView = new ReportView($scope.reportModel, $scope.reportChanges, $scope.taxMode, null, null);

            $scope.begin = moment($scope.beginDayId, "YYYYMMDD");
            $scope.end = moment($scope.endDayId, "YYYYMMDD");

            $scope.currentPeriod = new PeriodStat(StatPeriodType.CURRENT, $scope.begin, $scope.end, PeriodType.CUSTOMED);

            CategoryData.categoryRoot.label = TypeOfSale.SERVICE.label;
            ProductCategoryData.categoryRoot.label = TypeOfSale.PRODUCT.label;
            CureCategoryData.categoryRoot.label = TypeOfSale.CURE.label;
            LoyaltyCardCategoryData.categoryRoot.label = TypeOfSale.LOYALTY.label;

            $scope.pastPeriod = new PeriodStat(StatPeriodType.PAST, PeriodStat.getLastYearCorrespondingDay($scope.currentPeriod.getArrayOfDays()[0].getMomentDate(), $scope.currentPeriod.periodType), PeriodType.getLastDayOfPeriod($scope.currentPeriod.periodType, PeriodStat.getLastYearCorrespondingDay($scope.currentPeriod.getArrayOfDays()[0].getMomentDate(), $scope.currentPeriod.periodType), $scope.currentPeriod.arrayOfDays.length), PeriodType.CUSTOMED);

            $scope.reportView.getDataSource().loadPeriod($scope.currentPeriod, $scope.pastPeriod, $scope.taxMode);
        }
    });
}]);

/***/ }),

/***/ 504:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by mathieudeumie on 22/07/2014.
 */

angular.module('FlexyBeautyApp.services').factory('CategoryStatView', ["ServiceStatView", function (ServiceStatView) {
    var CategoryStatView = function CategoryStatView(category, parentCategoryStatView) {
        this.label = "";
        this.nbBookingsOrSales = 0;
        this.color = "";
        this.parentCategoryStatView = parentCategoryStatView;

        this.equivalentCategory = category;

        this.categoryStatViews = [];
        this.serviceStatViews = [];
        this.globalServiceStatViews = [];

        this.ca = 0;

        if (category) this.loadData(category);
    };

    CategoryStatView.prototype.addServiceStatView = function (serviceStatView) {
        if (serviceStatView != undefined && serviceStatView != null) {
            this.serviceStatViews.push(serviceStatView);
            this.addGlobalServiceStatView(serviceStatView);
        }
    };
    CategoryStatView.prototype.addGlobalServiceStatView = function (serviceStatView) {
        if (serviceStatView != undefined && serviceStatView != null) {
            if (this.globalServiceStatViews.indexOf(serviceStatView) == -1) this.globalServiceStatViews.push(serviceStatView);
            if (this.parentCategoryStatView) this.parentCategoryStatView.addGlobalServiceStatView(serviceStatView);
        }
    };
    CategoryStatView.prototype.addCategoryStatView = function (categoryStatView) {
        if (categoryStatView != undefined && categoryStatView != null) this.categoryStatViews.push(categoryStatView);
    };
    CategoryStatView.prototype.loadData = function (category) {
        this.setColor(category);
        this.label = category.label;
        for (var i = 0; i < category.categories.length; i++) {
            var newCategoryStatViewFille = new CategoryStatView(category.categories[i], this);
            this.addCategoryStatView(newCategoryStatViewFille);
        }
        for (i = 0; i < category.services.length; i++) {
            var newServiceStatView = new ServiceStatView(category.services[i], this);
            this.addServiceStatView(newServiceStatView);
        }
    };

    CategoryStatView.prototype.setColor = function (category) {
        if (category.style == null && category.parentCategory != undefined && category.parentCategory != null) this.setColor(category.parentCategory);
        if (category.style != null && category.style.indexOf("background") != -1) {
            var index = category.style.indexOf("\"", category.style.indexOf("background") + 13);
            if (index != -1) this.color = category.style.substr(category.style.indexOf("background") + 13, index - category.style.indexOf("background") - 13);else this.color = category.style.substr(category.style.indexOf("background") + 13, 7);
            if (this.color == "white") //inverse for visibility
                this.color = "black";
        }
    };
    CategoryStatView.prototype.setPricesFromBookings = function (bookings) {
        // Set ca values for categoryViews / serviceStatViews / customers
        for (var i = 0; i < bookings.length; i++) {
            for (var j = 0; j < bookings[i].bookingServices.length; j++) {
                var serviceStatView = this.getServiceStatView(bookings[i].bookingServices[j].service);
                if (serviceStatView != null) {
                    if (bookings[i].bookingServices[j].dayHr) // if bookingService is not affected to an Hr
                        {
                            // set CA to serviceStatViews
                            serviceStatView.ca += bookings[i].bookingServices[j].price;
                            // set CA to categoryStatViews
                            serviceStatView.parentCategoryStatView.setValuesToParentCategories(bookings[i].bookingServices[j].price);

                            serviceStatView.nbBookingsOrSales++;

                            serviceStatView.bookingServices.push(bookings[i].bookingServices[j]);
                        }
                }
            }
        }
    };
    CategoryStatView.prototype.setPricesFromSales = function (sales) {
        // Set ca values for categoryViews / serviceStatViews / customers
        var price;
        for (var i = 0; i < sales.length; i++) {
            if (sales[i].status == "sold" || sales[i].status == "credit" || sales[i].status == "canceled") for (var j = 0; j < sales[i].saleServices.length; j++) {

                var serviceStatView = this.getServiceStatView(sales[i].saleServices[j].service);
                if (serviceStatView != null) {
                    //if(sales[i].saleServices[j].humanResource) // if bookingService is not affected to an Hr
                    {
                        // set CA to serviceStatViews
                        price = sales[i].saleServices[j].price - sales[i].saleServices[j].price * sales[i].discountPercent / 100;
                        serviceStatView.ca += price;
                        // set CA to categoryStatViews
                        serviceStatView.parentCategoryStatView.setValuesToParentCategories(price);

                        if (sales[i].status == "sold" || sales[i].status == "canceled") serviceStatView.nbBookingsOrSales++;else serviceStatView.nbBookingsOrSales--;
                        serviceStatView.saleServices.push(sales[i].saleServices[j]);
                    }
                }
            }
        }
    };
    CategoryStatView.prototype.setValuesToParentCategories = function (ca) {
        this.ca += ca;
        this.nbBookingsOrSales++;
        if (this.parentCategoryStatView != null) this.parentCategoryStatView.setValuesToParentCategories(ca);
    };

    CategoryStatView.prototype.getServiceStatView = function (service) {
        if (service) {
            var serviceStatView = null;
            for (var i = 0; i < this.serviceStatViews.length; i++) {
                if (this.serviceStatViews[i].serviceId == service.id) serviceStatView = this.serviceStatViews[i];
            }
            if (serviceStatView == null && this.categoryStatViews.length > 0) {
                for (i = 0; i < this.categoryStatViews.length; i++) {
                    serviceStatView = this.categoryStatViews[i].getServiceStatView(service);
                    if (serviceStatView != null) return serviceStatView;
                }
            }
        }
        return serviceStatView;
    };

    CategoryStatView.prototype.getCategoryStatViewById = function (id) {
        if (this.categoryStatViews[id] != undefined) return this.categoryStatViews[id];else return null;
    };
    CategoryStatView.prototype.getServiceStatViewById = function (id) {
        if (this.serviceStatViews[id] != undefined) return this.serviceStatViews[id];else return null;
    };

    CategoryStatView.prototype.clearValues = function () {
        this.clearPrices();
        this.clearNbBookings();
    };
    CategoryStatView.prototype.clearPrices = function () {
        this.ca = 0;
        for (var i = 0; i < this.serviceStatViews.length; i++) {
            this.serviceStatViews[i].ca = 0;
            this.serviceStatViews[i].bookingServices = [];
            this.serviceStatViews[i].saleServices = [];
        }
        for (i = 0; i < this.categoryStatViews.length; i++) {
            this.categoryStatViews[i].clearPrices();
        }
    };
    CategoryStatView.prototype.clearNbBookings = function () {
        this.nbBookingsOrSales = 0;
        for (var i = 0; i < this.serviceStatViews.length; i++) {
            this.serviceStatViews[i].nbBookingsOrSales = 0;
        }for (i = 0; i < this.categoryStatViews.length; i++) {
            this.categoryStatViews[i].clearNbBookings();
        }
    };

    return CategoryStatView;
}]);

/***/ }),

/***/ 505:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by mathieudeumie on 22/07/2014.
 */

angular.module('FlexyBeautyApp.services').factory('CureCategoryStatView', ["CureStatView", function (CureStatView) {
    var CureCategoryStatView = function CureCategoryStatView(cureCategory, parentCategoryStatView) {
        this.label = "";
        this.nbBookingsOrSales = 0;
        this.color = null; //null -> color generation
        this.parentCategoryStatView = parentCategoryStatView;

        this.equivalentCureCategory = cureCategory;

        this.cureCategoryStatViews = [];
        this.cureStatViews = [];
        this.globalCureStatViews = [];

        this.ca = 0;

        if (cureCategory) this.loadData(cureCategory);
    };

    CureCategoryStatView.prototype.addCureStatView = function (cureStatView) {
        if (cureStatView != undefined && cureStatView != null) {
            this.cureStatViews.push(cureStatView);
            this.addGlobalCureStatView(cureStatView);
        }
    };
    CureCategoryStatView.prototype.addGlobalCureStatView = function (cureStatView) {
        if (cureStatView != undefined && cureStatView != null) {
            if (this.globalCureStatViews.indexOf(cureStatView) == -1) this.globalCureStatViews.push(cureStatView);
            if (this.parentCategoryStatView) this.parentCategoryStatView.addGlobalCureStatView(cureStatView);
        }
    };
    CureCategoryStatView.prototype.addCureCategoryStatView = function (cureCategoryStatView) {
        if (cureCategoryStatView != undefined && cureCategoryStatView != null) this.cureCategoryStatViews.push(cureCategoryStatView);
    };
    CureCategoryStatView.prototype.loadData = function (cureCategory) {
        this.setColor(cureCategory);
        this.label = cureCategory.label;
        for (var i = 0; i < cureCategory.categories.length; i++) {
            var newCureCategoryStatViewFille = new CureCategoryStatView(cureCategory.categories[i], this);
            this.addCureCategoryStatView(newCureCategoryStatViewFille);
        }
        for (i = 0; i < cureCategory.cures.length; i++) {
            var newCureStatView = new CureStatView(cureCategory.cures[i], this);
            this.addCureStatView(newCureStatView);
        }
    };

    CureCategoryStatView.prototype.setColor = function (category) {
        if (category.style == null && category.parentCategory != undefined && category.parentCategory != null) this.setColor(category.parentCategory);
        if (category.style != null && category.style.indexOf("background") != -1) {
            var index = category.style.indexOf("\"", category.style.indexOf("background") + 13);
            if (index != -1) this.color = category.style.substr(category.style.indexOf("background") + 13, index - category.style.indexOf("background") - 13);else this.color = category.style.substr(category.style.indexOf("background") + 13, 7);
            if (this.color == "white") //inverse for visibility
                this.color = "black";
        }
    };

    CureCategoryStatView.prototype.setPricesFromSales = function (sales) {
        // Set ca values for cureCategoryViews / cureStatViews / customers
        var price;
        for (var i = 0; i < sales.length; i++) {
            if (sales[i].status == "sold" || sales[i].status == "credit" || sales[i].status == "canceled") for (var j = 0; j < sales[i].saleCures.length; j++) {

                var cureStatView = this.getCureStatView(sales[i].saleCures[j].cure);
                if (cureStatView != null) {
                    //if(sales[i].saleCures[j].humanResource) // if bookingCure is not affected to an Hr
                    {
                        // set CA to cureStatViews
                        price = sales[i].saleCures[j].price - sales[i].saleCures[j].price * sales[i].discountPercent / 100;
                        cureStatView.ca += price;
                        // set CA to cureCategoryStatViews
                        cureStatView.parentCategoryStatView.setValuesToParentCategories(price);
                        if (sales[i].status == "sold" || sales[i].status == "canceled") cureStatView.nbBookingsOrSales += sales[i].saleCures[j].quantity;else cureStatView.nbBookingsOrSales -= sales[i].saleCures[j].quantity;
                        cureStatView.saleCures.push(sales[i].saleCures[j]);
                    }
                }
            }
        }
    };
    CureCategoryStatView.prototype.setValuesToParentCategories = function (ca) {
        this.ca += ca;
        this.nbBookingsOrSales++;
        if (this.parentCategoryStatView != null) this.parentCategoryStatView.setValuesToParentCategories(ca);
    };

    CureCategoryStatView.prototype.getCureStatView = function (cure) {
        var cureStatView = null;
        if (cure) {
            for (var i = 0; i < this.cureStatViews.length; i++) {
                if (this.cureStatViews[i].cureId == cure.id) cureStatView = this.cureStatViews[i];
            }
            if (cureStatView == null && this.cureCategoryStatViews.length > 0) {
                for (i = 0; i < this.cureCategoryStatViews.length; i++) {
                    cureStatView = this.cureCategoryStatViews[i].getCureStatView(cure);
                    if (cureStatView != null) return cureStatView;
                }
            }
        }
        return cureStatView;
    };

    CureCategoryStatView.prototype.getCureCategoryStatViewById = function (id) {
        if (this.cureCategoryStatViews[id] != undefined) return this.cureCategoryStatViews[id];else return null;
    };
    CureCategoryStatView.prototype.getCureStatViewById = function (id) {
        if (this.cureStatViews[id] != undefined) return this.cureStatViews[id];else return null;
    };

    CureCategoryStatView.prototype.clearValues = function () {
        this.clearPrices();
        this.clearNbBookings();
    };
    CureCategoryStatView.prototype.clearPrices = function () {
        this.ca = 0;
        for (var i = 0; i < this.cureStatViews.length; i++) {
            this.cureStatViews[i].ca = 0;
            this.cureStatViews[i].bookingCures = [];
            this.cureStatViews[i].saleCures = [];
        }
        for (i = 0; i < this.cureCategoryStatViews.length; i++) {
            this.cureCategoryStatViews[i].clearPrices();
        }
    };
    CureCategoryStatView.prototype.clearNbBookings = function () {
        this.nbBookingsOrSales = 0;
        for (var i = 0; i < this.cureStatViews.length; i++) {
            this.cureStatViews[i].nbBookingsOrSales = 0;
        }for (i = 0; i < this.cureCategoryStatViews.length; i++) {
            this.cureCategoryStatViews[i].clearNbBookings();
        }
    };

    return CureCategoryStatView;
}]);

/***/ }),

/***/ 506:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by mathieudeumie on 22/07/2014.
 */

angular.module('FlexyBeautyApp.services').factory('CureStatView', ["$filter", function ($filter) {
    var CureStatView = function CureStatView(cure, parentCategoryStatView) {
        this.label = "";
        this.ca = 0;
        this.nbBookings = 0;
        this.parentCategoryStatView = parentCategoryStatView;
        this.cureId = 0;

        this.saleCures = []; // [{dayId, saleCure, price},...]

        if (cure) {
            this.label = cure.label;
            this.cureId = cure.id;
        }
    };

    return CureStatView;
}]);

/***/ }),

/***/ 507:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by mathieudeumie on 04/08/2014.
 */

angular.module('FlexyBeautyApp.services').factory('CustomerStatView', ["CustomerData", function (CustomerData) {
    var CustomerStatView = function CustomerStatView(booking, sale) {
        if (booking) {
            if (booking.customer) {
                this.id = booking.customer.id;
                this.ca = 0;
                this.averagePrice = 0;

                this.equivalentCustomer = booking.customer;
                this.globalCa = 0;
                this.globalAveragePrice = 0;

                this.firstName = booking.customer.firstName;
                this.lastName = booking.customer.lastName;
                if (booking.customer.bookings && booking.customer.bookings.length != 0) this.idOfFirstBookingDay = booking.customer.bookings[0].day.id;else this.idOfFirstBookingDay = -1;
            } else {
                this.id = -1;
                this.ca = 0;
                this.averagePrice = 0;

                this.equivalentCustomer = null;
                this.globalCa = 0;
                this.globalAveragePrice = 0;

                this.firstName = "Client de passage";
                this.lastName = "";
                this.idOfFirstBookingDay = -1;
                this.listOfBookings = [];
                this.listOfSales = [];
            }
            if (booking.bookingServices.length > 0) {
                this.listOfBookings = [booking];
                this.setCa();
                this.setAveragePrice();
                this.setGlobalValues();
            }
        } else if (sale) {
            this.listOfSales = [];
            if (sale.customer) {
                this.id = sale.customer.id;
                this.ca = 0;
                this.globalNbSales = 0;
                this.averagePrice = 0;

                this.equivalentCustomer = sale.customer;
                this.globalCa = 0;
                this.globalAveragePrice = 0;

                this.firstName = sale.customer.firstName;
                this.lastName = sale.customer.lastName;
                this.idOfFirstSaleDay = sale.customer.sales[0].day.id;
            } else {
                this.id = -1;
                this.ca = 0;
                this.averagePrice = 0;

                this.equivalentCustomer = null;
                this.globalCa = 0;
                this.globalAveragePrice = 0;

                this.firstName = "Client de passage";
                this.lastName = "";
                this.idOfFirstSaleDay = -1;
                this.listOfBookings = [];
            }
            if (sale.saleServices.length > 0 || sale.saleProducts.length > 0) {
                this.listOfSales = [sale];
                this.setCa();
                this.setAveragePrice();
                this.setGlobalValues();
            }
        } else {
            this.id = -10;
            this.ca = 0;
            this.averagePrice = 0;

            this.equivalentCustomer = null;
            this.globalCa = 0;
            this.globalAveragePrice = 0;

            this.firstName = "";
            this.lastName = "";
            this.idOfFirstBookingDay = -10;
            this.listOfBookings = [];
            this.listOfSales = [];
        }
    };

    CustomerStatView.prototype.getModel = function () {
        if (this.id != -1) return CustomerData.getById(this.id);
        return null;
    };
    CustomerStatView.prototype.addBooking = function (booking) {
        if (booking && this.listOfBookings) {
            this.listOfBookings.push(booking);
            this.setCa();
            this.setAveragePrice();
        }
    };
    CustomerStatView.prototype.addSale = function (sale) {
        if (sale && this.listOfSales) {
            this.listOfSales.push(sale);
            this.setCa();
            this.setAveragePrice();
        }
    };
    CustomerStatView.prototype.getCa = function () {
        return this.ca;
    };
    CustomerStatView.prototype.setCa = function () {
        this.ca = 0;
        if (this.listOfBookings) for (var i = 0; i < this.listOfBookings.length; i++) {
            this.ca += this.listOfBookings[i].price;
        }if (this.listOfSales) for (var i = 0; i < this.listOfSales.length; i++) {
            this.ca += this.listOfSales[i].price;
        }
    };
    CustomerStatView.prototype.isOld = function (period) // array of day
    {
        if (this.id === -1) // Client de passage is new by default
            return false;
        if (period[0]) return this.idOfFirstSaleDay < period[0].id;else return false; // case of opening month of institute : customer is new
    };
    CustomerStatView.prototype.getName = function () {
        return this.firstName + " " + this.lastName;
    };
    CustomerStatView.prototype.getAveragePrice = function () {
        return this.averagePrice;
    };
    CustomerStatView.prototype.setAveragePrice = function () {
        if (this.listOfBookings && this.listOfBookings.length != 0) this.averagePrice = Math.round(this.ca / this.listOfBookings.length * 100) / 100;else if (this.listOfSales && this.listOfSales.length != 0) this.averagePrice = Math.round(this.ca / this.listOfSales.length * 100) / 100;
    };
    CustomerStatView.prototype.getGlobalCa = function () {
        return this.globalCa;
    };
    CustomerStatView.prototype.getGlobalNbBookings = function () {
        return this.equivalentCustomer.bookings.length;
    };
    CustomerStatView.prototype.getGlobalAveragePrice = function () {
        return this.globalAveragePrice;
    };
    CustomerStatView.prototype.setGlobalValues = function () {
        this.globalCa = 0;
        if (this.listOfSales && this.equivalentCustomer) {
            this.globalNbSales = 0;
            for (var i = 0; i < this.equivalentCustomer.sales.length; i++) {
                var sale = this.equivalentCustomer.sales[i];
                if (sale.status == "sold") {
                    this.globalCa += sale.price;
                    this.globalNbSales++;
                }
            }
            this.globalAveragePrice = Math.round(this.globalCa / this.globalNbSales * 100) / 100;
        } else if (this.listOfBookings && this.equivalentCustomer) {
            for (var i = 0; i < this.equivalentCustomer.bookings.length; i++) {
                var booking = this.equivalentCustomer.bookings[i];
                this.globalCa += booking.price;
            }
            this.globalAveragePrice = Math.round(this.globalCa / this.getGlobalNbBookings() * 100) / 100;
        }
    };

    return CustomerStatView;
}]);

/***/ }),

/***/ 508:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by mathieudeumie on 04/08/2014.
 */

angular.module('FlexyBeautyApp.services').factory('HumanResourceStatView', [function () {
    var HumanResourceStatView = function HumanResourceStatView(id, label, firstName, lastName, hasPlanning) {
        if (id) this.id = id;else this.id = 0;
        if (label) this.label = label;else this.label = "";
        if (firstName) this.firstName = firstName;else this.firstName = "";
        if (label) this.lastName = lastName;else this.lastName = "";
        this.ca = 0;
        this.caServices = 0;
        this.caProducts = 0;
        this.caCures = 0;
        this.caGiftItems = 0;
        this.caLoyaltyCards = 0;
        this.occupationRates = [];
        this.nbBookings = 0;
        this.nbSales = 0;
        this.hasPlanning = hasPlanning;
    };

    HumanResourceStatView.prototype.getOccupationRate = function () {
        var rate = 0;
        for (var i = 0; i < this.occupationRates.length; i++) {
            rate += this.occupationRates[i];
        }
        if (this.occupationRates.length > 0) return Math.round(rate / this.occupationRates.length * 100) / 100;else return 0;
    };

    HumanResourceStatView.prototype.cleanData = function () {
        this.cleanOccupationRate();
        this.cleanNbBookings();
        this.cleanNbSales();
        this.cleanCa();
    };
    HumanResourceStatView.prototype.cleanOccupationRate = function () {
        this.occupationRates = [];
    };
    HumanResourceStatView.prototype.cleanNbBookings = function () {
        this.nbBookings = 0;
    };
    HumanResourceStatView.prototype.cleanNbSales = function () {
        this.nbSales = 0;
    };
    HumanResourceStatView.prototype.cleanCa = function () {
        this.ca = 0;
        this.caServices = 0;
        this.caProducts = 0;
        this.caCures = 0;
        this.caGiftItems = 0;
        this.caLoyaltyCards = 0;
    };

    return HumanResourceStatView;
}]);

/***/ }),

/***/ 509:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by mathieudeumie on 22/07/2014.
 */

angular.module('FlexyBeautyApp.services').factory('LoyaltyCardCategoryStatView', ["LoyaltyCardStatView", function (LoyaltyCardStatView) {
    var LoyaltyCardCategoryStatView = function LoyaltyCardCategoryStatView(loyaltyCardCategory, parentCategoryStatView) {
        this.label = "";
        this.nbBookingsOrSales = 0;
        this.color = null; //null -> color generation
        this.parentCategoryStatView = parentCategoryStatView;

        this.equivalentLoyaltyCardCategory = loyaltyCardCategory;

        this.loyaltyCardCategoryStatViews = [];
        this.loyaltyCardStatViews = [];
        this.globalLoyaltyCardStatViews = [];

        this.ca = 0;

        if (loyaltyCardCategory) this.loadData(loyaltyCardCategory);
    };

    LoyaltyCardCategoryStatView.prototype.addLoyaltyCardStatView = function (loyaltyCardStatView) {
        if (loyaltyCardStatView != undefined && loyaltyCardStatView != null) {
            this.loyaltyCardStatViews.push(loyaltyCardStatView);
            this.addGlobalLoyaltyCardStatView(loyaltyCardStatView);
        }
    };
    LoyaltyCardCategoryStatView.prototype.addGlobalLoyaltyCardStatView = function (loyaltyCardStatView) {
        if (loyaltyCardStatView != undefined && loyaltyCardStatView != null) {
            if (this.globalLoyaltyCardStatViews.indexOf(loyaltyCardStatView) == -1) this.globalLoyaltyCardStatViews.push(loyaltyCardStatView);
            if (this.parentCategoryStatView) this.parentCategoryStatView.addGlobalLoyaltyCardStatView(loyaltyCardStatView);
        }
    };
    LoyaltyCardCategoryStatView.prototype.addLoyaltyCardCategoryStatView = function (loyaltyCardCategoryStatView) {
        if (loyaltyCardCategoryStatView != undefined && loyaltyCardCategoryStatView != null) this.loyaltyCardCategoryStatViews.push(loyaltyCardCategoryStatView);
    };
    LoyaltyCardCategoryStatView.prototype.loadData = function (loyaltyCardCategory) {
        this.setColor(loyaltyCardCategory);
        this.label = loyaltyCardCategory.label;
        for (var i = 0; i < loyaltyCardCategory.categories.length; i++) {
            var newLoyaltyCardCategoryStatViewFille = new LoyaltyCardCategoryStatView(loyaltyCardCategory.categories[i], this);
            this.addLoyaltyCardCategoryStatView(newLoyaltyCardCategoryStatViewFille);
        }
        for (i = 0; i < loyaltyCardCategory.loyaltyCards.length; i++) {
            var newLoyaltyCardStatView = new LoyaltyCardStatView(loyaltyCardCategory.loyaltyCards[i], this);
            this.addLoyaltyCardStatView(newLoyaltyCardStatView);
        }
    };

    LoyaltyCardCategoryStatView.prototype.setColor = function (category) {
        if (category.style == null && category.parentCategory != undefined && category.parentCategory != null) this.setColor(category.parentCategory);
        if (category.style != null && category.style.indexOf("background") != -1) {
            var index = category.style.indexOf("\"", category.style.indexOf("background") + 13);
            if (index != -1) this.color = category.style.substr(category.style.indexOf("background") + 13, index - category.style.indexOf("background") - 13);else this.color = category.style.substr(category.style.indexOf("background") + 13, 7);
            if (this.color == "white") //inverse for visibility
                this.color = "black";
        }
    };

    LoyaltyCardCategoryStatView.prototype.setPricesFromSales = function (sales) {
        // Set ca values for loyaltyCardCategoryViews / loyaltyCardStatViews / customers
        var price;
        for (var i = 0; i < sales.length; i++) {
            if (sales[i].status == "sold" || sales[i].status == "credit" || sales[i].status == "canceled") for (var j = 0; j < sales[i].loyaltyCardItems.length; j++) {

                var loyaltyCardStatView = this.getLoyaltyCardStatView(sales[i].loyaltyCardItems[j].loyaltyCard);
                if (loyaltyCardStatView != null) {
                    //if(sales[i].loyaltyCardItems[j].humanResource) // if bookingLoyaltyCard is not affected to an Hr
                    {
                        // set CA to loyaltyCardStatViews
                        price = sales[i].loyaltyCardItems[j].price - sales[i].loyaltyCardItems[j].price * sales[i].discountPercent / 100;
                        loyaltyCardStatView.ca += price;
                        // set CA to loyaltyCardCategoryStatViews
                        loyaltyCardStatView.parentCategoryStatView.setValuesToParentCategories(price);
                        if (sales[i].status == "sold" || sales[i].status == "canceled") loyaltyCardStatView.nbBookingsOrSales += 1;else loyaltyCardStatView.nbBookingsOrSales -= 1;
                        loyaltyCardStatView.loyaltyCardItems.push(sales[i].loyaltyCardItems[j]);
                    }
                }
            }
        }
    };
    LoyaltyCardCategoryStatView.prototype.setValuesToParentCategories = function (ca) {
        this.ca += ca;
        this.nbBookingsOrSales++;
        if (this.parentCategoryStatView != null) this.parentCategoryStatView.setValuesToParentCategories(ca);
    };

    LoyaltyCardCategoryStatView.prototype.getLoyaltyCardStatView = function (loyaltyCard) {
        var loyaltyCardStatView = null;
        if (loyaltyCard) {
            for (var i = 0; i < this.loyaltyCardStatViews.length; i++) {
                if (this.loyaltyCardStatViews[i].loyaltyCardId == loyaltyCard.id) loyaltyCardStatView = this.loyaltyCardStatViews[i];
            }
            if (loyaltyCardStatView == null && this.loyaltyCardCategoryStatViews.length > 0) {
                for (i = 0; i < this.loyaltyCardCategoryStatViews.length; i++) {
                    loyaltyCardStatView = this.loyaltyCardCategoryStatViews[i].getLoyaltyCardStatView(loyaltyCard);
                    if (loyaltyCardStatView != null) return loyaltyCardStatView;
                }
            }
        }
        return loyaltyCardStatView;
    };

    LoyaltyCardCategoryStatView.prototype.getLoyaltyCardCategoryStatViewById = function (id) {
        if (this.loyaltyCardCategoryStatViews[id] != undefined) return this.loyaltyCardCategoryStatViews[id];else return null;
    };
    LoyaltyCardCategoryStatView.prototype.getLoyaltyCardStatViewById = function (id) {
        if (this.loyaltyCardStatViews[id] != undefined) return this.loyaltyCardStatViews[id];else return null;
    };

    LoyaltyCardCategoryStatView.prototype.clearValues = function () {
        this.clearPrices();
        this.clearNbBookings();
    };
    LoyaltyCardCategoryStatView.prototype.clearPrices = function () {
        this.ca = 0;
        for (var i = 0; i < this.loyaltyCardStatViews.length; i++) {
            this.loyaltyCardStatViews[i].ca = 0;
            this.loyaltyCardStatViews[i].bookingLoyaltyCards = [];
            this.loyaltyCardStatViews[i].loyaltyCardItems = [];
        }
        for (i = 0; i < this.loyaltyCardCategoryStatViews.length; i++) {
            this.loyaltyCardCategoryStatViews[i].clearPrices();
        }
    };
    LoyaltyCardCategoryStatView.prototype.clearNbBookings = function () {
        this.nbBookingsOrSales = 0;
        for (var i = 0; i < this.loyaltyCardStatViews.length; i++) {
            this.loyaltyCardStatViews[i].nbBookingsOrSales = 0;
        }for (i = 0; i < this.loyaltyCardCategoryStatViews.length; i++) {
            this.loyaltyCardCategoryStatViews[i].clearNbBookings();
        }
    };

    return LoyaltyCardCategoryStatView;
}]);

/***/ }),

/***/ 510:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by mathieudeumie on 22/07/2014.
 */

angular.module('FlexyBeautyApp.services').factory('LoyaltyCardStatView', ["$filter", function ($filter) {
    var LoyaltyCardStatView = function LoyaltyCardStatView(loyaltyCard, parentCategoryStatView) {
        this.label = "";
        this.ca = 0;
        this.nbBookings = 0;
        this.parentCategoryStatView = parentCategoryStatView;
        this.loyaltyCardId = 0;

        this.loyaltyCardItems = []; // [{dayId, loyaltyCardItemCard, price},...]

        if (loyaltyCard) {
            this.label = loyaltyCard.label;
            this.loyaltyCardId = loyaltyCard.id;
        }
    };

    return LoyaltyCardStatView;
}]);

/***/ }),

/***/ 511:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by mathieudeumie on 22/07/2014.
 */

angular.module('FlexyBeautyApp.services').factory('MenuStatView', ["$filter", function ($filter) {
    var MenuStatView = function MenuStatView(view, code, label, parent, $scope) {
        this.view = view;
        this.code = code;
        this.label = label;
        this.scope = $scope;
        this.parentMenuStatView = parent;
        this.menuStatsView = [];
        this.object = null;
        this.icon = "fa-chevron-right";
        this.tab = 1;
        this.sort = "";
        this.sortReverse = false;
    };

    MenuStatView.prototype.getByCode = function (code) //
    {
        if (this.code == code) return this;
        var menu = null;
        for (var i = 0; i < this.menuStatsView.length && !menu; i++) {
            menu = this.menuStatsView[i].getByCode(code);
        }return menu;
    };
    MenuStatView.prototype.getByObject = function (object) //
    {
        if (this.object === object) return this;
        var menu = null;
        for (var i = 0; i < this.menuStatsView.length && !menu; i++) {
            menu = this.menuStatsView[i].getByObject(object);
        }return menu;
    };
    MenuStatView.prototype.getSum = function () {
        var sum = 0;
        for (var i = 0; i < this.menuStatsView.length; i++) {
            if (this.menuStatsView[i].object) {
                sum += this.menuStatsView[i].object.ca;
            }
        }return sum;
    };
    return MenuStatView;
}]);

/***/ }),

/***/ 512:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by mathieudeumie on 22/07/2014.
 */

angular.module('FlexyBeautyApp.services').factory('ProductCategoryStatView', ["ProductStatView", function (ProductStatView) {
    var ProductCategoryStatView = function ProductCategoryStatView(productCategory, parentCategoryStatView) {
        this.label = "";
        this.productCategoryId = null;
        this.nbBookingsOrSales = 0;
        this.color = null; //null -> color generation
        this.parentCategoryStatView = parentCategoryStatView;

        this.equivalentProductCategory = productCategory;

        this.productCategoryStatViews = [];
        this.productStatViews = [];
        this.globalProductStatViews = [];

        this.ca = 0;

        if (productCategory) this.loadData(productCategory);
    };

    ProductCategoryStatView.prototype.addProductStatView = function (productStatView) {
        if (productStatView != undefined && productStatView != null) {
            this.productStatViews.push(productStatView);
            this.addGlobalProductStatView(productStatView);
        }
    };
    ProductCategoryStatView.prototype.addGlobalProductStatView = function (productStatView) {
        if (productStatView != undefined && productStatView != null) {
            if (this.globalProductStatViews.indexOf(productStatView) == -1) this.globalProductStatViews.push(productStatView);
            if (this.parentCategoryStatView) this.parentCategoryStatView.addGlobalProductStatView(productStatView);
        }
    };
    ProductCategoryStatView.prototype.addProductCategoryStatView = function (productCategoryStatView) {
        if (productCategoryStatView != undefined && productCategoryStatView != null) this.productCategoryStatViews.push(productCategoryStatView);
    };
    ProductCategoryStatView.prototype.loadData = function (productCategory) {
        this.productCategoryId = productCategory.id;
        this.setColor(productCategory);
        this.label = productCategory.label;
        for (var i = 0; i < productCategory.categories.length; i++) {
            var newProductCategoryStatViewFille = new ProductCategoryStatView(productCategory.categories[i], this);
            this.addProductCategoryStatView(newProductCategoryStatViewFille);
        }
        for (i = 0; i < productCategory.products.length; i++) {
            var newProductStatView = new ProductStatView(productCategory.products[i], this);
            this.addProductStatView(newProductStatView);
        }
    };

    ProductCategoryStatView.prototype.setColor = function (category) {
        if (category.style == null && category.parentCategory != undefined && category.parentCategory != null) this.setColor(category.parentCategory);
        if (category.style != null && category.style.indexOf("background") != -1) {
            var index = category.style.indexOf("\"", category.style.indexOf("background") + 13);
            if (index != -1) this.color = category.style.substr(category.style.indexOf("background") + 13, index - category.style.indexOf("background") - 13);else this.color = category.style.substr(category.style.indexOf("background") + 13, 7);
            if (this.color == "white") //inverse for visibility
                this.color = "black";
        }
    };

    ProductCategoryStatView.prototype.setPricesFromSales = function (sales) {
        // Set ca values for productCategoryViews / productStatViews / customers
        var price;
        for (var i = 0; i < sales.length; i++) {
            if (sales[i].status == "sold" || sales[i].status == "credit" || sales[i].status == "canceled") for (var j = 0; j < sales[i].saleProducts.length; j++) {

                var productStatView = this.getProductStatView(sales[i].saleProducts[j].product);
                if (!productStatView) if (sales[i].saleProducts[j].product && sales[i].saleProducts[j].product.parentCategory) {
                    var productCategoryStatView = this.getProductCategoryStatView(sales[i].saleProducts[j].product.parentCategory);
                    if (!productCategoryStatView) {
                        if (sales[i].saleProducts[j].product.parentCategory.parentCategory) //try to add category
                            {
                                var parentCat = this.getProductCategoryStatView(sales[i].saleProducts[j].product.parentCategory.parentCategory);
                                if (parentCat) {
                                    productCategoryStatView = new ProductCategoryStatView(sales[i].saleProducts[j].product.parentCategory, parentCat);
                                    parentCat.addProductCategoryStatView(productCategoryStatView);
                                    productStatView = this.getProductStatView(sales[i].saleProducts[j].product);
                                }
                            }
                    }
                    if (productCategoryStatView && !productStatView) {
                        productStatView = new ProductStatView(sales[i].saleProducts[j].product, productCategoryStatView);
                        productCategoryStatView.addProductStatView(productStatView);
                    }
                } else {
                    productStatView = this.getProductStatViewByLabel(sales[i].saleProducts[j].label);
                    if (!productStatView) {
                        productStatView = new ProductStatView(null, this);
                        productStatView.label = sales[i].saleProducts[j].label;
                        this.addProductStatView(productStatView);
                    }
                }

                if (productStatView != null) {
                    //if(sales[i].saleProducts[j].humanResource) // online payment don't have hr
                    {
                        // set CA to productStatViews
                        price = sales[i].saleProducts[j].price - sales[i].saleProducts[j].price * sales[i].discountPercent / 100;
                        productStatView.ca += price;
                        // set CA to productCategoryStatViews
                        productStatView.parentCategoryStatView.setValuesToParentCategories(price);
                        if (sales[i].status == "sold" || sales[i].status == "canceled") productStatView.nbBookingsOrSales += sales[i].saleProducts[j].quantity;else productStatView.nbBookingsOrSales -= sales[i].saleProducts[j].quantity;
                        productStatView.saleProducts.push(sales[i].saleProducts[j]);
                    }
                }
            }
        }
    };
    ProductCategoryStatView.prototype.setValuesToParentCategories = function (ca) {
        this.ca += ca;
        this.nbBookingsOrSales++;
        if (this.parentCategoryStatView != null) this.parentCategoryStatView.setValuesToParentCategories(ca);
    };

    ProductCategoryStatView.prototype.getProductStatView = function (product) {
        var productStatView = null;
        if (product) {
            for (var i = 0; i < this.productStatViews.length; i++) {
                if (this.productStatViews[i].productId == product.id) productStatView = this.productStatViews[i];
            }
            if (productStatView == null && this.productCategoryStatViews.length > 0) {
                for (i = 0; i < this.productCategoryStatViews.length; i++) {
                    productStatView = this.productCategoryStatViews[i].getProductStatView(product);
                    if (productStatView != null) return productStatView;
                }
            }
        }
        return productStatView;
    };

    ProductCategoryStatView.prototype.getProductStatViewByLabel = function (label) {
        var productStatView = null;
        if (label) {
            for (var i = 0; i < this.productStatViews.length; i++) {
                if (this.productStatViews[i].label == label) productStatView = this.productStatViews[i];
            }
            if (productStatView == null && this.productCategoryStatViews.length > 0) {
                for (i = 0; i < this.productCategoryStatViews.length; i++) {
                    productStatView = this.productCategoryStatViews[i].getProductStatViewByLabel(label);
                    if (productStatView != null) return productStatView;
                }
            }
        }
        return productStatView;
    };

    ProductCategoryStatView.prototype.getProductCategoryStatView = function (productCategory) {
        var productStatView = null;
        if (productCategory) {
            if (productCategory.id == this.productCategoryId) return this;

            for (var i = 0; i < this.productCategoryStatViews.length; i++) {
                productStatView = this.productCategoryStatViews[i].getProductCategoryStatView(productCategory);
                if (productStatView != null) return productStatView;
            }
        }
        return productStatView;
    };

    ProductCategoryStatView.prototype.getProductCategoryStatViewById = function (id) {
        if (this.productCategoryStatViews[id] != undefined) return this.productCategoryStatViews[id];else return null;
    };
    ProductCategoryStatView.prototype.getProductStatViewById = function (id) {
        if (this.productStatViews[id] != undefined) return this.productStatViews[id];else return null;
    };

    ProductCategoryStatView.prototype.clearValues = function () {
        this.clearPrices();
        this.clearNbBookings();
    };
    ProductCategoryStatView.prototype.clearPrices = function () {
        this.ca = 0;
        for (var i = 0; i < this.productStatViews.length; i++) {
            this.productStatViews[i].ca = 0;
            this.productStatViews[i].saleProducts = [];
        }
        for (i = 0; i < this.productCategoryStatViews.length; i++) {
            this.productCategoryStatViews[i].clearPrices();
        }
    };
    ProductCategoryStatView.prototype.clearNbBookings = function () {
        this.nbBookingsOrSales = 0;
        for (var i = 0; i < this.productStatViews.length; i++) {
            this.productStatViews[i].nbBookingsOrSales = 0;
        }for (i = 0; i < this.productCategoryStatViews.length; i++) {
            this.productCategoryStatViews[i].clearNbBookings();
        }
    };

    return ProductCategoryStatView;
}]);

/***/ }),

/***/ 513:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by mathieudeumie on 22/07/2014.
 */

angular.module('FlexyBeautyApp.services').factory('ProductStatView', ["$filter", function ($filter) {
    var ProductStatView = function ProductStatView(product, parentCategoryStatView) {
        this.label = "";
        this.ca = 0;
        this.nbSales = 0;
        this.parentCategoryStatView = parentCategoryStatView;
        this.productId = 0;

        this.saleProducts = []; // [{dayId, saleProduct, price},...]

        if (product) {
            this.label = product.label;
            this.productId = product.id;
        }
    };

    return ProductStatView;
}]);

/***/ }),

/***/ 514:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by mathieudeumie on 22/07/2014.
 */

angular.module('FlexyBeautyApp.services').factory('ServiceStatView', ["$filter", function ($filter) {
    var ServiceStatView = function ServiceStatView(service, parentCategoryStatView) {
        this.label = "";
        this.ca = 0;
        this.nbBookings = 0;
        this.parentCategoryStatView = parentCategoryStatView;
        this.serviceId = 0;

        this.bookingServices = []; // [{dayId, bookingService, price},...]
        this.saleServices = []; // [{dayId, saleService, price},...]

        if (service) {
            this.label = service.label;
            this.serviceId = service.id;
        }
    };

    return ServiceStatView;
}]);

/***/ }),

/***/ 515:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by cedricgodefroy on 18/07/2017.
 */
/**
 * Created by cedricgodefroy on 18/07/2017.
 */
angular.module('FlexyBeautyApp.services').factory('DashboardSchedulerView', ["DashboardScheduler", "DashboardSchedulerData", "DashboardSchedulerSrv", function (DashboardScheduler, DashboardSchedulerData, DashboardSchedulerSrv) {
    var DashboardSchedulerView = function DashboardSchedulerView(dashboardSchedulerModel, dashboardSchedulerIndex) {
        this.dashboardSchedulerIndex = dashboardSchedulerIndex;
        this.id = "";
        this.surname = null;
        this.type = null;
        this.object = null;
        this.message = null;
        this.dashboardId = null;
        this.sendTo = [];
        this.editMode = false;
        this.displayEmptyEmail = false;
        this.displayEmptyObject = false;
        this.displayEmptyMessage = false;
        this.displayEmptySurname = false;

        if (dashboardSchedulerModel) {
            this.loadDataFrom(dashboardSchedulerModel);
        }
    };

    DashboardSchedulerView.prototype.loadDataFrom = function (dashboardSchedulerModel) {
        this.id = dashboardSchedulerModel.id;
        this.surname = dashboardSchedulerModel.surname;
        this.type = dashboardSchedulerModel.type;
        this.object = dashboardSchedulerModel.object;
        this.message = dashboardSchedulerModel.message;
        this.sendTo = [];
        for (var i = 0; i < dashboardSchedulerModel.sendTo.length; i++) {
            this.sendTo.push({ text: dashboardSchedulerModel.sendTo[i] });
        }
        this.dashboardId = dashboardSchedulerModel.dashboardId;
    };

    DashboardSchedulerView.prototype.isChanged = function () {
        var isSendToChanged = false,
            dashboardSchedulerModel = this.getModel();
        if (dashboardSchedulerModel && dashboardSchedulerModel.sendTo.length === this.sendTo.length) {
            for (var i = 0; i < dashboardSchedulerModel.sendTo.length && !isSendToChanged; i++) {
                if (this.sendTo[i].text !== dashboardSchedulerModel.sendTo[i]) {
                    isSendToChanged = true;
                }
            }
        } else {
            isSendToChanged = true;
        }
        if (dashboardSchedulerModel) {
            return this.type !== dashboardSchedulerModel.type || this.object !== dashboardSchedulerModel.object || this.message !== dashboardSchedulerModel.message || isSendToChanged || this.surname !== dashboardSchedulerModel.surname;
        } else {
            return true;
        }
    };

    DashboardSchedulerView.prototype.copyDataTo = function (dashboardScheduler) {
        dashboardScheduler.type = this.type;
        dashboardScheduler.object = this.object;
        dashboardScheduler.message = this.message;
        dashboardScheduler.dashboardId = this.dashboardId;
        dashboardScheduler.surname = this.surname;
        dashboardScheduler.sendTo = [];
        for (var i = 0; i < this.sendTo.length; i++) {
            dashboardScheduler.sendTo.push(this.sendTo[i].text);
        }
    };

    DashboardSchedulerView.prototype.getModel = function () {
        if (this.dashboardSchedulerIndex != -1) {
            return DashboardSchedulerData.getByIndex(this.dashboardSchedulerIndex);
        }
        return null;
    };

    DashboardSchedulerView.prototype.updateModel = function (success, failure) {

        var dashboardScheduler = this.getModel();
        if (dashboardScheduler == null) {
            dashboardScheduler = new DashboardScheduler();
            this.dashboardSchedulerIndex = DashboardSchedulerData.getIndexOf(dashboardScheduler);
        }

        this.copyDataTo(dashboardScheduler);

        DashboardSchedulerSrv.save(dashboardScheduler, success, failure);
    };

    DashboardSchedulerView.prototype.getSendToList = function () {
        var sendToListe = null;
        for (var i = 0; i < this.sendTo.length; i++) {
            if (sendToListe == null) sendToListe = this.sendTo[i].text;else sendToListe += ", " + this.sendTo[i].text;
        }
        return sendToListe;
    };

    DashboardSchedulerView.prototype.reloadModel = function () {
        var dashboardScheduler = this.getModel();

        this.loadDataFrom(dashboardScheduler);
    };

    DashboardSchedulerView.prototype.canSave = function () {
        var canSave = true;

        if (!this.surname || this.surname == "") {
            canSave = false;
        }
        if (!this.sendTo || this.sendTo.length == 0) {
            canSave = false;
        }
        if (!this.object || this.object == "") {
            canSave = false;
        }
        return canSave;
    };

    DashboardSchedulerView.prototype.updateErrorEmail = function ($tag) {
        this.displayEmptyEmail = false;

        if (!this.sendTo || this.sendTo.length == 0) {
            this.displayEmptyEmail = true;
        }
    };

    DashboardSchedulerView.prototype.updateErrorObject = function ($tag) {
        this.displayEmptyObject = false;

        if (!this.object || this.object == "") {
            this.displayEmptyObject = true;
        }
    };

    DashboardSchedulerView.prototype.updateErrorSurname = function ($tag) {
        this.displayEmptySurname = false;

        if (!this.surname || this.surname == "") {
            this.displayEmptySurname = true;
        }
    };

    DashboardSchedulerView.prototype.updateError = function ($tag) {
        this.displayEmptyEmail = false;
        this.displayEmptyObject = false;
        this.displayEmptySurname = false;

        if (!this.sendTo || this.sendTo.length == 0) {
            this.displayEmptyEmail = true;
        }
        if (!this.object || this.object == "") {
            this.displayEmptyObject = true;
        }
        if (!this.surname || this.surname == "") {
            this.displayEmptySurname = true;
        }
    };

    return DashboardSchedulerView;
}]);

/***/ }),

/***/ 516:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by cedricgodefroy on 18/07/2017.
 */
angular.module('FlexyBeautyApp.services').factory('DashboardStatView', ["$dialog", "ReportView", "DashboardSrv", "DashboardData", "Dashboard", "ReportModelData", "TaxMode", "gettextCatalog", "DashboardSchedulerView", "DashboardSchedulerData", function ($dialog, ReportView, DashboardSrv, DashboardData, Dashboard, ReportModelData, TaxMode, gettextCatalog, DashboardSchedulerView, DashboardSchedulerData) {
    var DashboardStatView = function DashboardStatView(dashboard, dashboardIndex, functionSolutionActivated, startModelId) {
        this.dashboardIndex = dashboardIndex;
        this.reportsView = [];
        this.dashboardSchedulersView = [];
        this.id = null;
        this.title = this.defaultTitle;
        this.titleMouseover = false;
        this.titleFocus = false;
        this.editing = false;
        this.isFlexy = false;
        this.dashboardModel = dashboard;

        if (dashboard) {
            this.loadDataFrom(dashboard, functionSolutionActivated, startModelId);
        }
    };

    var myNewTable = gettextCatalog.getString("Mon nouveau tableau de bord");
    DashboardStatView.prototype.defaultTitle = myNewTable;

    DashboardStatView.prototype.loadDataFrom = function (datas, functionSolutionActivated, startModelId) {
        this.id = datas.id;
        this.title = datas.title;

        this.isFlexy = datas.isFlexy;

        var reports = angular.fromJson(datas.jsonDetail);

        this.reportsView = [];
        if (reports) {
            for (var i = 0; i < reports.length; i++) {
                var reportModel = ReportModelData.getById(reports[i].reportModelId);
                if (reportModel) {
                    var reportView = new ReportView(reportModel, reports[i].reportChanges, this.taxMode, functionSolutionActivated, startModelId);
                    this.reportsView.push(reportView);
                }
            }
        }
        if (datas.dashboardSchedulers) {
            for (var i = 0; i < datas.dashboardSchedulers.length; i++) {
                var dashboardSchedulerView = new DashboardSchedulerView(datas.dashboardSchedulers[i], DashboardSchedulerData.getIndexOf(datas.dashboardSchedulers[i]));
                this.dashboardSchedulersView.push(dashboardSchedulerView);
            }
        }
    };

    DashboardStatView.prototype.addReport = function (reportView) {
        var cloneReport = reportView.getClone(),
            currentCategorieId = null,
            currentCategoryType = null;

        if (reportView.getDataSource().currentPath.length > 1) {
            currentCategorieId = reportView.getDataSource().currentPath[reportView.getDataSource().currentPath.length - 1].id;
        }
        if (reportView.getDataSource().currentPath.length > 1) {
            currentCategoryType = reportView.getDataSource().currentPath[reportView.getDataSource().currentPath.length - 1].constructor ? reportView.getDataSource().currentPath[reportView.getDataSource().currentPath.length - 1].constructor.name : null;
        }

        cloneReport.createDataSource(reportView.taxMode, currentCategorieId, currentCategoryType);
        cloneReport.getDataSource().loadPeriod(reportView.getDataSource().currentPeriod, reportView.getDataSource().selectedPastPeriod, reportView.getDataSource().taxMode);
        this.reportsView.push(cloneReport);
    };

    DashboardStatView.prototype.removeReport = function (reportView) {
        var indexToRemove = this.reportsView.indexOf(reportView);

        if (indexToRemove != -1) {
            this.reportsView.splice(indexToRemove, 1);
        }
    };

    DashboardStatView.prototype.moveRight = function (reportView) {
        var index = this.reportsView.indexOf(reportView);

        this.reportsView.splice(index, 1);

        this.reportsView.splice(index + 1, 0, reportView);
    };

    DashboardStatView.prototype.moveLeft = function (reportView) {
        var index = this.reportsView.indexOf(reportView);

        this.reportsView.splice(index, 1);
        this.reportsView.splice(index - 1, 0, reportView);
    };
    DashboardStatView.prototype.moveToIndex = function (indexOld, indexTarget) {
        if (indexOld >= 0 && indexOld < this.reportsView.length && indexTarget >= 0 && indexTarget < this.reportsView.length && indexOld != indexTarget) {
            var reportView = this.reportsView[indexOld];
            this.reportsView.splice(indexOld, 1);
            this.reportsView.splice(indexTarget, 0, reportView);
        }
    };

    DashboardStatView.prototype.hasReport = function (reportView) {
        var hasReport = this.reportsView.indexOf(reportView) != -1 ? true : false;
        return hasReport;
    };

    DashboardStatView.prototype.getReport = function (reportId) {
        var reportsView = null;
        for (var i = 0; i < this.reportsView.length; i++) {
            if (this.reportsView[i].id === reportId) {
                reportsView = this.reportsView[i];
                break;
            }
        }
        return reportsView;
    };

    DashboardStatView.prototype.updateModel = function (endFunction) {
        var dashboard = this.getModel();

        if (dashboard == null) {
            dashboard = new Dashboard();
            this.dashboardIndex = DashboardData.getIndexOf(dashboard);
            this.dashboardModel = dashboard;
        }

        this.copyDataTo(dashboard);

        DashboardSrv.save(dashboard, endFunction);
    };

    DashboardStatView.prototype.copyDataTo = function (dashboard) {
        dashboard.title = this.title;

        var reports = new Array();

        for (var i = 0; i < this.reportsView.length; i++) {
            var userChanges = this.reportsView[i].getChanges();

            var report = {
                reportModelId: this.reportsView[i].reportModelId,
                reportChanges: userChanges
            };
            reports.push(report);
            this.reportsView[i].userChanges = userChanges;
        }

        dashboard.jsonDetail = angular.toJson(reports);
    };

    DashboardStatView.prototype.getModel = function () {
        if (this.dashboardIndex != -1) {
            return DashboardData.getByIndex(this.dashboardIndex);
        }
        return null;
    };

    DashboardStatView.prototype.removeModel = function () {
        var dashboard = this.getModel();
        if (dashboard != null) DashboardSrv.remove(dashboard);
    };

    DashboardStatView.prototype.reloadModel = function (functionSolutionActivated, startModelId) {
        var dashboard = this.getModel();
        if (dashboard != null) {
            this.loadDataFrom(dashboard, functionSolutionActivated, startModelId);
        }
    };

    DashboardStatView.prototype.isChanged = function () {
        if (this.dashboardModel) {
            var isReportChanged = false;

            var reportsFromDashboardModel = angular.fromJson(this.dashboardModel.jsonDetail);

            for (var i = 0; i < this.reportsView.length && isReportChanged === false; i++) {
                isReportChanged = isReportChanged || this.reportsView[i].isChanged() || reportsFromDashboardModel[i] == null || reportsFromDashboardModel[i] != null && reportsFromDashboardModel[i].reportModelId !== this.reportsView[i].reportModelId;
            }

            var isDashboardSchedulerChanged = false;

            for (var i = 0; i < this.dashboardSchedulersView.length && isDashboardSchedulerChanged === false; i++) {
                isDashboardSchedulerChanged = isDashboardSchedulerChanged || this.dashboardSchedulersView[i].isChanged();
            }

            return this.title != this.dashboardModel.title || isReportChanged || isDashboardSchedulerChanged;
        } else {
            return true;
        }
    };

    DashboardStatView.prototype.isNavigationChanged = function () {
        var isNavigationChanged = false;
        for (var i = 0; i < this.reportsView.length; i++) {
            isNavigationChanged = isNavigationChanged || this.reportsView[i].isNavigationChanged();
        }
        return isNavigationChanged;
    };

    DashboardStatView.prototype.onTaxModeChange = function (newTaxMode) {
        this.taxMode = newTaxMode;
        for (var i = 0; i < this.reportsView.length; i++) {
            this.reportsView[i].getDataSource().changeTaxMode(this.taxMode);
        }
    };

    DashboardStatView.prototype.hasCurrencyReport = function (newTaxMode) {
        var hasCurrencyReport = false;
        for (var i = 0; i < this.reportsView.length; i++) {
            if (this.reportsView[i].typeOfData == 'currency') {
                hasCurrencyReport = true;
                break;
            }
        }
        return hasCurrencyReport;
    };

    DashboardStatView.prototype.removeDashboardScheduler = function (dashboardSchedulerView) {
        var index = this.dashboardSchedulersView.indexOf(dashboardSchedulerView);
        if (index != -1) this.dashboardSchedulersView.splice(index, 1);
    };

    return DashboardStatView;
}]);

/***/ }),

/***/ 517:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by cedricgodefroy on 18/07/2017.
 */
/**
 * Created by cedricgodefroy on 18/07/2017.
 */
angular.module('FlexyBeautyApp.services').factory('DataSourceFactory', ['ReportDatasSource', 'ReportTemporalAgregateFunctionType', 'Day', 'RootStatCategorie', 'TypeOfSale', 'HrRootOccupationRateCategory', 'PrRootOccupationRateCategory', 'CategoryData', 'NbCustormerCategoryStat', 'HrRootCategory', 'TypeOfBooking', 'GiftItemRootCategory', 'LoyaltyCustomers', 'LoyaltyPeriodDataSource', 'GiftItemByHrRootCategory', 'ReportTotalAgregateFunctionType', 'WorkingTimeRootCategory', 'TypeOfCustomerRootCategory', 'ProductStatCategorie', function (ReportDatasSource, ReportTemporalAgregateFunctionType, Day, RootStatCategorie, TypeOfSale, HrRootOccupationRateCategory, PrRootOccupationRateCategory, CategoryData, NbCustormerCategoryStat, HrRootCategory, TypeOfBooking, GiftItemRootCategory, LoyaltyCustomers, LoyaltyPeriodDataSource, GiftItemByHrRootCategory, ReportTotalAgregateFunctionType, WorkingTimeRootCategory, TypeOfCustomerRootCategory, ProductStatCategorie) {
    var DataSourceFactory = function () {
        var instance;

        var constructeur = function constructeur() {
            this.createDataSource = function (idReportModel, currentCategorieLabel, currentCategoryType, taxMode, typeOfData) {
                var dataSource = null;

                switch (idReportModel) {
                    case "ca":
                        dataSource = new ReportDatasSource(idReportModel, Day.prototype.getSalesCaOfSaleObject, null, ReportTemporalAgregateFunctionType.DAILY_SUM, ReportTotalAgregateFunctionType.SUM_CATEGORIES, Day.prototype.getSubSalesOfSaleObject, RootStatCategorie, currentCategorieLabel, currentCategoryType, taxMode, typeOfData);
                        break;
                    case "ca-by-personnal":
                        dataSource = new ReportDatasSource(idReportModel, Day.prototype.getAverageSalesCaByWorkerOfSaleObject, null, ReportTotalAgregateFunctionType.SUM_CATEGORIES, ReportTemporalAgregateFunctionType.DAILY_SUM, Day.prototype.getSubSalesOfSaleObject, RootStatCategorie, currentCategorieLabel, currentCategoryType, taxMode, typeOfData);
                        break;
                    case "daily-average-ca-by-personnal":
                        dataSource = new ReportDatasSource(idReportModel, Day.prototype.getAverageSalesCaByWorkerOfSaleObject, null, ReportTemporalAgregateFunctionType.DAILY_AVERAGE, ReportTotalAgregateFunctionType.SUM_CATEGORIES, Day.prototype.getSubSalesOfSaleObject, RootStatCategorie, currentCategorieLabel, currentCategoryType, taxMode, typeOfData);
                        break;
                    case "nb-sales":
                        dataSource = new ReportDatasSource(idReportModel, Day.prototype.getNbSubSalesOfSaleObject, null, ReportTemporalAgregateFunctionType.DAILY_SUM, ReportTotalAgregateFunctionType.SUM_CATEGORIES, Day.prototype.getSubSalesOfSaleObject, RootStatCategorie, currentCategorieLabel, currentCategoryType, taxMode, typeOfData);
                        break;
                    case "nb-sales-by-personnal":
                        dataSource = new ReportDatasSource(idReportModel, Day.prototype.getAverageNbSubSalesByWorkerOfSaleObject, null, ReportTemporalAgregateFunctionType.DAILY_SUM, ReportTotalAgregateFunctionType.SUM_CATEGORIES, Day.prototype.getSubSalesOfSaleObject, RootStatCategorie, currentCategorieLabel, currentCategoryType, taxMode, typeOfData);
                        break;
                    case "daily-average-nb-sales-by-personnal":
                        dataSource = new ReportDatasSource(idReportModel, Day.prototype.getAverageNbSubSalesByWorkerOfSaleObject, null, ReportTemporalAgregateFunctionType.DAILY_AVERAGE, ReportTotalAgregateFunctionType.SUM_CATEGORIES, Day.prototype.getSubSalesOfSaleObject, RootStatCategorie, currentCategorieLabel, currentCategoryType, taxMode, typeOfData);
                        break;
                    case "daily-average-nb-visits-by-personnal":
                        dataSource = new ReportDatasSource(idReportModel, Day.prototype.getAverageNbSalesByWorkerOfSaleObject, null, ReportTemporalAgregateFunctionType.DAILY_AVERAGE, ReportTotalAgregateFunctionType.SUM_CATEGORIES, Day.prototype.getSalesOfSaleObject, NbCustormerCategoryStat, currentCategorieLabel, currentCategoryType, taxMode, typeOfData);
                        break;
                    case "old-customer":
                        dataSource = new ReportDatasSource(idReportModel, Day.prototype.getNbSubSalesOldCustomerOfSaleObject, null, ReportTemporalAgregateFunctionType.DAILY_SUM, ReportTotalAgregateFunctionType.SUM_CATEGORIES, Day.prototype.getSubSalesOldCustomerOfSaleObject, RootStatCategorie, currentCategorieLabel, currentCategoryType, taxMode, typeOfData);
                        break;
                    case "new-customer":
                        dataSource = new ReportDatasSource(idReportModel, Day.prototype.getNbSubSalesNewCustomerOfSaleObject, null, ReportTemporalAgregateFunctionType.DAILY_SUM, ReportTotalAgregateFunctionType.SUM_CATEGORIES, Day.prototype.getSubSalesNewCustomerOfSaleObject, RootStatCategorie, currentCategorieLabel, currentCategoryType, taxMode, typeOfData);
                        break;
                    case "ticket-prd":
                        dataSource = new ReportDatasSource(idReportModel, Day.prototype.getNbSalesOfSaleObject, Day.prototype.getNbSalesWithServiceOrProduct, ReportTemporalAgregateFunctionType.DAILY_SUM, ReportTotalAgregateFunctionType.SUM_CATEGORIES, Day.prototype.getSalesOfSaleObject, TypeOfSale.ALL_WITH_PRODUCT_OR_NOT, currentCategorieLabel, currentCategoryType, taxMode, typeOfData);
                        break;
                    case "hr-occupation-rate":
                        dataSource = new ReportDatasSource(idReportModel, Day.prototype.getBookingTimeOfHrObject, Day.prototype.getWorkingTimeOfHrObject, ReportTemporalAgregateFunctionType.DAILY_SUM, ReportTotalAgregateFunctionType.AVERAGE_CATEGORIES, Day.prototype.getSubBookingsStepOfBookingObject, HrRootOccupationRateCategory, currentCategorieLabel, currentCategoryType, taxMode, typeOfData);
                        break;
                    case "pr-occupation-rate":
                        dataSource = new ReportDatasSource(idReportModel, Day.prototype.getBookingTimeOfPrObject, Day.prototype.getWorkingTimeOfPrObject, ReportTemporalAgregateFunctionType.DAILY_SUM, ReportTotalAgregateFunctionType.AVERAGE_CATEGORIES, Day.prototype.getSubBookingsStepOfBookingObject, PrRootOccupationRateCategory, currentCategorieLabel, currentCategoryType, taxMode, typeOfData);
                        break;
                    case "sale-by-hr":
                        dataSource = new ReportDatasSource(idReportModel, Day.prototype.getSalesCaOfSaleObject, null, ReportTemporalAgregateFunctionType.DAILY_SUM, ReportTotalAgregateFunctionType.SUM_CATEGORIES, Day.prototype.getSubSalesStepOfSaleObject, HrRootCategory, currentCategorieLabel, currentCategoryType, taxMode, typeOfData);
                        break;
                    case "gift-by-hr":
                        dataSource = new ReportDatasSource(idReportModel, Day.prototype.getSalesCaOfSaleObject, null, ReportTemporalAgregateFunctionType.DAILY_SUM, ReportTotalAgregateFunctionType.SUM_CATEGORIES, Day.prototype.getSubSalesOfSaleObject, GiftItemByHrRootCategory, currentCategorieLabel, currentCategoryType, taxMode, typeOfData);
                        break;
                    case "gain-by-minute":
                        dataSource = new ReportDatasSource(idReportModel, Day.prototype.getSalesCaOfSaleObject, Day.prototype.getDurationOfSaleObject, ReportTemporalAgregateFunctionType.DAILY_SUM, ReportTotalAgregateFunctionType.AVERAGE_CATEGORIES, Day.prototype.getSubSalesOfSaleObject, CategoryData.categoryRoot, currentCategorieLabel, currentCategoryType, taxMode, typeOfData);
                        break;
                    case "nb-customers":
                        dataSource = new ReportDatasSource(idReportModel, Day.prototype.getNbVisitsOfSaleObject, null, ReportTemporalAgregateFunctionType.DAILY_SUM, ReportTotalAgregateFunctionType.SUM_CATEGORIES, Day.prototype.getVisitsOfSaleObject, NbCustormerCategoryStat, currentCategorieLabel, currentCategoryType, taxMode, typeOfData);
                        break;
                    case "average-cart":
                        dataSource = new ReportDatasSource(idReportModel, Day.prototype.getSalesCaOfSaleObject, Day.prototype.getNbSoldSalesWithoutGift, ReportTemporalAgregateFunctionType.DAILY_SUM, ReportTotalAgregateFunctionType.SUM_CATEGORIES, Day.prototype.getSubSalesOfSaleObject, RootStatCategorie, currentCategorieLabel, currentCategoryType, taxMode, typeOfData);
                        break;
                    case "average-cart-by-gender":
                        dataSource = new ReportDatasSource(idReportModel, Day.prototype.getSalesCaOfSaleObject, Day.prototype.getNbSoldSalesOfSaleObject, ReportTemporalAgregateFunctionType.DAILY_SUM, ReportTotalAgregateFunctionType.SUM_CATEGORIES, Day.prototype.getSalesOfSaleObject, NbCustormerCategoryStat, currentCategorieLabel, currentCategoryType, taxMode, typeOfData);
                        break;
                    case "average-cart-gift":
                        dataSource = new ReportDatasSource(idReportModel, Day.prototype.getSalesCaOfSaleObject, Day.prototype.getNbSalesWithGift, ReportTemporalAgregateFunctionType.DAILY_SUM, ReportTotalAgregateFunctionType.SUM_CATEGORIES, Day.prototype.getSubSalesOfSaleObject, GiftItemRootCategory, currentCategorieLabel, currentCategoryType, taxMode, typeOfData);
                        break;
                    case "custormer-come":
                        dataSource = new ReportDatasSource(idReportModel, Day.prototype.getNbBookingsOfBookingObject, null, ReportTemporalAgregateFunctionType.DAILY_SUM, ReportTotalAgregateFunctionType.SUM_CATEGORIES, Day.prototype.getBookingsOfBookingObject, TypeOfBooking.COME_AND_NOT_COME, currentCategorieLabel, currentCategoryType, taxMode, typeOfData);
                        break;
                    case "not-honored-booking":
                        dataSource = new ReportDatasSource(idReportModel, Day.prototype.getBookingsCAOfBookingObject, null, ReportTemporalAgregateFunctionType.DAILY_SUM, ReportTotalAgregateFunctionType.SUM_CATEGORIES, Day.prototype.getBookingsOfBookingObject, TypeOfBooking.NOT_COME, currentCategorieLabel, currentCategoryType, taxMode, typeOfData);
                        break;
                    case "booking-in-line":
                        dataSource = new ReportDatasSource(idReportModel, Day.prototype.getNbBookingsOfBookingObject, null, ReportTemporalAgregateFunctionType.DAILY_SUM, ReportTotalAgregateFunctionType.SUM_CATEGORIES, Day.prototype.getBookingsOfBookingObject, TypeOfBooking.CREATE_BY_CUSTORMER_AND_NOT, currentCategorieLabel, currentCategoryType, taxMode, typeOfData);
                        break;
                    case "giftItem":
                        dataSource = new ReportDatasSource(idReportModel, Day.prototype.getSalesCaOfSaleObject, null, ReportTemporalAgregateFunctionType.DAILY_SUM, ReportTotalAgregateFunctionType.SUM_CATEGORIES, Day.prototype.getSubSalesOfSaleObject, GiftItemRootCategory, currentCategorieLabel, currentCategoryType, taxMode, typeOfData);
                        break;
                    case "fidelity-collaborator-rate":
                        dataSource = new ReportDatasSource(idReportModel, null, {}, null, null, null, LoyaltyCustomers, currentCategorieLabel, currentCategoryType, taxMode, typeOfData, LoyaltyPeriodDataSource);
                        break;
                    case "working-time":
                        dataSource = new ReportDatasSource(idReportModel, Day.prototype.getOccupationDatasOfHrObject, null, ReportTemporalAgregateFunctionType.DAILY_SUM, ReportTotalAgregateFunctionType.SUM_CATEGORIES, Day.prototype.getHrOccupationPrimaryDatas, WorkingTimeRootCategory, currentCategorieLabel, currentCategoryType, taxMode, typeOfData, null, true);
                        break;
                    case "old-and-new-customer":
                        dataSource = new ReportDatasSource(idReportModel, Day.prototype.getNbFirstCustomersOfSaleObject, null, ReportTemporalAgregateFunctionType.DAILY_SUM, ReportTotalAgregateFunctionType.SUM_CATEGORIES, Day.prototype.getCustomersFirstOfSaleObject, TypeOfCustomerRootCategory, currentCategorieLabel, currentCategoryType, taxMode, typeOfData);
                        break;
                    case "visits-by-collab":
                        dataSource = new ReportDatasSource(idReportModel, Day.prototype.getNbVisitsOfSaleObject, null, ReportTemporalAgregateFunctionType.DAILY_SUM, ReportTotalAgregateFunctionType.SUM_CATEGORIES, Day.prototype.getVisitsOfSaleObject, HrRootOccupationRateCategory, currentCategorieLabel, currentCategoryType, taxMode, typeOfData);
                        break;
                    case "products-ca":
                        dataSource = new ReportDatasSource(idReportModel, Day.prototype.getSalesCaOfSaleObject, Day.prototype.getSalesCaTotal, ReportTemporalAgregateFunctionType.DAILY_SUM, ReportTotalAgregateFunctionType.SUM_CATEGORIES, Day.prototype.getSubSalesOfSaleObject, ProductStatCategorie.ALL, currentCategorieLabel, currentCategoryType, taxMode, typeOfData);
                        break;
                    case "sales-by-visit":
                        dataSource = new ReportDatasSource(idReportModel, Day.prototype.getNbSubSalesOfSaleObject, Day.prototype.getNbSalesTotal, ReportTemporalAgregateFunctionType.DAILY_SUM, ReportTotalAgregateFunctionType.NO_AGREGATION, Day.prototype.getSubSalesOfSaleObject, RootStatCategorie, currentCategorieLabel, currentCategoryType, taxMode, typeOfData);
                        break;
                    case "penetration-rate":
                        dataSource = new ReportDatasSource(idReportModel, Day.prototype.getNbFirstCustomersOfSaleObject, Day.prototype.getTotalFirstCustomers, ReportTemporalAgregateFunctionType.DAILY_SUM, ReportTotalAgregateFunctionType.NO_AGREGATION, Day.prototype.getSubSalesOfSaleObject, RootStatCategorie, currentCategorieLabel, currentCategoryType, taxMode, typeOfData);
                        break;
                    case "fidelity-rate":
                        dataSource = new ReportDatasSource(idReportModel, Day.prototype.getNbSubVisitsOfSaleObject, Day.prototype.getNbFirstCustomersOfSaleObject, ReportTemporalAgregateFunctionType.DAILY_SUM, ReportTotalAgregateFunctionType.NO_AGREGATION, Day.prototype.getVisitsOfSaleObject, RootStatCategorie, currentCategorieLabel, currentCategoryType, taxMode, typeOfData);
                        break;
                    case "daily-average-nb-sales":
                        dataSource = new ReportDatasSource(idReportModel, Day.prototype.getNbSubSalesOfSaleObject, null, ReportTemporalAgregateFunctionType.DAILY_AVERAGE, ReportTotalAgregateFunctionType.SUM_CATEGORIES, Day.prototype.getSubSalesOfSaleObject, RootStatCategorie, currentCategorieLabel, currentCategoryType, taxMode, typeOfData);
                        break;
                }
                return dataSource;
            };
        };

        return {
            getInstance: function getInstance() {
                if (!instance) {
                    instance = new constructeur();
                    instance.constructeur = null;
                }
                return instance;
            }
        };
    }();

    return DataSourceFactory;
}]);

/***/ }),

/***/ 518:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by cedricgodefroy on 22/11/2017.
 */
angular.module('FlexyBeautyApp.services').factory('LoyaltyPeriodDataSource', ['PeriodDatasSource', 'LoyaltyCustomers', '$log', function (PeriodDatasSource, LoyaltyCustomers, $log) {
    var LoyaltyPeriodDataSource = function LoyaltyPeriodDataSource(type, period, getDataPrototypeFunction1, getDataPrototypeFunction2, temporalAgregateFunctionType, totalAgregateFunctionType, getPrimaryDatasPrototypeFunction, categorieTable, currentPath, taxMode, typeOfData, additionalFilters) {
        this.nbPassageCustomers = 0;
        PeriodDatasSource.call(this, type, period, getDataPrototypeFunction1, getDataPrototypeFunction2, temporalAgregateFunctionType, totalAgregateFunctionType, getPrimaryDatasPrototypeFunction, categorieTable, currentPath, taxMode, typeOfData, additionalFilters);
    };
    LoyaltyPeriodDataSource.prototype = Object.create(PeriodDatasSource.prototype);

    LoyaltyPeriodDataSource.prototype.initDatas = function () {
        var periodCategoryCustomers = new Array(),
            periodCategoryPassageCustomers = new Array(),
            monthlyCategoryCustomers = new Array(),
            monthlyCategoryPassageCustomers = new Array(),
            monthlyCategoryLoyaltyCustomers = new Array(),
            currentMonthMoment = null,
            nbPeriodCurrentCategoryPassageCustomers = 0,
            periodCurrentCategoryLoyaltyCustomers = new Array(),
            periodCurrentCategoryCustomers = new Array();

        if (!this.primaryDatas) this.primaryDatas = new Array();

        for (var i = 0; i < this.categorieTable.length; i++) {
            this.statByCategory[this.categorieTable[i].id] = 0;

            periodCategoryCustomers[this.categorieTable[i].id] = new Array();
            periodCategoryPassageCustomers[this.categorieTable[i].id] = 0;

            monthlyCategoryCustomers[this.categorieTable[i].id] = new Array();
            monthlyCategoryPassageCustomers[this.categorieTable[i].id] = 0;
            monthlyCategoryLoyaltyCustomers[this.categorieTable[i].id] = new Array();
        }

        $log.debug(this.type);

        for (var i = 0; i < this.arrayOfDay.length; i++) {
            var day = this.arrayOfDay[i];

            if (day) {
                var momentMonthOfDay = day.getMomentDate().startOf('month');

                if (day.isAStatisticDay()) {
                    this.dailyDatas2[day.id] = new Array();

                    for (var j = 0; j < this.categorieTable.length; j++) {

                        // for the day and the category, we need to calcule :
                        //  - dailyCategoryCustomers : the customers of the day for the category
                        //  - nbDailyCategoryPassageCustomers : the number of passage customers of the day for the category
                        //  - dailyCategoryLoyaltyCustomers : the loyalty customers of the day for the category (customers of the day who are ever come with this category during the period before the current day)
                        //  - dailyCategoryNotLoyaltyCustomers : the non-loyalty customers of the day for the category (customers who are come for the first time with this category)
                        var dailyCategoryCustomers = day.getCustomersOfSaleObject([this.categorieTable[j]], this.additionalFilters, this.arrayOfDay[0], this.arrayOfDay[this.arrayOfDay.length - 1], this.taxMode),
                            nbDailyCategoryPassageCustomers = day.getNbPassageCustomersOfSaleObject([this.categorieTable[j]], this.additionalFilters, this.arrayOfDay[0], this.arrayOfDay[this.arrayOfDay.length - 1], this.taxMode),
                            dailyCategoryLoyaltyCustomers = day.getLoyaltyCustomersOfSaleObject([this.categorieTable[j]], this.additionalFilters, this.arrayOfDay[0], this.arrayOfDay[this.arrayOfDay.length - 1], this.taxMode),
                            dailyCategoryNotLoyaltyCustomers = new Array();

                        periodCategoryPassageCustomers[this.categorieTable[j].id] += nbDailyCategoryPassageCustomers;
                        monthlyCategoryPassageCustomers[this.categorieTable[j].id] += nbDailyCategoryPassageCustomers;

                        //with the dailyCategoryCustomers we popule :
                        //  - periodCategoryCustomers : the customers of the period for the category
                        //  - dailyCategoryNotLoyaltyCustomers : the not loyalty customers of the day
                        //  - monthlyCategoryCustomers : the customers of the month for the category
                        for (var k = 0; k < dailyCategoryCustomers.length; k++) {
                            if (dailyCategoryCustomers[k] && this.categorieTable[j] && !periodCategoryCustomers[this.categorieTable[j].id][dailyCategoryCustomers[k].id]) {
                                periodCategoryCustomers[this.categorieTable[j].id][dailyCategoryCustomers[k].id] = {
                                    customer: dailyCategoryCustomers[k],
                                    nbVisits: 0
                                };
                            }
                            if (dailyCategoryCustomers[k] && dailyCategoryLoyaltyCustomers.indexOf(dailyCategoryCustomers[k]) == -1) {
                                dailyCategoryNotLoyaltyCustomers.push(dailyCategoryCustomers[k]);
                            }
                            if (this.categorieTable[j] && dailyCategoryCustomers[k] && monthlyCategoryCustomers[this.categorieTable[j].id].indexOf(dailyCategoryCustomers[k]) == -1) {
                                monthlyCategoryCustomers[this.categorieTable[j].id].push(dailyCategoryCustomers[k]);
                            }
                            if (dailyCategoryCustomers[k]) periodCategoryCustomers[this.categorieTable[j].id][dailyCategoryCustomers[k].id].nbVisits++;
                        }

                        //with the dailyCategoryLoyaltyCustomers we popule :
                        //  - monthlyCategoryLoyaltyCustomers :
                        for (var k = 0; k < dailyCategoryLoyaltyCustomers.length; k++) {
                            if (monthlyCategoryLoyaltyCustomers[this.categorieTable[j].id].indexOf(dailyCategoryLoyaltyCustomers[i]) == -1) {
                                monthlyCategoryLoyaltyCustomers[this.categorieTable[j].id].push(dailyCategoryLoyaltyCustomers[i]);
                            }
                        }

                        //popule the datas of the day for the "analyse" tab
                        this.dailyDatas2[day.id][this.categorieTable[j].id] = dailyCategoryCustomers.length + nbDailyCategoryPassageCustomers != 0 ? dailyCategoryLoyaltyCustomers.length / (dailyCategoryCustomers.length + nbDailyCategoryPassageCustomers) : 0;

                        $log.debug(day.id + " " + this.categorieTable[j].label + "; clients : [" + this.tabCustomersToString(dailyCategoryCustomers) + "]" + "; nb clients de passage : " + nbDailyCategoryPassageCustomers + "; clients déjà venus : [" + this.tabCustomersToString(dailyCategoryLoyaltyCustomers) + "]" + "; clients venus une seule fois : [" + this.tabCustomersToString(dailyCategoryNotLoyaltyCustomers) + "]");
                    }

                    //for the day and all categories, we need to calcule :
                    //  - dailyCurrentCategoryCustomers : the customers of the day (all categories)
                    //  - dailyCurrentCategoryLoyaltyCustomers : the loyalty customers of the day (all categories) (customers of the day who are ever come during the period before the current day)
                    var dailyCurrentCategoryLoyaltyCustomers = day.getLoyaltyCustomersOfSaleObject([this.currentPath[this.currentPath.length - 1]], this.additionalFilters, this.arrayOfDay[0], this.arrayOfDay[this.arrayOfDay[0].length - 1], this.taxMode),
                        dailyCurrentCategoryCustomers = day.getCustomersOfSaleObject([this.currentPath[this.currentPath.length - 1]], this.additionalFilters, this.arrayOfDay[0], this.arrayOfDay[this.arrayOfDay[0].length - 1], this.taxMode);

                    //for the period and all categories, we need to calcule/populate :
                    //  - periodCurrentCategoryCustomers : the customers of the period
                    //  - periodCurrentCategoryLoyaltyCustomers : the loyalty customers of the period
                    //  - nbPeriodCurrentCategoryPassageCustomers : the number of passage customers

                    //calcul the number of passage customers of the period
                    nbPeriodCurrentCategoryPassageCustomers += day.getNbPassageCustomersOfSaleObject([this.currentPath[this.currentPath.length - 1]], this.additionalFilters, this.arrayOfDay[0], this.arrayOfDay[this.arrayOfDay[0].length - 1], this.taxMode);

                    //with the dailyCurrentCategoryCustomers we popule :
                    //  - the periodCurrentCategoryCustomers (table of all customers of the period)
                    for (var l = 0; l < dailyCurrentCategoryCustomers.length; l++) {
                        if (periodCurrentCategoryCustomers.indexOf(dailyCurrentCategoryCustomers[l]) == -1) {
                            periodCurrentCategoryCustomers.push(dailyCurrentCategoryCustomers[l]);
                        }
                    }

                    //with the dailyCurrentCategoryLoyaltyCustomers we popule :
                    //  - the periodCurrentCategoryLoyaltyCustomers (table of all loyalty customers of the period)
                    for (var l = 0; l < dailyCurrentCategoryLoyaltyCustomers.length; l++) {
                        if (periodCurrentCategoryLoyaltyCustomers.indexOf(dailyCurrentCategoryLoyaltyCustomers[l]) == -1) {
                            periodCurrentCategoryLoyaltyCustomers.push(dailyCurrentCategoryLoyaltyCustomers[l]);
                        }
                    }

                    //calcule primary datas for the case of loyalty customers
                    //we use the dailyCurrentCategoryLoyaltyCustomers in place of periodCurrentCategoryLoyaltyCustomers because we need to calculate the number of visits of each customer
                    //if (this.currentPath.indexOf(LoyaltyCustomers.subCategories.LOYALTY) != -1) {
                    for (var l = 0; l < dailyCurrentCategoryLoyaltyCustomers.length; l++) {
                        var indexLoyaltyCustomers = this.primaryDatas.indexOf(dailyCurrentCategoryLoyaltyCustomers[l]);

                        if (indexLoyaltyCustomers == -1) {
                            dailyCurrentCategoryLoyaltyCustomers[l].nbVisits = 2;
                            this.primaryDatas.push(dailyCurrentCategoryLoyaltyCustomers[l]);
                        } else {
                            this.primaryDatas[indexLoyaltyCustomers].nbVisits++;
                        }
                    }
                    //}

                    //change of month or init
                    if (!currentMonthMoment || currentMonthMoment && !currentMonthMoment.isSame(momentMonthOfDay) || currentMonthMoment && i === this.arrayOfDay.length - 1) {

                        //change of month : put tthe datas of the month in monthlyDatas and reinit variables
                        if (currentMonthMoment != null) {
                            var dayId = currentMonthMoment.format('YYYYMMDD');
                            this.monthlyDatas2[dayId] = new Array();

                            var monthArray = new Array();
                            monthArray.push(currentMonthMoment.toDate());

                            for (var j = 0; j < this.categorieTable.length; j++) {

                                //popule the datas of the day for the "analyse" tab
                                this.monthlyDatas2[dayId][this.categorieTable[j].id] = monthlyCategoryCustomers[this.categorieTable[j].id].length + monthlyCategoryPassageCustomers[this.categorieTable[j].id] != 0 ? monthlyCategoryLoyaltyCustomers[this.categorieTable[j].id].length / (monthlyCategoryCustomers[this.categorieTable[j].id].length + monthlyCategoryPassageCustomers[this.categorieTable[j].id]) : 0;
                            }

                            //initialisation of datas for the new month
                            monthlyCategoryCustomers = new Array();
                            monthlyCategoryLoyaltyCustomers = new Array();
                            for (var j = 0; j < this.categorieTable.length; j++) {
                                monthlyCategoryCustomers[this.categorieTable[j].id] = new Array();
                                monthlyCategoryLoyaltyCustomers[this.categorieTable[j].id] = new Array();
                                monthlyCategoryPassageCustomers[this.categorieTable[j].id] = 0;
                            }
                        }
                        currentMonthMoment = momentMonthOfDay;
                    }

                    this.nbDays += 1;
                }
            }
        }

        var sumOfcategories = 0;
        for (var j = 0; j < this.categorieTable.length; j++) {
            var periodCategoryLoyaltyCustomers = new Array(),
                periodCategoryNonLoyaltyCustomers = new Array(),
                statCategory = 0;

            for (var k in periodCategoryCustomers[this.categorieTable[j].id]) {
                if (periodCategoryCustomers[this.categorieTable[j].id][k].nbVisits > 1) {
                    periodCategoryLoyaltyCustomers.push(periodCategoryCustomers[this.categorieTable[j].id][k].customer);
                } else {
                    periodCategoryNonLoyaltyCustomers.push(periodCategoryCustomers[this.categorieTable[j].id][k].customer);
                }
            }

            $log.debug("Total " + this.categorieTable[j].label + "; nb clients de passage : " + periodCategoryPassageCustomers[this.categorieTable[j].id] + "; clients venus plusieurs fois : [" + this.tabCustomersToString(periodCategoryLoyaltyCustomers) + "]" + "; clients venus une seule fois : [" + this.tabCustomersToString(periodCategoryNonLoyaltyCustomers) + "]");

            statCategory = periodCategoryLoyaltyCustomers.length + periodCategoryNonLoyaltyCustomers.length + periodCategoryPassageCustomers[this.categorieTable[j].id] != 0 ? periodCategoryLoyaltyCustomers.length / (periodCategoryLoyaltyCustomers.length + periodCategoryNonLoyaltyCustomers.length + periodCategoryPassageCustomers[this.categorieTable[j].id]) : 0;;
            this.statByCategory[this.categorieTable[j].id] = statCategory;
            sumOfcategories += statCategory;
        }

        //calcule primary datas for the case of notloyalty customers
        var periodCurrentCategoryNotLoyaltyCustomers = new Array();
        for (var j = 0; j < periodCurrentCategoryCustomers.length; j++) {
            if (periodCurrentCategoryLoyaltyCustomers.indexOf(periodCurrentCategoryCustomers[j]) == -1) {
                periodCurrentCategoryNotLoyaltyCustomers.push(periodCurrentCategoryCustomers[j]);
            }
        }

        this.totalStat = this.categorieTable.length != 0 ? sumOfcategories / this.categorieTable.length : 0;
        this.nbPassageCustomers = nbPeriodCurrentCategoryPassageCustomers;

        this.getCustomers();
        this.sortDatas();
    };

    LoyaltyPeriodDataSource.prototype.tabCustomersToString = function (tabCustomer) {
        var tabString = "";
        for (var i = 0; i < tabCustomer.length; i++) {
            if (tabString != "") tabString = tabString + ", ";

            if (tabCustomer[i]) tabString = tabString + tabCustomer[i].firstName + " " + tabCustomer[i].lastName;
        }
        return tabString;
    };

    return LoyaltyPeriodDataSource;
}]);

/***/ }),

/***/ 519:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Created by cedricgodefroy on 23/08/2017.
 */
angular.module('FlexyBeautyApp.services').factory('PeriodDatasSource', ['ReportTemporalAgregateFunctionType', '$log', 'DayData', 'PrimaryDatasType', 'ReportTotalAgregateFunctionType', 'gettextCatalog', '$filter', function (ReportTemporalAgregateFunctionType, $log, DayData, PrimaryDatasType, ReportTotalAgregateFunctionType, gettextCatalog, $filter) {
    var PeriodDatasSource = function PeriodDatasSource(type, period, getDataPrototypeFunction1, getDataPrototypeFunction2, temporalAgregateFunctionType, totalAgregateFunctionType, getPrimaryDatasPrototypeFunction, categorieTable, currentPath, taxMode, typeOfData, additionalFilters) {

        if ( /*getDataPrototypeFunction1 &&*/period.arrayOfDays && categorieTable) {
            this.type = type + "-" + period.type.id;
            this.prototypeDailyFunction1 = getDataPrototypeFunction1;
            this.prototypeDailyFunction2 = getDataPrototypeFunction2;
            this.getPrimaryDatasPrototypeFunction = getPrimaryDatasPrototypeFunction;

            this.arrayOfDay = period.arrayOfDays;
            this.categorieTable = new Array();
            this.additionalFilters = additionalFilters ? additionalFilters : [];

            for (var i = 0; i < categorieTable.length; i++) {
                if (!categorieTable[i].statFilter || categorieTable[i].statFilter && categorieTable[i].statFilter(this.arrayOfDay) == true) {
                    this.categorieTable.push(categorieTable[i]);
                }
            }

            this.taxMode = taxMode;

            this.parentCategory = currentPath[currentPath.length - 1];
            this.currentPath = currentPath;

            this.stat1ByCategory = new Array();
            this.stat2ByCategory = new Array();

            this.statByCategory = new Array();

            this.totalStat1 = null;
            this.totalStat2 = null;

            this.totalStat = null;

            this.dailyDatas = new Array();
            this.dailyDatas2 = new Array();

            this.monthlyDatas = new Array();
            this.monthlyDatas2 = new Array();

            this.primaryDatas = null;
            this.detailDatas = new Array();

            this.customers = null;
            this.typeOfData = typeOfData;

            this.temporalAgregateFunctionType = temporalAgregateFunctionType;
            this.totalAgregateFunctionType = totalAgregateFunctionType;

            this.nbDays = 0;
            this.nbPassageCustomers = 0;
            this.initDatas();
        }
    };

    PeriodDatasSource.prototype.initDatas = function () {
        var monthlyStat1ByCategory = new Array(),
            monthlyStat2ByCategory = new Array(),
            nbPeriodCurrentCategoryPassageCustomers = 0;

        for (var i = 0; i < this.categorieTable.length; i++) {
            this.stat1ByCategory[this.categorieTable[i].id] = 0;
            this.stat2ByCategory[this.categorieTable[i].id] = 0;
            this.statByCategory[this.categorieTable[i].id] = 0;
            monthlyStat1ByCategory[this.categorieTable[i].id] = 0;
            monthlyStat2ByCategory[this.categorieTable[i].id] = 0;
        }

        var currentMonthMoment = null,
            monthArray = new Array();

        $log.debug(this.type);

        for (var i = 0; i < this.arrayOfDay.length; i++) {
            var day = this.arrayOfDay[i];

            if (day) {
                var momentMonthOfDay = day.getMomentDate().startOf('month');

                if (day.isAStatisticDay()) {

                    this.dailyDatas2[day.id] = new Array();

                    for (var j = 0; j < this.categorieTable.length; j++) {
                        var tabCategories = this.currentPath.concat([this.categorieTable[j]]);

                        var stat1 = this.prototypeDailyFunction1.apply(day, [tabCategories, this.additionalFilters, this.arrayOfDay[0], this.arrayOfDay[this.arrayOfDay.length - 1], this.taxMode]);
                        var stat2 = this.prototypeDailyFunction2 ? this.prototypeDailyFunction2.apply(day, [tabCategories, this.additionalFilters, this.arrayOfDay[0], this.arrayOfDay[this.arrayOfDay.length - 1], this.taxMode]) : null;

                        $log.debug(day.id + " " + this.categorieTable[j].label + " stat1 = " + stat1 + "; stat2 = " + stat2);
                        this.stat1ByCategory[this.categorieTable[j].id] += stat1;
                        monthlyStat1ByCategory[this.categorieTable[j].id] += stat1;

                        if (stat2) {
                            this.stat2ByCategory[this.categorieTable[j].id] += stat2;
                            monthlyStat2ByCategory[this.categorieTable[j].id] += stat2;
                        }

                        if (this.prototypeDailyFunction2) {
                            if (stat2 != 0) {
                                this.dailyDatas2[day.id][this.categorieTable[j].id] = stat1 / stat2 * (this.typeOfData == 'percent' ? 100 : 1);
                            } else {
                                //we put 0 in order to have one value by category (the 0 value is not visible in the graph)
                                this.dailyDatas2[day.id][this.categorieTable[j].id] = 0 * (this.typeOfData == 'percent' ? 100 : 1);
                            }
                        } else {
                            this.dailyDatas2[day.id][this.categorieTable[j].id] = stat1 * (this.typeOfData == 'percent' ? 100 : 1);
                        }
                    }

                    if (this.getPrimaryDatasPrototypeFunction) {
                        if (!this.primaryDatas) this.primaryDatas = new Array();
                        this.primaryDatas = this.primaryDatas.concat(this.getPrimaryDatasPrototypeFunction.apply(day, [this.currentPath, this.additionalFilters, this.arrayOfDay[0], this.arrayOfDay[this.arrayOfDay.length - 1], this.taxMode]));
                    }

                    this.nbDays += 1;
                }
            }

            if (this.getPrimaryDatasPrototypeFunction && this.currentPath[0] && this.currentPath[0].getSubStatCategories) {
                var firstCategories = this.currentPath[0].getSubStatCategories();
                if (firstCategories) {
                    for (var j = 0; j < firstCategories.length; j++) {
                        var tabCategories = [this.currentPath[0], firstCategories[j]],
                            catPrimaryData = this.getPrimaryDatasPrototypeFunction.apply(day, [tabCategories, this.additionalFilters, this.arrayOfDay[0], this.arrayOfDay[this.arrayOfDay.length - 1], this.taxMode]);

                        if (!Array.isArray(catPrimaryData) && (typeof catPrimaryData === 'undefined' ? 'undefined' : _typeof(catPrimaryData)) == "object") {
                            if (!this.detailDatas[firstCategories[j].id]) this.detailDatas[firstCategories[j].id] = {};
                            for (var prop in catPrimaryData) {

                                if (typeof catPrimaryData[prop] == "number") {
                                    if (!this.detailDatas[firstCategories[j].id][prop]) this.detailDatas[firstCategories[j].id][prop] = 0;

                                    this.detailDatas[firstCategories[j].id][prop] += catPrimaryData[prop];
                                }
                            }
                        } else {
                            if (Array.isArray(catPrimaryData)) {
                                if (!this.detailDatas[firstCategories[j].id]) this.detailDatas[firstCategories[j].id] = new Array();

                                this.detailDatas[firstCategories[j].id] = this.detailDatas[firstCategories[j].id].concat(this.getPrimaryDatasPrototypeFunction.apply(day, [tabCategories, this.additionalFilters, this.arrayOfDay[0], this.arrayOfDay[this.arrayOfDay.length - 1], this.taxMode]));
                            }
                        }
                    }
                }
            }

            //change of month or init
            if (!currentMonthMoment || currentMonthMoment && !currentMonthMoment.isSame(momentMonthOfDay) || currentMonthMoment && i === this.arrayOfDay.length - 1) {

                //change of month : put tthe datas of the month in monthlyDatas and reinit variables
                if (currentMonthMoment != null) {
                    var dayId = currentMonthMoment.format('YYYYMMDD');
                    this.monthlyDatas2[dayId] = new Array();

                    for (var j = 0; j < this.categorieTable.length; j++) {
                        if (this.prototypeDailyFunction2) {
                            if (monthlyStat2ByCategory[this.categorieTable[j].id] != 0) {
                                this.monthlyDatas2[dayId][this.categorieTable[j].id] = monthlyStat1ByCategory[this.categorieTable[j].id] / monthlyStat2ByCategory[this.categorieTable[j].id] * (this.typeOfData == 'percent' ? 100 : 1);
                            } else {
                                this.monthlyDatas2[dayId][this.categorieTable[j].id] = 0 * (this.typeOfData == 'percent' ? 100 : 1);
                            }
                        } else {
                            this.monthlyDatas2[dayId][this.categorieTable[j].id] = monthlyStat1ByCategory[this.categorieTable[j].id] * (this.typeOfData == 'percent' ? 100 : 1);
                        }
                    }

                    //initialisation of datas for the new month
                    monthlyStat1ByCategory = new Array();
                    monthlyStat2ByCategory = new Array();
                    for (var j = 0; j < this.categorieTable.length; j++) {
                        monthlyStat1ByCategory[this.categorieTable[j].id] = 0;
                        monthlyStat2ByCategory[this.categorieTable[j].id] = 0;
                    }
                }
                currentMonthMoment = momentMonthOfDay;
            }

            //calcul the number of passage customers of the period
            nbPeriodCurrentCategoryPassageCustomers += day.getNbPassageCustomersOfSaleObject([this.currentPath[this.currentPath.length - 1]], this.additionalFilters, this.arrayOfDay[0]);
        }

        $log.debug(this.stat1ByCategory);
        $log.debug(this.stat2ByCategory);

        if (!this.prototypeDailyFunction2) {
            var nbCatNotNull = 0;
            for (var i in this.stat1ByCategory) {

                if (this.temporalAgregateFunctionType === ReportTemporalAgregateFunctionType.DAILY_SUM) {
                    this.statByCategory[i] = this.stat1ByCategory[i];
                } else if (this.temporalAgregateFunctionType === ReportTemporalAgregateFunctionType.DAILY_AVERAGE && this.nbDays != 0) {
                    this.statByCategory[i] = this.stat1ByCategory[i] / this.nbDays;
                }

                this.totalStat += this.statByCategory[i];
                if (this.statByCategory[i] != 0) {
                    nbCatNotNull++;
                }
            }
            if (this.totalAgregateFunctionType === ReportTotalAgregateFunctionType.AVERAGE_CATEGORIES) {
                this.totalStat = this.totalStat / nbCatNotNull;
            }
        } else {
            var nbCat = 0;

            for (var i in this.stat1ByCategory) {
                var stat1BayCat = this.stat1ByCategory[i],
                    stat2BayCat = this.stat2ByCategory[i];

                if (this.temporalAgregateFunctionType === ReportTemporalAgregateFunctionType.DAILY_AVERAGE) {
                    stat1BayCat = stat1BayCat / this.nbDays;
                    stat2BayCat = stat2BayCat / this.nbDays;
                }

                var averageStat = null;

                if (stat2BayCat != 0) {
                    averageStat = stat1BayCat / stat2BayCat;

                    this.totalStat += averageStat;
                    nbCat++;
                }

                this.statByCategory[i] = averageStat;
            }

            if (this.totalAgregateFunctionType === ReportTotalAgregateFunctionType.AVERAGE_CATEGORIES) {
                this.totalStat = this.totalStat / nbCat;
            }
        }
        this.nbPassageCustomers = nbPeriodCurrentCategoryPassageCustomers;
        $log.debug(this.statByCategory);
        this.getCustomers();
        this.sortDatas();
    };

    PeriodDatasSource.prototype.sortDatas = function () {
        var me = this;
        //sort the datas
        this.categorieTable.sort(function (v1, v2) {
            return me.statByCategory[v2.id] - me.statByCategory[v1.id];
        });
        this.sortDailyDatas();
        this.sortMonthlyDatas();
    };

    PeriodDatasSource.prototype.sortMonthlyDatas = function () {
        var monthlyDatasFirstRow = new Array();
        monthlyDatasFirstRow.push({ id: 'jour', label: 'jour', type: 'date' });

        for (var i = 0; i < this.categorieTable.length; i++) {
            monthlyDatasFirstRow.push(this.categorieTable[i].label);
            monthlyDatasFirstRow.push({ type: 'string', role: 'tooltip', 'p': { 'html': true } });
        }
        this.monthlyDatas.push(monthlyDatasFirstRow);

        for (var dayId in this.monthlyDatas2) {
            var monthArray = new Array(),
                day = DayData.getById(dayId);
            if (day) {
                monthArray.push(DayData.getById(dayId).getDate());

                for (var j = 0; j < this.categorieTable.length; j++) {
                    var tooltipValue = null;
                    monthArray.push(this.monthlyDatas2[dayId][this.categorieTable[j].id]);

                    if (this.typeOfData === "percent") {
                        tooltipValue = "<div style='padding:5px;'><b>" + day.getMomentDate().format('L') + "</b><br/>" + gettextCatalog.getString(this.categorieTable[j].label) + " : " + $filter("smartNumber")(this.monthlyDatas2[dayId][this.categorieTable[j].id], 2) + "%</div>";
                    } else if (this.typeOfData === "currency") {
                        tooltipValue = "<div style='padding:5px;'><b>" + day.getMomentDate().format('L') + "</b><br/>" + gettextCatalog.getString(this.categorieTable[j].label) + " : " + $filter("currencyFormatFilter")(this.monthlyDatas2[dayId][this.categorieTable[j].id]) + "</div>";
                    } else if (this.typeOfData === "time") {
                        tooltipValue = "<div style='padding:5px;'><b>" + day.getMomentDate().format('L') + "</b><br/>" + gettextCatalog.getString(this.categorieTable[j].label) + " : " + $filter("shorterMinutesToTimeString")(this.monthlyDatas2[dayId][this.categorieTable[j].id]) + "</div>";
                    } else {
                        tooltipValue = "<div style='padding:5px;'><b>" + day.getMomentDate().format('L') + "</b><br/>" + gettextCatalog.getString(this.categorieTable[j].label) + " : " + $filter("smartNumber")(this.monthlyDatas2[dayId][this.categorieTable[j].id], 2) + " </div>";
                    }
                    monthArray.push(tooltipValue);
                }
                this.monthlyDatas.push(monthArray);
            }
        }
    };

    PeriodDatasSource.prototype.sortDailyDatas = function () {
        var dailyDatasFirstRow = new Array();
        dailyDatasFirstRow.push({ id: 'jour', label: 'jour', type: 'date' });

        for (var i = 0; i < this.categorieTable.length; i++) {
            dailyDatasFirstRow.push(this.categorieTable[i].label);
            dailyDatasFirstRow.push({ type: 'string', role: 'tooltip', 'p': { 'html': true } });
        }

        this.dailyDatas.push(dailyDatasFirstRow);

        for (var dayId in this.dailyDatas2) {
            var dayArray = new Array(),
                day = DayData.getById(dayId);
            dayArray.push(day.getDate());

            for (var j = 0; j < this.categorieTable.length; j++) {
                var tooltipValue = null;
                dayArray.push(this.dailyDatas2[dayId][this.categorieTable[j].id]);

                if (this.typeOfData === "percent") {
                    tooltipValue = "<div style='padding:5px;'><b>" + day.getMomentDate().format('L') + "</b><br/>" + gettextCatalog.getString(this.categorieTable[j].label) + " : " + $filter("smartNumber")(this.dailyDatas2[dayId][this.categorieTable[j].id], 2) + "%</div>";
                } else if (this.typeOfData === "currency") {
                    tooltipValue = "<div style='padding:5px;'><b>" + day.getMomentDate().format('L') + "</b><br/>" + gettextCatalog.getString(this.categorieTable[j].label) + " : " + $filter("currencyFormatFilter")(this.dailyDatas2[dayId][this.categorieTable[j].id]) + "</div>";
                } else {
                    tooltipValue = "<div style='padding:5px;'><b>" + day.getMomentDate().format('L') + "</b><br/>" + gettextCatalog.getString(this.categorieTable[j].label) + " : " + $filter("smartNumber")(this.dailyDatas2[dayId][this.categorieTable[j].id], 2) + " </div>";
                }

                dayArray.push(tooltipValue);
            }

            this.dailyDatas.push(dayArray);
        }
    };

    PeriodDatasSource.prototype.getStatByDay = function () {
        return this.dailyDatas;
    };

    PeriodDatasSource.prototype.getStatByMonth = function () {
        return this.monthlyDatas;
    };

    PeriodDatasSource.prototype.getAgregationOfCategory = function (category) {
        var value = this.statByCategory[category.id];
        if (value == null || value == undefined) return null;
        return value * (this.typeOfData == 'percent' ? 100 : 1);
    };

    PeriodDatasSource.prototype.getAgregationOfTotalCategory = function () {
        return !isNaN(this.totalStat) && this.totalStat != null && this.totalStat != undefined ? this.totalStat * (this.typeOfData == 'percent' ? 100 : 1) : null;
    };

    PeriodDatasSource.prototype.getAverageFromDetailLevel = function () {
        var total = 0;
        var nbItems = 0;
        for (var c = 0; c < this.categorieTable.length; c++) {
            total += this.stat1ByCategory[this.categorieTable[c].id];
            nbItems += this.stat2ByCategory[this.categorieTable[c].id];
        }
        return total / nbItems;
    };
    PeriodDatasSource.prototype.getCustomers = function () {
        //TODO RETURN {customer : customer, results : {ca:xxx,nbSales:xx}} instead only customer on period
        //TODO MANAGE no customer (de passage)
        var groupArray = [];
        if (this.primaryDatas && this.primaryDatas.length > 0) {
            var type = PrimaryDatasType.getType(this.primaryDatas[0]);
            if (type == PrimaryDatasType.SALE || type == PrimaryDatasType.BOOKING) angular.forEach(this.primaryDatas, function (item, idx) {
                if (item && item.customer && groupArray.indexOf(item.customer) == -1) {
                    groupArray.push(item.customer);
                }
            });else if (type == PrimaryDatasType.CUSTOMER) angular.forEach(this.primaryDatas, function (item, idx) {
                if (item && groupArray.indexOf(item) == -1) {
                    groupArray.push(item);
                }
            });else if (type == PrimaryDatasType.VISITE) angular.forEach(this.primaryDatas, function (item, idx) {
                if (item && item.customer && groupArray.indexOf(item.customer) == -1) {
                    groupArray.push(item.customer);
                }
            });else if (type == PrimaryDatasType.BOOKINGSERVICE) angular.forEach(this.primaryDatas, function (item, idx) {
                if (item && item.booking && item.booking.customer && groupArray.indexOf(item.booking.customer) == -1) {
                    groupArray.push(item.booking.customer);
                }
            });
            /* else if(type == PrimaryDatasType.HROCCUPATIONDATAS) {
                 angular.forEach(this.primaryDatas, function (item, idx) {
                     angular.forEach(item.subBookings, function (subSaleItem, idx2) {
                         if (subSaleItem && subSaleItem.booking && subSaleItem.booking.customer && groupArray.indexOf(subSaleItem.booking.customer) == -1) {
                             groupArray.push(subSaleItem.booking.customer);
                         }
                     });
                 });
             }*/
            else if (type == PrimaryDatasType.SALESERVICE || type == PrimaryDatasType.SALEPRODUCT || type == PrimaryDatasType.SALECURE || type == PrimaryDatasType.LOYALTYCARDITEM || type == PrimaryDatasType.GIFTITEM) {
                    angular.forEach(this.primaryDatas, function (item, idx) {
                        if (item && item.sale && item.sale.customer && groupArray.indexOf(item.sale.customer) == -1) {
                            groupArray.push(item.sale.customer);
                        }
                    });
                };
        }
        this.customers = groupArray;
    };

    PeriodDatasSource.prototype.hasDataOnCategories = function () {
        var hasDataOnCategories = false;
        for (var cat in this.statByCategory) {
            if (this.statByCategory[cat] && this.statByCategory[cat] != 0) {
                hasDataOnCategories = true;
                break;
            }
        }
        return hasDataOnCategories;
    };

    return PeriodDatasSource;
}]);

/***/ }),

/***/ 520:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by cedricgodefroy on 23/08/2017.
 */
angular.module('FlexyBeautyApp.services').factory('PeriodStat', ["PeriodType", "DayData", "gettextCatalog", "moment", function (PeriodType, DayData, gettextCatalog, moment) {
    var PeriodStat = function PeriodStat(type, beginMomentDay, endMomentDay, periodType) {
        this.type = type;

        this.beginMomentDay = beginMomentDay;
        this.endMomentDay = endMomentDay;

        this.periodType = periodType;

        this.arrayOfDays = null;
        this.loadArrayOfDays();
    };

    PeriodStat.prototype.getArrayOfDays = function () {
        return this.arrayOfDays;
    };

    PeriodStat.prototype.loadArrayOfDays = function () {
        var arrayOfDays = new Array();

        var currentMomentDay = this.beginMomentDay.clone();

        while (this.endMomentDay.diff(currentMomentDay) >= 0) {

            var dayId = currentMomentDay.format("YYYYMMDD"),

            //myDay = DaySrv.getByIdAdder(dayId,true);
            myDay = DayData.getById(dayId);

            if (myDay) {
                arrayOfDays.push(myDay);
            }
            currentMomentDay.add(1, 'day');
        }

        this.arrayOfDays = arrayOfDays;
    };

    PeriodStat.prototype.getLabel = function () {
        var formator = null,
            labelPeriod = null;
        if (this.periodType != PeriodType.CUSTOMED) {
            if (this.periodType === PeriodType.DAY) {
                formator = "dddd L";
            } else if (this.periodType === PeriodType.WEEK) {
                var weekFormat = gettextCatalog.getString("Semaine du");
                formator = "[" + weekFormat + "] L";
            } else if (this.periodType === PeriodType.MONTH) {
                formator = "MMMM YYYY";
            } else if (this.periodType === PeriodType.YEAR) {
                formator = "YYYY";
            }
            labelPeriod = this.beginMomentDay.format(formator);
        } else {
            formator = "DD/MM/YYYY";
            labelPeriod = "Du " + this.beginMomentDay.format(formator) + " au " + this.endMomentDay.format(formator);
        }
        return labelPeriod;
    };

    PeriodStat.prototype.getLabelBegin = function () {
        var formator = formator = "dddd L";

        return this.beginMomentDay.format(formator);
    };

    PeriodStat.prototype.getLabelEnd = function () {
        var formator = "dddd L",
            labelEnd = '';
        if (this.arrayOfDays && this.arrayOfDays.length > 0) {
            labelEnd = this.arrayOfDays[this.arrayOfDays.length - 1].getMomentDate().format(formator);
        } else {
            labelEnd = this.endMomentDay.format(formator);
        }
        return labelEnd;
    };

    PeriodStat.prototype.isSame = function (otherPeriodStat) {
        return this.type === otherPeriodStat.type && this.beginMomentDay.isSame(otherPeriodStat.beginMomentDay) && this.endMomentDay.isSame(otherPeriodStat.endMomentDay) && this.periodType === otherPeriodStat.periodType;
    };

    PeriodStat.getLastYearCorrespondingDay = function (momentDay, timePeriod) {
        var momentLastYear = null;
        if (momentDay) {
            if (timePeriod === PeriodType.DAY || timePeriod === PeriodType.WEEK || timePeriod === PeriodType.CUSTOMED) {
                var year = momentDay.year();
                var weekNumber = momentDay.isoWeek();
                var dayNumber = momentDay.isoWeekday();

                momentLastYear = new moment().year(year - 1).isoWeek(weekNumber).isoWeekday(dayNumber).startOf('day');
            } else if (timePeriod === PeriodType.MONTH || timePeriod === PeriodType.YEAR) {
                momentLastYear = momentDay.subtract(1, 'year').startOf('day');
            }
        }
        return momentLastYear;
    };

    PeriodStat.prototype.getNbDaysDuration = function () {
        return this.endMomentDay.diff(this.beginMomentDay, 'days');
    };

    return PeriodStat;
}]);

/***/ }),

/***/ 521:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by cedricgodefroy on 23/08/2017.
 */
angular.module('FlexyBeautyApp.services').factory('ReportDatasSource', ["PeriodDatasSource", "EltReportType", "ReportTemporalAgregateFunctionType", "DayData", "ColorGraph", "PrimaryDatasType", "moment", "PeriodStat", "PeriodType", "StatPeriodType", "Booking", "TaxMode", "GiftItem", "Customer", "BookingService", "$log", "$filter", "ReportTotalAgregateFunctionType", "gettextCatalog", function (PeriodDatasSource, EltReportType, ReportTemporalAgregateFunctionType, DayData, ColorGraph, PrimaryDatasType, moment, PeriodStat, PeriodType, StatPeriodType, Booking, TaxMode, GiftItem, Customer, BookingService, $log, $filter, ReportTotalAgregateFunctionType, gettextCatalog) {

    var ReportDatasSource = function ReportDatasSource(type, prototypeDailyCalculFunction1, prototypeDailyCalculFunction2, temporalAgregateFunctionType, totalAgregateFunctionType, prototypeDailyListeOfPrimaryDatas, rootCategory, currentCategorieId, currentCategorieType, taxMode, typeOfData, typePeriodDataSource, isZeroValueDisplayed, additionalFilters) {
        this.type = type;

        this.prototypeDailyCalculFunction1 = prototypeDailyCalculFunction1;
        this.prototypeDailyCalculFunction2 = prototypeDailyCalculFunction2;
        this.prototypeDailyListeOfPrimaryDatas = prototypeDailyListeOfPrimaryDatas;
        this.temporalAgregateFunctionType = temporalAgregateFunctionType;
        this.totalAgregateFunctionType = totalAgregateFunctionType;

        this.tabStatPeriod = new Array();

        this.currentPeriod = null;
        this.selectedPastPeriod = null;

        this.eltReportDatasSources = new Array();

        this.categorieTable = null;
        this.currentPath = new Array();

        this.rootCategory = rootCategory;
        this.additionalFilters = additionalFilters;
        this.currentCategory = null;

        this.taxMode = taxMode;
        this.typeOfData = typeOfData;
        this.isZeroValueDisplayed = isZeroValueDisplayed ? isZeroValueDisplayed : false;

        if (!currentCategorieId) {
            currentCategorieId = this.rootCategory.id;
        }
        this.currentCategorieId = currentCategorieId;
        if (!currentCategorieType) {
            currentCategorieType = this.rootCategory.constructor ? this.rootCategory.constructor.name : null;
        }
        this.currentCategorieType = currentCategorieType;

        if (typePeriodDataSource) {
            this.typePeriodDataSource = typePeriodDataSource;
        } else {
            this.typePeriodDataSource = PeriodDatasSource;
        }

        this.initCurrentPath(this.rootCategory, this.currentCategorieId, this.currentCategorieType);

        if (this.currentPath.length === 0) {
            //currenCategory not found; delete?
            this.currentPath.push(this.rootCategory);
        }

        this.setCurrentCategory(this.currentPath[this.currentPath.length - 1]);

        this.initReportDataSource();
    };

    ReportDatasSource.prototype.initCurrentPath = function (currentCategory, targetCategoryId, targetCategoryType) {
        this.currentPath.push(currentCategory);
        if (currentCategory.id === targetCategoryId && (!currentCategory.constructor || !targetCategoryType || currentCategory.constructor && targetCategoryType && currentCategory.constructor.name === targetCategoryType)) {
            return true;
        } else {
            if (currentCategory.getSubStatCategories) {
                var subCategories = currentCategory.getSubStatCategories(this.rootCategory);
                var targetFound = false,
                    i = 0;
                while (!targetFound && i < subCategories.length) {
                    targetFound = this.initCurrentPath(subCategories[i], targetCategoryId, targetCategoryType);
                    i++;
                }
                if (!targetFound) {
                    this.currentPath.pop();
                    return false;
                } else {
                    return true;
                }
            } else {
                this.currentPath.pop();
                return false;
            }
        }
    };

    ReportDatasSource.prototype.initReportDataSource = function () {
        this.eltReportDatasSources[EltReportType.TOTALISE.id] = this.getTotaliseDataSource();
        this.eltReportDatasSources[EltReportType.COMPARE.id] = this.getCompareDataSource();
        this.eltReportDatasSources[EltReportType.ZOOM.id] = this.getZoomDataSource();
    };

    ReportDatasSource.prototype.loadPeriod = function (currentPeriod, pastPeriod, taxMode, additionalFilters) {
        this.currentPeriod = currentPeriod;
        this.selectedPastPeriod = pastPeriod;
        if (taxMode) {
            this.taxMode = taxMode;
        }
        if (additionalFilters) {
            this.additionalFilters = additionalFilters;
        }
        this.loadDatas();
    };

    ReportDatasSource.prototype.isLoaded = function () {
        var isLoaded = false;
        if (this.tabStatPeriod[StatPeriodType.CURRENT.id] && this.tabStatPeriod[StatPeriodType.PAST.id]) {
            isLoaded = true;
        }
        return isLoaded;
    };

    ReportDatasSource.prototype.loadDatas = function () {
        $log.debug(new moment().format("DD/MM/YYYY HH:mm:ss SSS") + " " + this.type + ": BEGIN calcul current period");
        this.tabStatPeriod[StatPeriodType.CURRENT.id] = this.calculStatByPeriod(this.currentPeriod);
        $log.debug(new moment().format("DD/MM/YYYY HH:mm:ss SSS") + " " + this.type + ": END calcul current period/BEGIN calcul old period");
        this.tabStatPeriod[StatPeriodType.PAST.id] = this.calculStatByPeriod(this.selectedPastPeriod);
        $log.debug(new moment().format("DD/MM/YYYY HH:mm:ss SSS") + " " + this.type + ": END calcul old period ");
        $log.debug("");
        this.initReportDataSource();
    };

    ReportDatasSource.prototype.loadPastPeriod = function () {
        this.tabStatPeriod[StatPeriodType.PAST.id] = this.calculStatByPeriod(this.selectedPastPeriod);
        this.initReportDataSource();
    };

    ReportDatasSource.prototype.getPeriod = function (statPeriodType) {
        var period = null;
        if (statPeriodType.id === StatPeriodType.CURRENT.id) {
            period = this.currentPeriod;
        } else if (statPeriodType.id === StatPeriodType.PAST.id) {
            period = this.selectedPastPeriod;
        }
        return period;
    };

    ReportDatasSource.prototype.getPeriodStat = function (statPeriodType) {
        if (statPeriodType) return this.tabStatPeriod[statPeriodType.id];
    };

    ReportDatasSource.prototype.getCurrentPeriodStat = function () {
        return this.tabStatPeriod[StatPeriodType.CURRENT.id];
    };

    ReportDatasSource.prototype.getPastPeriodStat = function () {
        return this.tabStatPeriod[StatPeriodType.PAST.id];
    };

    ReportDatasSource.prototype.calculStatByPeriod = function (period) {
        var periodDataSource = Object.create(this.typePeriodDataSource.prototype);

        // Invoke the custom constructor on the new object,
        // passing in any arguments that were provided.
        this.typePeriodDataSource.apply(periodDataSource, [this.type, period, this.prototypeDailyCalculFunction1, this.prototypeDailyCalculFunction2, this.temporalAgregateFunctionType, this.totalAgregateFunctionType, this.prototypeDailyListeOfPrimaryDatas, this.categorieTable, this.currentPath, this.taxMode, this.typeOfData, this.additionalFilters]);

        return periodDataSource;
    };

    ReportDatasSource.prototype.zeroValueDisplayed = function () {
        return this.isZeroValueDisplayed || this.prototypeDailyCalculFunction2 || this.totalAgregateFunctionType != ReportTotalAgregateFunctionType.SUM_CATEGORIES;
    };

    ReportDatasSource.prototype.getTotaliseDataSource = function () {
        var datasChart = new Array(),
            dynamicTitlePart1 = 0,
            sumCategories = 0,
            averageOfCategories = 0;

        if (this.getCurrentPeriodStat()) {
            //the tooltip column must be declared before the style column
            //because the style column is usefull and understood only by column chart graph
            datasChart.push(['Type', 'Valeur', { type: 'string', role: 'tooltip', 'p': { 'html': true } }, { type: 'string', role: 'style' }]);

            for (var i = 0; i < this.getCurrentPeriodStat().categorieTable.length; i++) {
                var categoryValue = this.getCurrentPeriodStat().getAgregationOfCategory(this.getCurrentPeriodStat().categorieTable[i]),
                    stat1 = this.getCurrentPeriodStat().stat1ByCategory[this.getCurrentPeriodStat().categorieTable[i].id],
                    stat2 = this.prototypeDailyCalculFunction2 ? this.getCurrentPeriodStat().stat2ByCategory[this.getCurrentPeriodStat().categorieTable[i].id] : null,
                    totalCategory = this.getCurrentPeriodStat().getAgregationOfTotalCategory(),
                    tooltipValue = null;

                if (this.typeOfData === "percent" && stat1 && stat2) {
                    tooltipValue = "<div style='padding:5px;'><b>" + gettextCatalog.getString(this.getCurrentPeriodStat().categorieTable[i].label) + "</b> : " + $filter("smartNumber")(categoryValue, 2) + "% (" + $filter("smartNumber")(stat1, 2) + " / " + $filter("smartNumber")(stat2, 2) + ") </div>";
                } else if (this.typeOfData === "percent") {
                    tooltipValue = "<div style='padding:5px;'><b>" + gettextCatalog.getString(this.getCurrentPeriodStat().categorieTable[i].label) + "</b> : " + $filter("smartNumber")(categoryValue, 2) + "%</div>";
                } else if (this.typeOfData === "currency" && this.totalAgregateFunctionType === ReportTotalAgregateFunctionType.SUM_CATEGORIES) {
                    tooltipValue = "<div style='padding:5px;'><b>" + gettextCatalog.getString(this.getCurrentPeriodStat().categorieTable[i].label) + "</b> : " + $filter("currencyFormatFilter")(categoryValue) + " (" + $filter("smartNumber")(categoryValue / totalCategory * 100, 1) + "%) </div>";
                } else if (this.typeOfData === "currency") {
                    tooltipValue = "<div style='padding:5px;'><b>" + gettextCatalog.getString(this.getCurrentPeriodStat().categorieTable[i].label) + "</b> : " + $filter("currencyFormatFilter")(categoryValue) + "</div>";
                } else if (this.typeOfData === "time") {
                    tooltipValue = "<div style='padding:5px;'><b>" + gettextCatalog.getString(this.getCurrentPeriodStat().categorieTable[i].label) + "</b> : " + $filter("shorterMinutesToTimeString")(categoryValue) + " </div>";
                } else if (this.totalAgregateFunctionType === ReportTotalAgregateFunctionType.SUM_CATEGORIES) {
                    tooltipValue = "<div style='padding:5px;'><b>" + gettextCatalog.getString(this.getCurrentPeriodStat().categorieTable[i].label) + "</b> : " + $filter("smartNumber")(categoryValue) + " (" + $filter("smartNumber")(categoryValue / totalCategory * 100, 1) + "%) </div>";
                } else {
                    tooltipValue = "<div style='padding:5px;'><b>" + gettextCatalog.getString(this.getCurrentPeriodStat().categorieTable[i].label) + "</b> : " + $filter("smartNumber")(categoryValue, 2) + " </div>";
                }

                if (this.zeroValueDisplayed() || !this.zeroValueDisplayed() && categoryValue != 0) {
                    //if(categoryValue > 0) {
                    datasChart.push([gettextCatalog.getString(this.getCurrentPeriodStat().categorieTable[i].label), categoryValue, tooltipValue, 'color:' + this.getCurrentPeriodStat().categorieTable[i].color]);
                    sumCategories += categoryValue;
                }
            }
            dynamicTitlePart1 = this.getCurrentPeriodStat().getAgregationOfTotalCategory();
        }

        return {
            dynamicTitlePart1: dynamicTitlePart1,
            datasChart: datasChart
        };
    };

    ReportDatasSource.prototype.getCompareDataSource = function () {
        var datasChart = new Array(),
            firstRow = new Array(),
            lastYearRow = new Array(),
            currentYearRow = new Array(),
            dynamicTitlePart1 = 0,
            dynamicTitlePart2 = 0;

        if (this.getCurrentPeriodStat() && this.getPastPeriodStat()) {
            firstRow.push({ id: 'Type', label: 'Type', type: 'number' });

            for (var i = 0; i < this.getCurrentPeriodStat().categorieTable.length; i++) {
                firstRow.push({
                    id: this.getCurrentPeriodStat().categorieTable[i].label,
                    label: gettextCatalog.getString(this.getCurrentPeriodStat().categorieTable[i].label),
                    type: 'number'
                });
                firstRow.push({ type: 'string', role: 'tooltip', 'p': { 'html': true } });
            }
            datasChart.push(firstRow);

            lastYearRow.push(1);
            for (var i = 0; i < this.getCurrentPeriodStat().categorieTable.length; i++) {
                var categoryValue = this.getPastPeriodStat().getAgregationOfCategory(this.getCurrentPeriodStat().categorieTable[i]);
                lastYearRow.push(categoryValue);
                lastYearRow.push("<div style='padding:5px'><b>" + this.getCurrentPeriodStat().categorieTable[i].label + "</b></br>Valeur : <b>" + (this.typeOfData == "percent" ? $filter('smartNumber')(categoryValue) + "%" : this.typeOfData == "currency" ? $filter('currencyFormatFilter')(categoryValue) : this.typeOfData == "time" ? $filter('shorterMinutesToTimeString')(categoryValue) : this.typeOfData == "number" ? $filter('smartNumber')(categoryValue) : "") + "</b></div>");
            }
            datasChart.push(lastYearRow);

            currentYearRow.push(2);
            for (var i = 0; i < this.getCurrentPeriodStat().categorieTable.length; i++) {
                var categoryValue = this.getCurrentPeriodStat().getAgregationOfCategory(this.getCurrentPeriodStat().categorieTable[i]);
                currentYearRow.push(categoryValue);
                currentYearRow.push("<div style='padding:5px'><b>" + this.getCurrentPeriodStat().categorieTable[i].label + "</b></br>Valeur : <b>" + (this.typeOfData == "percent" ? $filter('smartNumber')(categoryValue) + "%" : this.typeOfData == "currency" ? $filter('currencyFormatFilter')(categoryValue) : this.typeOfData == "time" ? $filter('shorterMinutesToTimeString')(categoryValue) : this.typeOfData == "number" ? $filter('smartNumber')(categoryValue) : "") + "</b></div>");
            }
            datasChart.push(currentYearRow);

            dynamicTitlePart1 = this.getPastPeriodStat().getAgregationOfTotalCategory();
            dynamicTitlePart2 = this.getCurrentPeriodStat().getAgregationOfTotalCategory();
        }

        return {
            dynamicTitlePart1: dynamicTitlePart1,
            dynamicTitlePart2: dynamicTitlePart2,
            datasChart: datasChart
        };
    };

    ReportDatasSource.prototype.getZoomDataSource = function () {
        var datasChart = new Array(),
            dynamicTitlePart1 = null;

        if (this.getCurrentPeriodStat()) {
            if (this.currentPeriod.periodType === PeriodType.YEAR || this.currentPeriod.periodType === PeriodType.CUSTOMED && this.currentPeriod.getNbDaysDuration() > 60) {
                datasChart = this.getCurrentPeriodStat().getStatByMonth();
            } else {
                datasChart = this.getCurrentPeriodStat().getStatByDay();
            }
            dynamicTitlePart1 = this.getCurrentPeriodStat().getAgregationOfTotalCategory();
        }

        return {
            dynamicTitlePart1: datasChart.length > 1 ? dynamicTitlePart1 : 0,
            datasChart: datasChart
        };
    };

    ReportDatasSource.prototype.getCategoryByLabel = function (label) {
        var category = null;
        for (var i = 0; i < this.categorieTable.length; i++) {
            if (label == this.categorieTable[i].label) {
                category = this.categorieTable[i];
                break;
            }
        }
        return category;
    };

    ReportDatasSource.prototype.setCurrentCategory = function (category) {
        this.currentCategory = category;
        this.categorieTable = new Array();
        if (category.getSubStatCategories) {
            var subCategory = this.currentCategory.getSubStatCategories(this.rootCategory);

            this.categorieTable = subCategory;
            for (var i = 0; i < this.categorieTable.length; i++) {
                this.categorieTable[i].color = ColorGraph.colors[i % ColorGraph.colors.length];
            }
        }
    };

    ReportDatasSource.prototype.loadCategory = function (category) {
        this.setCurrentCategory(category);
        this.loadDatas();
    };

    ReportDatasSource.prototype.getParentCategory = function () {
        var parent = null;
        if (this.currentPath.length > 1) {
            parent = this.currentPath[this.currentPath.length - 2];
        }
        return parent;
    };

    ReportDatasSource.prototype.addCategoryToCurrentPath = function (category) {
        this.currentPath.push(category);
        this.currentCategory = this.currentPath[this.currentPath.length - 1];
    };

    ReportDatasSource.prototype.removeLastCategoryToCurrentPath = function () {
        this.currentPath.pop();
        his.currentCategory = this.currentPath[this.currentPath.length - 1];
    };

    ReportDatasSource.prototype.updatePath = function (category) {
        this.currentPath = this.currentPath.slice(0, this.currentPath.indexOf(category) + 1);
        this.currentCategory = this.currentPath[this.currentPath.length - 1];
    };

    ReportDatasSource.prototype.getPrimaryDatasType = function (primaryDataTypePeriodStat) {
        var primaryDatasType = null;
        if (this.tabStatPeriod[primaryDataTypePeriodStat.id] && this.tabStatPeriod[primaryDataTypePeriodStat.id].primaryDatas && this.tabStatPeriod[primaryDataTypePeriodStat.id].primaryDatas.length > 0) {
            primaryDatasType = PrimaryDatasType.getType(this.tabStatPeriod[primaryDataTypePeriodStat.id].primaryDatas[0]);
        }
        return primaryDatasType;
    };

    ReportDatasSource.prototype.getCategoriesOnPeriods = function () {
        var categoriesOnPeriods = this.getCurrentPeriodStat().categorieTable.slice(0);

        for (var i = 0; i < this.getPastPeriodStat().categorieTable.length; i++) {
            if (this.getCurrentPeriodStat().categorieTable.indexOf(this.getPastPeriodStat().categorieTable[i]) == -1) {
                categoriesOnPeriods.push(this.getPastPeriodStat().categorieTable[i]);
            }
        }
        return categoriesOnPeriods;
    };

    return ReportDatasSource;
}]);

/***/ }),

/***/ 522:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by cedricgodefroy on 18/07/2017.
 */
/**
 * Created by cedricgodefroy on 18/07/2017.
 */
angular.module('FlexyBeautyApp.services').factory('ReportView', ['$filter', 'DataSourceFactory', 'ReportModelData', 'StatPeriodType', 'ReportTemporalAgregateFunctionType', 'EltReportType', function ($filter, DataSourceFactory, ReportModelData, StatPeriodType, ReportTemporalAgregateFunctionType, EltReportType) {
    var ReportView = function ReportView(reportModel, userChanges, taxMode, functionSolutionActivated, startModelId) {
        this.id = null;
        this.reportModelId = null;
        this.title = null;
        this.descriptionTitle = null;
        this.descriptionDetail = null;
        this.indexActifEltReport = null;
        this.eltsReport = null;
        this.mouseover = false;
        this.advanced = false;
        this.displayDescription = false;
        this.loading = false;
        this.dataSource = null;
        this.onTemplateOnly = false;
        this.primaryDataTypePeriodStat = StatPeriodType.CURRENT;
        this.businessPage = null;
        this.helpCenterArticlesId = null;

        this.reportModel = reportModel;
        this.userChanges = userChanges;
        this.isSolutionActivated = functionSolutionActivated;
        this.primaryDataDay = null;

        this.INDEX_EVALUATION_TAB = 0;
        this.INDEX_COMPARAISON_TAB = 1;
        this.INDEX_ZOOM_TAB = 2;

        if (this.reportModel) {
            this.loadDataFrom(this.reportModel, startModelId);
        }

        if (userChanges) {
            this.loadUserChanges();
        }

        this.createDataSource();
    };

    ReportView.prototype.setPrimaryDataTypePeriodStat = function (primaryDataTypePeriodStat) {
        this.primaryDataTypePeriodStat = primaryDataTypePeriodStat;
    };

    ReportView.prototype.loadDataFrom = function (reportModel, startModelId) {
        this.id = reportModel.id;
        this.reportModelId = reportModel.id;
        this.title = reportModel.title;
        this.descriptionTitle = reportModel.descriptionTitle;
        this.descriptionDetail = reportModel.descriptionDetail;
        this.indexActifEltReport = reportModel.indexActifEltReport;
        this.eltsReport = reportModel.eltsReport;
        this.advanced = reportModel.advanced;
        this.typeOfData = reportModel.typeOfData;
        this.onTemplateOnly = reportModel.onTemplateOnly;
        this.businessPage = reportModel.businessPage;
        if (reportModel.helpCenterArticles) // load according startModelId (flexymodel1 : coiffeur) or default
            this.helpCenterArticlesId = reportModel.helpCenterArticles[startModelId] ? reportModel.helpCenterArticles[startModelId] : reportModel.helpCenterArticles["default"];
    };

    ReportView.prototype.loadUserChanges = function () {
        if (this.userChanges.title) this.title = this.userChanges.title;
        if (this.userChanges.descriptionTitle) this.descriptionTitle = this.userChanges.descriptionTitle;
        if (this.userChanges.descriptionDetail) this.descriptionDetail = this.userChanges.descriptionDetail;
        if (this.userChanges.indexActifEltReport) this.indexActifEltReport = this.userChanges.indexActifEltReport;
        if (this.userChanges.primaryDataTypePeriodStat) this.primaryDataTypePeriodStat = this.userChanges.primaryDataTypePeriodStat;
    };

    ReportView.prototype.getChanges = function () {
        var changes = {};
        if (this.title !== this.reportModel.title) {
            changes.title = this.title;
        }
        if (this.descriptionTitle !== this.reportModel.descriptionTitle) {
            changes.descriptionTitle = this.descriptionTitle;
        }
        if (this.descriptionDetail !== this.reportModel.descriptionDetail) {
            changes.descriptionDetail = this.descriptionDetail;
        }
        if (this.indexActifEltReport !== this.reportModel.indexActifEltReport) {
            changes.indexActifEltReport = this.indexActifEltReport;
        }
        if (this.getDataSource() && this.getDataSource().currentPath.length > 1) {
            changes.currentCategorieId = this.getDataSource().currentPath[this.getDataSource().currentPath.length - 1].id;
        }
        if (this.getDataSource() && this.getDataSource().currentPath.length > 1) {
            changes.currentCategorieType = this.getDataSource().currentPath[this.getDataSource().currentPath.length - 1].constructor ? this.getDataSource().currentPath[this.getDataSource().currentPath.length - 1].constructor.name : null;
        }
        if (this.primaryDataTypePeriodStat) {
            changes.primaryDataTypePeriodStat = this.primaryDataTypePeriodStat;
        }
        return changes;
    };

    ReportView.prototype.createDataSource = function (taxMode, categorieId, categorieType) {
        var currentCategorieId = this.userChanges ? this.userChanges.currentCategorieId : categorieId,
            currentCategorieType = this.userChanges ? this.userChanges.currentCategorieType : categorieType;

        this.dataSource = DataSourceFactory.getInstance().createDataSource(this.reportModelId, currentCategorieId, currentCategorieType, taxMode, this.typeOfData);
    };

    ReportView.prototype.getDataSource = function () {
        return this.dataSource;
    };

    ReportView.prototype.onTabClick = function (idLabel) {
        if (idLabel === this.INDEX_EVALUATION_TAB || idLabel === this.INDEX_ZOOM_TAB) {
            this.setPrimaryDataTypePeriodStat(StatPeriodType.CURRENT);
        }
        this.indexActifEltReport = idLabel;
    };

    ReportView.prototype.getClone = function () {
        var clone = new ReportView(this.reportModel);
        clone.id = this.id;
        clone.title = this.title;
        clone.descriptionTitle = this.descriptionTitle;
        clone.descriptionDetail = this.descriptionDetail;
        clone.indexActifEltReport = this.indexActifEltReport; //default value
        clone.eltsReport = this.eltsReport;
        clone.advanced = this.advanced;
        clone.businessPage = this.businessPage;
        clone.isSolutionActivated = this.isSolutionActivated;
        clone.helpCenterArticlesId = this.helpCenterArticlesId;
        //clone.dataSource = this.dataSource.clone();

        return clone;
    };

    ReportView.prototype.isChanged = function () {
        if (this.reportModel) {
            return this.title != this.reportModel.title && (!this.userChanges || !this.userChanges.title) || this.userChanges && this.userChanges.title && this.userChanges.title != this.title;
        } else {
            return true;
        }
    };

    ReportView.prototype.isNavigationChanged = function () {
        if (this.reportModel) {
            return this.getDataSource().currentPath.length > 1 && (!this.userChanges || !this.userChanges.currentCategorieId || this.getDataSource().currentCategory.id != this.userChanges.currentCategorieId) || this.getDataSource().currentPath[this.getDataSource().currentPath.length - 1].constructor && this.getDataSource().currentPath.length > 1 && (!this.userChanges || !this.userChanges.currentCategorieType || this.getDataSource().currentCategorieType != this.userChanges.currentCategorieType) || this.indexActifEltReport != this.reportModel.indexActifEltReport && (!this.userChanges || !this.userChanges.indexActifEltReport) || this.userChanges != null && this.userChanges.indexActifEltReport != null && this.userChanges.indexActifEltReport != this.indexActifEltReport;
        } else {
            return true;
        }
    };

    ReportView.prototype.matchFilter = function (textFilter) {
        var matchFilter = true,
            textFilterNormalize = null,
            titleBNormalize = null;

        if (textFilter != null && textFilter != "") {

            if (this.title.normalize()) {
                textFilterNormalize = textFilter.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase();
                titleBNormalize = this.title.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase();
            } else {
                textFilterNormalize = textFilter.toLowerCase();
                titleBNormalize = this.title.toLowerCase();
            }

            if (titleBNormalize.indexOf(textFilterNormalize) === -1) {
                matchFilter = false;
            }
        }
        return matchFilter;
    };

    ReportView.prototype.getPeriodStat = function (periodType) {
        return this.getDataSource().getPeriodStat(periodType);
    };

    ReportView.prototype.getPeriod = function (periodType) {
        return this.getDataSource().getPeriod(periodType);
    };

    ReportView.prototype.getCurrentPeriod = function () {
        return this.getDataSource().getPeriod(StatPeriodType.CURRENT);
    };

    ReportView.prototype.getCurrentPeriodType = function () {
        return this.getDataSource().getPeriod(StatPeriodType.CURRENT).type;
    };

    ReportView.prototype.getPastPeriod = function () {
        return this.getDataSource().getPeriod(StatPeriodType.PAST);
    };

    ReportView.prototype.getDataSourcePath = function () {
        return this.getDataSource().currentPath;
    };

    ReportView.prototype.hasCustomers = function () {
        return this.getDataSource().getPeriodStat(this.primaryDataTypePeriodStat) && this.getDataSource().getPeriodStat(this.primaryDataTypePeriodStat).customers && this.getDataSource().getPeriodStat(this.primaryDataTypePeriodStat).customers.length > 0;
    };

    ReportView.prototype.hasPrimaryDatas = function () {
        return this.getDataSource().getPeriodStat(this.primaryDataTypePeriodStat).primaryDatas && this.getDataSource().getPeriodStat(this.primaryDataTypePeriodStat).primaryDatas.length > 0 || this.getDataSource().getPeriodStat(this.primaryDataTypePeriodStat).nbPassageCustomers && this.getDataSource().getPeriodStat(this.primaryDataTypePeriodStat).nbPassageCustomers > 0;
    };

    ReportView.prototype.categoryHasSubCategoriesOnPeriod = function (category, period) {
        return category.getSubStatCategories && category.getSubStatCategories(this.getDataSource().rootCategory, period ? period.arrayOfDays : null).length > 0;
    };

    ReportView.prototype.hasSubCategoriesOnPeriod = function (period) {
        return this.categoryHasSubCategoriesOnPeriod(this.getDataSource().currentCategory, period);
    };

    ReportView.prototype.getCurrentPeriodSubCategories = function () {
        return this.getDataSource().getCurrentPeriodStat().categorieTable;
    };

    ReportView.prototype.legendEvaluationSubCategoriesFilter = function (category) {
        return this.getDataSource().zeroValueDisplayed() || !this.getDataSource().zeroValueDisplayed() && this.getDataSource().getCurrentPeriodStat().getAgregationOfCategory(category) != 0;
    };

    ReportView.prototype.legendComparaisonSubCategoriesFilter = function (category) {
        return this.getDataSource().zeroValueDisplayed() || !this.getDataSource().zeroValueDisplayed() && (this.getDataSource().getCurrentPeriodStat().getAgregationOfCategory(category) != 0 || this.getDataSource().getPastPeriodStat().getAgregationOfCategory(category) != 0);
    };

    ReportView.prototype.sortCurrentPeriodAgregationOfCategory = function (category) {
        return this.getDataSource().getCurrentPeriodStat().getAgregationOfCategory(category);
    };

    ReportView.prototype.getCurrentPeriodAgregationOfCategory = function (category) {
        return this.getDataSource().getCurrentPeriodStat().getAgregationOfCategory(category);
    };

    ReportView.prototype.getCurrentPeriodAgregationOfAllCategories = function (needAverageFromDetail) {

        var currentPeriodAgregationOfAllCategories = null;
        if (this.getDataSource() && this.getDataSource().getCurrentPeriodStat()) {
            //WARNING! TODO : CHANGER l'id en dur...
            if (this.reportModelId == 'average-cart-by-gender' && needAverageFromDetail) {
                currentPeriodAgregationOfAllCategories = this.getDataSource().getCurrentPeriodStat().getAverageFromDetailLevel();
            } else {
                currentPeriodAgregationOfAllCategories = this.getDataSource().getCurrentPeriodStat().getAgregationOfTotalCategory();
            }
        }
        return currentPeriodAgregationOfAllCategories;
    };

    ReportView.prototype.getPastPeriodAgregationOfCategory = function (category) {
        return this.getDataSource().getPastPeriodStat().getAgregationOfCategory(category);
    };

    ReportView.prototype.getPastPeriodAgregationOfAllCategories = function () {
        return this.getDataSource().getPastPeriodStat().getAgregationOfTotalCategory();
    };

    ReportView.prototype.getPeriodTypeOfCurrentPeriod = function () {
        return this.getDataSource().currentPeriod.periodType;
    };

    ReportView.prototype.getLabelOfCurrentPeriod = function () {
        return this.getDataSource().currentPeriod.getLabel();
    };

    ReportView.prototype.getBeginLabelOfCurrentPeriod = function () {
        return this.getDataSource().currentPeriod.getLabelBegin();
    };

    ReportView.prototype.getEndLabelOfCurrentPeriod = function () {
        return this.getDataSource().currentPeriod.getLabelEnd();
    };

    ReportView.prototype.getLabelOfPastPeriod = function () {
        return this.getDataSource().selectedPastPeriod.getLabel();
    };

    ReportView.prototype.getBeginLabelOfPastPeriod = function () {
        return this.getDataSource().selectedPastPeriod.getLabelBegin();
    };

    ReportView.prototype.getEndLabelOfPastPeriod = function () {
        return this.getDataSource().selectedPastPeriod.getLabelEnd();
    };

    ReportView.prototype.getCategoriesOnPeriods = function () {
        return this.getDataSource().getCategoriesOnPeriods();
    };

    ReportView.prototype.sortCategories = function (cat1, cat2) {
        return this.getDataSource().getCurrentPeriodStat().getAgregationOfCategory(cat1) < this.getDataSource().getCurrentPeriodStat().getAgregationOfCategory(cat2);;
    };

    ReportView.prototype.onCategoryUpClick = function (category) {
        this.getDataSource().updatePath(category);
        this.getDataSource().loadCategory(category);
    };

    ReportView.prototype.eltReportViewHasDatas = function (eltReportView) {
        var hasDatas = false;
        if (this.getCurrentPeriodAgregationOfAllCategories() && this.getCurrentPeriodAgregationOfAllCategories() != 0 || EltReportType.getEltReportTypeById(eltReportView.type) === EltReportType.COMPARE && this.getPastPeriodAgregationOfAllCategories() && this.getPastPeriodAgregationOfAllCategories() != 0) {
            hasDatas = true;
        } else {
            if (this.getDataSource().getCurrentPeriodStat() && this.getDataSource().getCurrentPeriodStat().hasDataOnCategories() || EltReportType.getEltReportTypeById(eltReportView.type) === EltReportType.COMPARE && this.getDataSource().getPastPeriodStat().hasDataOnCategories()) {
                hasDatas = true;
            }
        }
        return hasDatas;
    };

    ReportView.prototype.setPrimaryDataDay = function (primaryDataDay) {
        this.primaryDataDay = primaryDataDay;
    };

    ReportView.prototype.filterDay = function (primaryData) {
        var matchDay = true,
            dayItem = null;

        if (this.primaryDataDay) {
            if (primaryData.day && primaryData.day.id) dayItem = primaryData.day.id;else if (primaryData.sale && primaryData.sale.day.id) dayItem = primaryData.sale.day.id;else if (primaryData.booking && primaryData.booking.day.id) dayItem = primaryData.booking.day.id;
            if (dayItem) matchDay = dayItem == this.primaryDataDay.id;
        }
        return matchDay;
    };

    return ReportView;
}]);

/***/ }),

/***/ 523:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by cedricgodefroy on 23/08/2017.
 */
angular.module('FlexyBeautyApp.services').factory('SimpleReportDataSource', [function () {

    var SimpleReportDataSource = function SimpleReportDataSource() {
        var dataSource = null;
        this.currentPeriod = null;
        this.dateDisplayed = null;
        this.primaryDatasByCategory = new Array();

        this.initReportDataSource();
    };

    SimpleReportDataSource.prototype.initReportDataSource = function () {};

    SimpleReportDataSource.prototype.loadDataSource = function (dataSource, currentPeriod, dateDisplayed) {
        this.dataSource = dataSource;
        this.currentPeriod = currentPeriod;
        this.dateDisplayed = dateDisplayed;
    };

    return SimpleReportDataSource;
}]);

/***/ }),

/***/ 804:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(511);
__webpack_require__(508);
__webpack_require__(504);
__webpack_require__(514);
__webpack_require__(507);
__webpack_require__(512);
__webpack_require__(513);
__webpack_require__(505);
__webpack_require__(506);
__webpack_require__(509);
__webpack_require__(510);
__webpack_require__(522);
__webpack_require__(516);
__webpack_require__(517);
__webpack_require__(521);
__webpack_require__(523);
__webpack_require__(519);
__webpack_require__(518);
__webpack_require__(520);
__webpack_require__(166);
__webpack_require__(338);
__webpack_require__(352);
module.exports = __webpack_require__(515);


/***/ })

},[804]);


// WEBPACK FOOTER //
// stats.bundle.min.12e29a636df17ea134ec.js